/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React from "react";

export const SearchIcon = (props) => {
  return (
    // <svg width="32" height="32" className={'svgButtonEffect'} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //     <g clipPath="url(#clip0)">
    //         <rect width="24" height="24" rx="4" fill="url(#paint0_linear)" />
    //         <rect width="24" height="24" rx="4" fill="url(#paint1_linear)" />
    //         <g filter="url(#filter0_d)">
    //             <path d="M11.5156 15.0311C13.4572 15.0311 15.0311 13.4572 15.0311 11.5156C15.0311 9.57398 13.4572 8 11.5156 8C9.57398 8 8 9.57398 8 11.5156C8 13.4572 9.57398 15.0311 11.5156 15.0311Z" stroke="#525252" strokeLinecap="round" strokeLinejoin="round" />
    //             <path d="M15.9099 15.9099L13.9983 13.9983" stroke="#525252" strokeLinecap="round" strokeLinejoin="round" />
    //         </g>
    //     </g>
    //     <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" stroke="#C7C7C7" strokeOpacity="0.5" />
    //     <defs>
    //         <filter id="filter0_d" x="-2" y="-2" width="30" height="30" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    //             <feFlood floodOpacity="0" result="BackgroundImageFix" />
    //             <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
    //             <feOffset dx="1" dy="1" />
    //             <feGaussianBlur stdDeviation="1.5" />
    //             <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
    //             <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
    //             <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
    //         </filter>
    //         <linearGradient id="paint0_linear" x1="11.5385" y1="0" x2="11.5385" y2="24" gradientUnits="userSpaceOnUse">
    //             <stop stopColor="white" stopOpacity="0" />
    //             <stop offset="1" stopColor="#F1F1F1" />
    //         </linearGradient>
    //         <linearGradient id="paint1_linear" x1="12" y1="0" x2="12" y2="24" gradientUnits="userSpaceOnUse">
    //             <stop stopColor="white" />
    //             <stop offset="1" stopColor="#ECECEC" stopOpacity="0" />
    //         </linearGradient>
    //         <clipPath id="clip0">
    //             <rect width="24" height="24" rx="4" fill="white" />
    //         </clipPath>
    //     </defs>
    // </svg>
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.51999 7.20992C3.52001 5.44967 4.76348 3.93458 6.48991 3.59124C8.21637 3.24789 9.94495 4.17195 10.6184 5.79826C11.292 7.42458 10.7228 9.30016 9.25912 10.278C7.79544 11.2557 5.84483 11.0634 4.60031 9.81856C3.90857 9.12666 3.51998 8.18829 3.51999 7.20992Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8986 10.8989L12.48 12.4803"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ClearIcon = (props) => {
  return (
    // <svg width="32" height="32" className={'svgButtonEffect'} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //     <g clipPath="url(#clip0)">
    //         <rect width="24" height="24" rx="4" fill="url(#paint0_linear)" />
    //         <rect width="24" height="24" rx="4" fill="url(#paint1_linear)" />
    //         <g filter="url(#filter0_d)">
    //             <path fillRule="evenodd" clipRule="evenodd" d="M11.9999 12.707L15.2464 15.9535L15.9535 15.2464L12.707 11.9999L15.9535 8.75349L15.2464 8.04639L11.9999 11.2928L8.75349 8.04639L8.04639 8.75349L11.2928 11.9999L8.04639 15.2464L8.75349 15.9535L11.9999 12.707Z" fill="#525252" />
    //         </g>
    //     </g>
    //     <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" stroke="#C7C7C7" strokeOpacity="0.5" />
    //     <defs>
    //         <filter id="filter0_d" x="-2" y="-2" width="30" height="30" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    //             <feFlood floodOpacity="0" result="BackgroundImageFix" />
    //             <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
    //             <feOffset dx="1" dy="1" />
    //             <feGaussianBlur stdDeviation="1.5" />
    //             <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
    //             <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
    //             <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
    //         </filter>
    //         <linearGradient id="paint0_linear" x1="11.5385" y1="0" x2="11.5385" y2="24" gradientUnits="userSpaceOnUse">
    //             <stop stopColor="white" stopOpacity="0" />
    //             <stop offset="1" stopColor="#F1F1F1" />
    //         </linearGradient>
    //         <linearGradient id="paint1_linear" x1="12" y1="0" x2="12" y2="24" gradientUnits="userSpaceOnUse">
    //             <stop stopColor="white" />
    //             <stop offset="1" stopColor="#ECECEC" stopOpacity="0" />
    //         </linearGradient>
    //         <clipPath id="clip0">
    //             <rect width="24" height="24" rx="4" fill="white" />
    //         </clipPath>
    //     </defs>
    // </svg>
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5394 10.8606C11.7269 11.0481 11.7269 11.3519 11.5394 11.5394C11.352 11.7269 11.048 11.7269 10.8606 11.5394L11.5394 10.8606ZM7.6606 8.3394C7.47315 8.15194 7.47315 7.84807 7.6606 7.66061C7.84806 7.47316 8.15193 7.47316 8.33939 7.66061L7.6606 8.3394ZM8.33939 7.66061C8.52684 7.84807 8.52684 8.15194 8.33939 8.3394C8.15193 8.52685 7.84806 8.52685 7.6606 8.3394L8.33939 7.66061ZM4.4606 5.13942C4.27315 4.95197 4.27315 4.64804 4.4606 4.46059C4.64806 4.27314 4.95193 4.27314 5.13939 4.46059L4.4606 5.13942ZM7.6606 7.66061C7.84806 7.47316 8.15193 7.47316 8.33939 7.66061C8.52684 7.84807 8.52684 8.15194 8.33939 8.3394L7.6606 7.66061ZM5.13939 11.5394C4.95193 11.7269 4.64806 11.7269 4.4606 11.5394C4.27315 11.3519 4.27315 11.0481 4.4606 10.8606L5.13939 11.5394ZM8.33939 8.3394C8.15193 8.52685 7.84806 8.52685 7.6606 8.3394C7.47315 8.15194 7.47315 7.84807 7.6606 7.66061L8.33939 8.3394ZM10.8606 4.46059C11.048 4.27314 11.352 4.27314 11.5394 4.46059C11.7269 4.64804 11.7269 4.95197 11.5394 5.13942L10.8606 4.46059ZM10.8606 11.5394L7.6606 8.3394L8.33939 7.66061L11.5394 10.8606L10.8606 11.5394ZM7.6606 8.3394L4.4606 5.13942L5.13939 4.46059L8.33939 7.66061L7.6606 8.3394ZM8.33939 8.3394L5.13939 11.5394L4.4606 10.8606L7.6606 7.66061L8.33939 8.3394ZM7.6606 7.66061L10.8606 4.46059L11.5394 5.13942L8.33939 8.3394L7.6606 7.66061Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const RefreshIcon = (props) => {
  return (
    // <svg width="32" height="32" className={'svgButtonEffect'} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //     <g clipPath="url(#clip0)">
    //         <rect width="24" height="24" rx="4" fill="url(#paint0_linear)" />
    //         <rect width="24" height="24" rx="4" fill="url(#paint1_linear)" />
    //         <g filter="url(#filter0_d)">
    //             <path d="M15.2417 11.95H15.9C15.9013 12.7995 15.6283 13.6268 15.1216 14.3086C14.6149 14.9905 13.9015 15.4905 13.0877 15.7342C12.2739 15.9779 11.4032 15.9524 10.6051 15.6613C9.80698 15.3703 9.12419 14.8293 8.65834 14.1189V15.0222H8V12.8278H10.1944V13.4861H9.04528C9.38779 14.1364 9.93834 14.6532 10.609 14.9539C11.2797 15.2546 12.0317 15.3219 12.7451 15.1451C13.4585 14.9682 14.0921 14.5574 14.5446 13.9782C14.9972 13.3991 15.2426 12.685 15.2417 11.95ZM15.2417 8.87778V9.78109C14.7758 9.0707 14.093 8.52972 13.2949 8.23867C12.4968 7.94763 11.6261 7.92207 10.8122 8.16581C9.99845 8.40955 9.2851 8.90955 8.77839 9.59139C8.27167 10.2732 7.99866 11.1005 8 11.95H8.65834C8.65743 11.215 8.90283 10.5009 9.35537 9.92175C9.8079 9.34259 10.4415 8.93178 11.1549 8.75493C11.8683 8.57807 12.6203 8.64538 13.291 8.94609C13.9617 9.2468 14.5122 9.76358 14.8547 10.4139H13.7056V11.0722H15.9V8.87778H15.2417Z" fill="#525252" />
    //         </g>
    //     </g>
    //     <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" stroke="#C7C7C7" strokeOpacity="0.5" />
    //     <defs>
    //         <filter id="filter0_d" x="-2" y="-2" width="30" height="30" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    //             <feFlood floodOpacity="0" result="BackgroundImageFix" />
    //             <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
    //             <feOffset dx="1" dy="1" />
    //             <feGaussianBlur stdDeviation="1.5" />
    //             <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
    //             <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
    //             <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
    //         </filter>
    //         <linearGradient id="paint0_linear" x1="11.5385" y1="0" x2="11.5385" y2="24" gradientUnits="userSpaceOnUse">
    //             <stop stopColor="white" stopOpacity="0" />
    //             <stop offset="1" stopColor="#F1F1F1" />
    //         </linearGradient>
    //         <linearGradient id="paint1_linear" x1="12" y1="0" x2="12" y2="24" gradientUnits="userSpaceOnUse">
    //             <stop stopColor="white" />
    //             <stop offset="1" stopColor="#ECECEC" stopOpacity="0" />
    //         </linearGradient>
    //         <clipPath id="clip0">
    //             <rect width="24" height="24" rx="4" fill="white" />
    //         </clipPath>
    //     </defs>
    // </svg>
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.92788 6.96313L2.87988 9.01113L0.831879 6.96313"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6608 4.33285C10.9495 3.60542 10.0377 3.10638 9.04161 2.89941C8.04551 2.69244 7.01031 2.78694 6.06813 3.17081C5.12596 3.55469 4.31952 4.21055 3.75168 5.05472C3.18385 5.89889 2.88039 6.89299 2.88 7.91034V9.01767"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0719 8.9344L13.1199 6.88L15.1679 8.9344"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.33939 11.5713C5.05066 12.2987 5.96251 12.7976 6.9586 13.0045C7.9547 13.2115 8.9899 13.1172 9.93204 12.7333C10.8743 12.3494 11.6807 11.6936 12.2485 10.8493C12.8163 10.0052 13.1198 9.01094 13.1202 7.9936V6.8864"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DeleteIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      className={"svgButtonEffect"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <rect width="24" height="24" rx="4" fill="url(#paint0_linear)" />
        <rect width="24" height="24" rx="4" fill="url(#paint1_linear)" />
        <g filter="url(#filter0_d)">
          <path
            d="M11.0088 8V8.87778H9V9.28291H9.77805L10.0427 15.9H14.618L14.8828 9.28291H15.7859V8.87778H13.659V8H11.0088ZM13.2538 8.87778H11.4139V8.40513H13.2538V8.87778Z"
            fill="#525252"
          />
        </g>
      </g>
      <rect
        x="0.5"
        y="0.5"
        width="23"
        height="23"
        rx="3.5"
        stroke="#C7C7C7"
        strokeOpacity="0.5"
      />
      <defs>
        <filter
          id="filter0_d"
          x="-2"
          y="-2"
          width="30"
          height="30"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear"
          x1="11.5385"
          y1="0"
          x2="11.5385"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#F1F1F1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="12"
          y1="0"
          x2="12"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#ECECEC" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0">
          <rect width="24" height="24" rx="4" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const EditIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      className={"svgButtonEffect"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <rect width="24" height="24" rx="4" fill="url(#paint0_linear)" />
        <rect width="24" height="24" rx="4" fill="url(#paint1_linear)" />
        <g filter="url(#filter0_d)">
          <path
            d="M13.6019 8.8045C13.7 8.70641 13.8164 8.62861 13.9446 8.57552C14.0727 8.52244 14.2101 8.49512 14.3488 8.49512C14.4875 8.49512 14.6249 8.52244 14.753 8.57552C14.8812 8.62861 14.9976 8.70641 15.0957 8.8045C15.1938 8.90259 15.2716 9.01903 15.3247 9.14719C15.3778 9.27535 15.4051 9.4127 15.4051 9.55142C15.4051 9.69013 15.3778 9.82749 15.3247 9.95565C15.2716 10.0838 15.1938 10.2002 15.0957 10.2983L10.054 15.34L8 15.9002L8.56019 13.8462L13.6019 8.8045Z"
            fill="#525252"
          />
          <rect
            x="14.4119"
            y="8"
            width="2.12715"
            height="1.54227"
            transform="rotate(45.2034 14.4119 8)"
            fill="#525252"
          />
          <rect
            x="13.5876"
            y="8.81787"
            width="2.12745"
            height="0.380989"
            transform="rotate(45.2034 13.5876 8.81787)"
            fill="#F3F3F3"
          />
        </g>
      </g>
      <rect
        x="0.5"
        y="0.5"
        width="23"
        height="23"
        rx="3.5"
        stroke="#C7C7C7"
        strokeOpacity="0.5"
      />
      <defs>
        <filter
          id="filter0_d"
          x="-2"
          y="-2"
          width="30"
          height="30"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear"
          x1="11.5385"
          y1="0"
          x2="11.5385"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#F1F1F1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="12"
          y1="0"
          x2="12"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#ECECEC" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0">
          <rect width="24" height="24" rx="4" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ViewIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      className={"svgButtonEffect"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <rect width="24" height="24" rx="4" fill="url(#paint0_linear)" />
        <rect width="24" height="24" rx="4" fill="url(#paint1_linear)" />
        <g filter="url(#filter0_d)">
          <path
            d="M11.955 10C10.4458 10 9.06827 10.8248 8.05923 12.176C7.98026 12.2901 7.98026 12.4392 8.05923 12.5533C9.06827 13.8958 10.4458 14.7206 11.955 14.7206C13.4642 14.7206 14.8417 13.8958 15.8508 12.5445C15.9297 12.4305 15.9297 12.2813 15.8508 12.1672C14.8417 10.8248 13.4642 10 11.955 10ZM12.0603 14.0186C11.06 14.08 10.2265 13.2553 10.2879 12.2462C10.3405 11.4214 11.0162 10.7458 11.8409 10.6932C12.8412 10.6317 13.6748 11.4565 13.6133 12.4656C13.5607 13.2991 12.8938 13.966 12.0603 14.0186ZM12.0164 13.2553C11.4724 13.2903 11.0337 12.8429 11.06 12.2989C11.0863 11.8514 11.4461 11.4916 11.8936 11.4653C12.4376 11.4302 12.8763 11.8777 12.85 12.4217C12.8237 12.8604 12.4551 13.2289 12.0164 13.2553Z"
            fill="#525252"
          />
        </g>
      </g>
      <rect
        x="0.5"
        y="0.5"
        width="23"
        height="23"
        rx="3.5"
        stroke="#C7C7C7"
        strokeOpacity="0.5"
      />
      <defs>
        <filter
          id="filter0_d"
          x="-2"
          y="-2"
          width="30"
          height="30"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear"
          x1="11.5385"
          y1="0"
          x2="11.5385"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#F1F1F1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="12"
          y1="0"
          x2="12"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#ECECEC" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0">
          <rect width="24" height="24" rx="4" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PublishIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      className={"svgButtonEffect"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <rect width="24" height="24" rx="4" fill="url(#paint0_linear)" />
        <rect width="24" height="24" rx="4" fill="url(#paint1_linear)" />
        <g filter="url(#filter0_d)">
          <path
            d="M12.0265 10.6119C11.0096 11.5373 9.93558 12.4872 9 13.3269C9.71172 13.3228 10.4224 13.3236 11.1341 13.3269C11.1341 14.9585 11.1341 14.2684 11.1341 15.9C11.7375 15.9 12.3807 15.9 12.9051 15.9C12.9051 14.2696 12.9051 14.9608 12.9051 13.3304C13.6168 13.3293 14.3275 13.3293 15.0393 13.3373C14.0036 12.407 12.9478 11.443 12.0265 10.6119ZM9.14182 8C9.14182 8.49129 9.14182 8.8656 9.14182 9.33493C11.2003 9.33493 13.0855 9.33493 14.8974 9.33493C14.8974 8.84363 14.8974 8.46933 14.8974 8C12.9091 8 10.8506 8 9.14182 8Z"
            fill="#525252"
          />
        </g>
      </g>
      <rect
        x="0.5"
        y="0.5"
        width="23"
        height="23"
        rx="3.5"
        stroke="#C7C7C7"
        strokeOpacity="0.5"
      />
      <defs>
        <filter
          id="filter0_d"
          x="-2"
          y="-2"
          width="30"
          height="30"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear"
          x1="11.5385"
          y1="0"
          x2="11.5385"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#F1F1F1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="12"
          y1="0"
          x2="12"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#ECECEC" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0">
          <rect width="24" height="24" rx="4" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ModifyIcon = (props) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      className={"svgButtonEffect"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.0844727"
        y="0.344238"
        width="40"
        height="40"
        rx="4"
        fill="url(#paint0_linear_974_3241)"
      />
      <rect
        x="0.0844727"
        y="0.344238"
        width="40"
        height="40"
        rx="4"
        fill="url(#paint1_linear_974_3241)"
      />
      <rect
        x="0.584473"
        y="0.844238"
        width="39"
        height="39"
        rx="3.5"
        stroke="#C7C7C7"
        strokeOpacity="0.5"
      />
      <path
        d="M19.1593 13.4185H13.0528C12.5901 13.4185 12.1463 13.6023 11.8191 13.9295C11.4919 14.2567 11.3081 14.7004 11.3081 15.1632V27.3761C11.3081 27.8388 11.4919 28.2826 11.8191 28.6098C12.1463 28.937 12.5901 29.1208 13.0528 29.1208H25.2658C25.7285 29.1208 26.1723 28.937 26.4995 28.6098C26.8267 28.2826 27.0105 27.8388 27.0105 27.3761V21.2696"
        stroke="#525252"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.7017 12.1099C26.0488 11.7628 26.5194 11.5679 27.0102 11.5679C27.501 11.5679 27.9717 11.7628 28.3188 12.1099C28.6658 12.4569 28.8608 12.9276 28.8608 13.4184C28.8608 13.9092 28.6658 14.3799 28.3188 14.7269L20.0314 23.0143L16.542 23.8867L17.4143 20.3972L25.7017 12.1099Z"
        stroke="#525252"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_974_3241"
          x1="19.3152"
          y1="0.344238"
          x2="19.3152"
          y2="40.3442"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#F1F1F1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_974_3241"
          x1="20.0845"
          y1="0.344238"
          x2="20.0845"
          y2="40.3442"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#ECECEC" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const ResendEmailIcon = (props) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 39 39"
      className={"svgButtonEffect"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="4" fill="url(#paint0_linear_974_3217)" />
      <rect width="40" height="40" rx="4" fill="url(#paint1_linear_974_3217)" />
      <rect
        width="39"
        height="39"
        rx="3.5"
        stroke="#C7C7C7"
        strokeOpacity="0.5"
      />
      <path
        d="M21.4072 20.8279V23.7383H24.3176"
        stroke="#525252"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.0788 28.589V25.6786H29.1685"
        stroke="#525252"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.8611 23.2535C30.6151 22.5583 30.197 21.9367 29.6458 21.4468C29.0946 20.9569 28.4283 20.6146 27.709 20.4519C26.9898 20.2891 26.241 20.3112 25.5326 20.5161C24.8242 20.7211 24.1792 21.1021 23.6579 21.6237L21.4072 23.7385M32.0786 25.6788L29.8279 27.7937C29.3066 28.3153 28.6617 28.6963 27.9533 28.9012C27.2448 29.1061 26.4961 29.1282 25.7768 28.9655C25.0576 28.8027 24.3912 28.4604 23.84 27.9705C23.2889 27.4806 22.8707 26.8591 22.6247 26.1639"
        stroke="#525252"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.743 14.6377L20.3585 19.1068L13.9741 14.6377"
        stroke="#525252"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1084 14.3442C11.1084 13.6585 11.6726 13.0942 12.3584 13.0942H28.3584C29.0442 13.0942 29.6084 13.6585 29.6084 14.3442V15.3995C30.1388 15.6383 30.641 15.9289 31.1084 16.2647V14.3442C31.1084 12.83 29.8726 11.5942 28.3584 11.5942H12.3584C10.8442 11.5942 9.6084 12.83 9.6084 14.3442V26.3442C9.6084 27.8585 10.8442 29.0942 12.3584 29.0942H19.5564C19.1479 28.6352 18.7874 28.1326 18.4827 27.5942H12.3584C11.6726 27.5942 11.1084 27.03 11.1084 26.3442V14.3442Z"
        fill="#525252"
      />
      <defs>
        <linearGradient
          id="paint0_linear_974_3217"
          x1="20.074"
          y1="0.344238"
          x2="20.074"
          y2="40.3442"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#F1F1F1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_974_3217"
          x1="20.8433"
          y1="0.344238"
          x2="20.8433"
          y2="40.3442"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#ECECEC" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const AcceptIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      className={"svgButtonEffect"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <rect width="24" height="24" rx="4" fill="url(#paint0_linear)" />
        <rect width="24" height="24" rx="4" fill="url(#paint1_linear)" />
        <g filter="url(#filter0_d)">
          <circle cx="12" cy="12" r="5" fill="#525252" />
          <path
            d="M14 11L10.5625 14L9 12.6364"
            stroke="white"
            strokeLinecap="square"
          />
        </g>
      </g>
      <rect
        x="0.5"
        y="0.5"
        width="23"
        height="23"
        rx="3.5"
        stroke="#C7C7C7"
        strokeOpacity="0.5"
      />
      <defs>
        <filter
          id="filter0_d"
          x="-2"
          y="-2"
          width="30"
          height="30"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear"
          x1="11.5385"
          y1="0"
          x2="11.5385"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#F1F1F1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="12"
          y1="0"
          x2="12"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#ECECEC" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0">
          <rect width="24" height="24" rx="4" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ActivateIcon = (props) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      className={"svgButtonEffect"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="4" fill="url(#paint0_linear_974_3273)" />
      <rect width="40" height="40" rx="4" fill="url(#paint1_linear_974_3273)" />
      <rect
        width="39"
        height="39"
        rx="3.5"
        stroke="#C7C7C7"
        strokeOpacity="0.5"
      />
      <path
        d="M21.7672 26.8998H18.2041C17.8792 26.8998 17.6174 26.636 17.6174 26.3131V25.9006C17.6212 25.5461 17.6038 25.2972 17.5665 25.1582C17.3664 24.4254 16.8369 23.8109 16.3242 23.2152C16.1549 23.0202 15.9954 22.8343 15.8487 22.647C15.1107 21.7083 14.7183 20.5837 14.7183 19.3909C14.7183 16.4789 17.0885 14.1106 20.0005 14.1106C22.9118 14.1106 25.2814 16.4789 25.2814 19.3909C25.2814 20.5843 24.8908 21.7103 24.1509 22.6483C24.0216 22.8143 23.8724 22.988 23.7167 23.1714C23.1917 23.7891 22.6055 24.4781 22.4035 25.2058C22.3681 25.3358 22.3508 25.5693 22.3533 25.8961V26.3118C22.3533 26.636 22.0915 26.8998 21.7672 26.8998ZM18.7922 25.725H21.1804C21.1869 25.2682 21.2313 25.043 21.2718 24.8963C21.5439 23.9164 22.2182 23.1206 22.8133 22.4219C22.9697 22.2378 23.1067 22.077 23.2283 21.9239C23.8029 21.193 24.1072 20.3186 24.1072 19.3915C24.1072 17.1268 22.2658 15.2841 20.0011 15.2841C17.7364 15.2841 15.8937 17.1268 15.8937 19.3915C15.8937 20.3167 16.1974 21.1917 16.7726 21.9226C16.9083 22.0963 17.057 22.2668 17.2146 22.4489C17.757 23.0788 18.4293 23.8592 18.7008 24.8506C18.7407 25.0057 18.787 25.2418 18.7922 25.725Z"
        fill="#525252"
        stroke="#525252"
        strokeWidth="0.3"
      />
      <path
        d="M20.8769 29.683H19.0954C18.7705 29.683 18.5073 29.4199 18.5073 29.0962C18.5073 28.772 18.7705 28.5082 19.0954 28.5082H20.8769C21.1999 28.5082 21.4637 28.772 21.4637 29.0962C21.4637 29.4199 21.1999 29.683 20.8769 29.683Z"
        fill="#525252"
        stroke="#525252"
        strokeWidth="0.3"
      />
      <path
        d="M30.1597 19.9785H27.8127C27.4884 19.9785 27.2246 19.7167 27.2246 19.3918C27.2246 19.0675 27.4884 18.805 27.8127 18.805H30.1597C30.484 18.805 30.7459 19.0675 30.7459 19.3918C30.7459 19.7167 30.484 19.9785 30.1597 19.9785Z"
        fill="#525252"
        stroke="#525252"
        strokeWidth="0.3"
      />
      <path
        d="M12.1877 19.9787H9.84003C9.51576 19.9787 9.25391 19.7169 9.25391 19.3919C9.25391 19.0677 9.51576 18.8052 9.84003 18.8052H12.1871C12.5114 18.8052 12.7752 19.0677 12.7752 19.3919C12.7758 19.7169 12.512 19.9787 12.1877 19.9787Z"
        fill="#525252"
        stroke="#525252"
        strokeWidth="0.3"
      />
      <path
        d="M20.0002 12.165C19.6753 12.165 19.4121 11.9031 19.4121 11.5782V9.22983C19.4121 8.90621 19.6753 8.64307 20.0002 8.64307C20.3251 8.64307 20.5869 8.90621 20.5869 9.22983V11.5776C20.5869 11.9025 20.3251 12.165 20.0002 12.165Z"
        fill="#525252"
        stroke="#525252"
        strokeWidth="0.3"
      />
      <path
        d="M27.282 27.3157C27.1328 27.3157 26.9829 27.2585 26.8677 27.1433L25.2084 25.4834C24.9794 25.255 24.9794 24.8825 25.2084 24.6528C25.4381 24.4237 25.8093 24.425 26.0384 24.6541L27.6977 26.3133C27.9274 26.543 27.9274 26.9156 27.6977 27.1446C27.5831 27.2598 27.4339 27.3157 27.282 27.3157Z"
        fill="#525252"
        stroke="#525252"
        strokeWidth="0.3"
      />
      <path
        d="M14.5286 14.3023C14.3793 14.3023 14.2288 14.245 14.113 14.1299L12.455 12.4712C12.2253 12.2415 12.2253 11.869 12.455 11.6393C12.6847 11.4103 13.0559 11.4103 13.2849 11.6393L14.9442 13.2986C15.1739 13.5277 15.1739 13.9008 14.9442 14.1299C14.8297 14.245 14.6798 14.3023 14.5286 14.3023Z"
        fill="#525252"
        stroke="#525252"
        strokeWidth="0.3"
      />
      <path
        d="M12.4715 27.0829C12.3216 27.0829 12.1717 27.027 12.0565 26.9118C11.8269 26.6827 11.8269 26.3102 12.0565 26.0805L13.7171 24.42C13.9449 24.1909 14.3161 24.1909 14.5458 24.42C14.7755 24.6496 14.7755 25.0222 14.5458 25.2519L12.8865 26.9118C12.7713 27.0263 12.6221 27.0829 12.4715 27.0829Z"
        fill="#525252"
        stroke="#525252"
        strokeWidth="0.3"
      />
      <path
        d="M25.6231 14.535C25.4732 14.535 25.3232 14.4777 25.2074 14.3626C24.9797 14.1335 24.9797 13.7616 25.2074 13.5326L26.8667 11.8733C27.0945 11.6443 27.4683 11.643 27.6967 11.872C27.9264 12.1017 27.9264 12.4729 27.6967 12.7026L26.0387 14.3613C25.9242 14.4764 25.7743 14.535 25.6231 14.535Z"
        fill="#525252"
        stroke="#525252"
        strokeWidth="0.3"
      />
      <defs>
        <linearGradient
          id="paint0_linear_974_3273"
          x1="19.2308"
          y1="0.344238"
          x2="19.2308"
          y2="40.3442"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#F1F1F1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_974_3273"
          x1="20"
          y1="0.344238"
          x2="20"
          y2="40.3442"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#ECECEC" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const CancelIcon = (props) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      className={"svgButtonEffect"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="4" fill="url(#paint0_linear_974_3267)" />
      <rect width="40" height="40" rx="4" fill="url(#paint1_linear_974_3267)" />
      <rect
        width="39"
        height="39"
        rx="3.5"
        stroke="#C7C7C7"
        strokeOpacity="0.5"
      />
      <path
        d="M23.291 17.9391L18.499 22.7311"
        stroke="#525252"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.2926 22.734L18.4966 17.937"
        stroke="#525252"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.23 11.0944H16.561C13.54 11.0944 11.646 13.2334 11.646 16.2604V24.4284C11.646 27.4554 13.531 29.5944 16.561 29.5944H25.229C28.26 29.5944 30.146 27.4554 30.146 24.4284V16.2604C30.146 13.2334 28.26 11.0944 25.23 11.0944Z"
        stroke="#525252"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_974_3267"
          x1="20.1263"
          y1="0.344238"
          x2="20.1263"
          y2="40.3442"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#F1F1F1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_974_3267"
          x1="20.8955"
          y1="0.344238"
          x2="20.8955"
          y2="40.3442"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#ECECEC" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const AddDocumentsIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      className={"svgButtonEffect"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <rect width="24" height="24" rx="4" fill="url(#paint0_linear)" />
        <rect width="24" height="24" rx="4" fill="url(#paint1_linear)" />
        <g filter="url(#filter0_d)">
          <path
            d="M9 8V8.2825V15.91H15.215V10.26H12.955V8H9ZM13.52 8.16553V9.695H15.0495L13.52 8.16553ZM11.825 10.825H12.39V11.955H13.52V12.52H12.39V13.65H11.825V12.52H10.695V11.955H11.825V10.825Z"
            fill="#525252"
          />
        </g>
      </g>
      <rect
        x="0.5"
        y="0.5"
        width="23"
        height="23"
        rx="3.5"
        stroke="#C7C7C7"
        strokeOpacity="0.5"
      />
      <defs>
        <filter
          id="filter0_d"
          x="-2"
          y="-2"
          width="30"
          height="30"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear"
          x1="11.5385"
          y1="0"
          x2="11.5385"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#F1F1F1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="12"
          y1="0"
          x2="12"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#ECECEC" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0">
          <rect width="24" height="24" rx="4" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AutoActivatedIcon = (props) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      className={"svgButtonEffect"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z"
        fill="url(#paint0_linear_1573_4261)"
      />
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z"
        fill="url(#paint1_linear_1573_4261)"
      />
      <path
        d="M10.9338 20.3356H8.58612C8.26186 20.3356 8 20.0738 8 19.7489C8 19.4246 8.26186 19.1621 8.58612 19.1621H10.9332C11.2575 19.1621 11.5213 19.4246 11.5213 19.7489C11.5219 20.0738 11.2581 20.3356 10.9338 20.3356Z"
        fill="#525252"
        stroke="#525252"
        strokeWidth="0.3"
      />
      <path
        d="M18.7463 12.5219C18.4213 12.5219 18.1582 12.26 18.1582 11.9351V9.58677C18.1582 9.26315 18.4213 9 18.7463 9C19.0712 9 19.333 9.26315 19.333 9.58677V11.9345C19.333 12.2594 19.0712 12.5219 18.7463 12.5219Z"
        fill="#525252"
        stroke="#525252"
        strokeWidth="0.3"
      />
      <path
        d="M13.2747 14.6592C13.1254 14.6592 12.9749 14.602 12.8591 14.4868L11.2011 12.8281C10.9714 12.5985 10.9714 12.2259 11.2011 11.9962C11.4308 11.7672 11.802 11.7672 12.031 11.9962L13.6903 13.6555C13.92 13.8846 13.92 14.2577 13.6903 14.4868C13.5758 14.602 13.4259 14.6592 13.2747 14.6592Z"
        fill="#525252"
        stroke="#525252"
        strokeWidth="0.3"
      />
      <path
        d="M11.2176 27.4399C11.0677 27.4399 10.9178 27.3839 10.8026 27.2687C10.5729 27.0397 10.5729 26.6672 10.8026 26.4375L12.4632 24.7769C12.691 24.5478 13.0622 24.5478 13.2919 24.7769C13.5216 25.0066 13.5216 25.3791 13.2919 25.6088L11.6326 27.2687C11.5174 27.3832 11.3682 27.4399 11.2176 27.4399Z"
        fill="#525252"
        stroke="#525252"
        strokeWidth="0.3"
      />
      <path
        d="M24.3692 14.8919C24.2193 14.8919 24.0693 14.8347 23.9535 14.7195C23.7258 14.4904 23.7258 14.1186 23.9535 13.8895L25.6128 12.2302C25.8406 12.0012 26.2144 11.9999 26.4428 12.2289C26.6725 12.4586 26.6725 12.8299 26.4428 13.0596L24.7848 14.7182C24.6703 14.8334 24.5204 14.8919 24.3692 14.8919Z"
        fill="#525252"
        stroke="#525252"
        strokeWidth="0.3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.2509 19.4907C23.516 17.4571 21.5658 16 19.2822 16C16.3702 16 14 18.3683 14 21.2803C14 22.4731 14.3925 23.5977 15.1304 24.5364C15.2771 24.7237 15.4367 24.9096 15.6059 25.1046L15.6083 25.1073C16.1203 25.7022 16.6485 26.3159 16.8483 27.0476C16.8856 27.1866 16.903 27.4355 16.8991 27.7901V28.2025C16.8991 28.5254 17.161 28.7892 17.4859 28.7892H19.6775C19.6074 28.4058 19.5625 28.0136 19.5446 27.6144H18.0739C18.0688 27.1312 18.0224 26.8951 17.9826 26.74C17.7112 25.7491 17.0395 24.969 16.4972 24.3393L16.4963 24.3383L16.4674 24.3049C16.3205 24.1353 16.1818 23.975 16.0543 23.812C15.4791 23.0811 15.1755 22.2061 15.1755 21.2809C15.1755 19.0162 17.0181 17.1735 19.2828 17.1735C21.1428 17.1735 22.7172 18.4164 23.2206 20.1152C23.5481 19.8843 23.8922 19.6754 24.2509 19.4907Z"
        fill="#525252"
      />
      <path
        d="M24.2509 19.4907L24.3196 19.6241L24.4368 19.5637L24.392 19.4397L24.2509 19.4907ZM15.1304 24.5364L15.2485 24.4439L15.2484 24.4437L15.1304 24.5364ZM15.6059 25.1046L15.7196 25.0067L15.7192 25.0062L15.6059 25.1046ZM15.6083 25.1073L15.4946 25.2052L15.4946 25.2052L15.6083 25.1073ZM16.8483 27.0476L16.9931 27.0087L16.993 27.0081L16.8483 27.0476ZM16.8991 27.7901L16.7491 27.7884V27.7901H16.8991ZM19.6775 28.7892V28.9392H19.8574L19.8251 28.7623L19.6775 28.7892ZM19.5446 27.6144L19.6944 27.6077L19.688 27.4644H19.5446V27.6144ZM18.0739 27.6144L17.9239 27.616L17.9255 27.7644H18.0739V27.6144ZM17.9826 26.74L18.1278 26.7027L18.1272 26.7004L17.9826 26.74ZM16.4972 24.3393L16.3835 24.4372L16.3836 24.4372L16.4972 24.3393ZM16.4963 24.3383L16.6101 24.2405L16.6097 24.2401L16.4963 24.3383ZM16.4674 24.3049L16.5808 24.2067L16.5808 24.2067L16.4674 24.3049ZM16.0543 23.812L16.1725 23.7196L16.1722 23.7192L16.0543 23.812ZM23.2206 20.1152L23.0768 20.1578L23.1362 20.3583L23.307 20.2378L23.2206 20.1152ZM19.2822 16.15C21.5005 16.15 23.3957 17.5655 24.1099 19.5417L24.392 19.4397C23.6364 17.3487 21.6311 15.85 19.2822 15.85V16.15ZM14.15 21.2803C14.15 18.4512 16.453 16.15 19.2822 16.15V15.85C16.2875 15.85 13.85 18.2854 13.85 21.2803H14.15ZM15.2484 24.4437C14.531 23.5312 14.15 22.4392 14.15 21.2803H13.85C13.85 22.507 14.254 23.6643 15.0125 24.6292L15.2484 24.4437ZM15.7192 25.0062C15.55 24.8113 15.3926 24.6279 15.2485 24.4439L15.0124 24.629C15.1616 24.8194 15.3234 25.0079 15.4926 25.2029L15.7192 25.0062ZM15.722 25.0095L15.7196 25.0067L15.4922 25.2024L15.4946 25.2052L15.722 25.0095ZM16.993 27.0081C16.7826 26.2378 16.2289 25.5984 15.722 25.0095L15.4946 25.2052C16.0117 25.806 16.5143 26.394 16.7036 27.0871L16.993 27.0081ZM17.0491 27.7917C17.0529 27.4374 17.0364 27.1697 16.9931 27.0087L16.7034 27.0865C16.7348 27.2034 16.753 27.4337 16.7491 27.7884L17.0491 27.7917ZM17.0491 28.2025V27.7901H16.7491V28.2025H17.0491ZM17.4859 28.6392C17.2441 28.6392 17.0491 28.4429 17.0491 28.2025H16.7491C16.7491 28.608 17.0778 28.9392 17.4859 28.9392V28.6392ZM19.6775 28.6392H17.4859V28.9392H19.6775V28.6392ZM19.8251 28.7623C19.7562 28.3855 19.7121 28.0001 19.6944 27.6077L19.3947 27.6212C19.413 28.0272 19.4587 28.4261 19.53 28.8162L19.8251 28.7623ZM18.0739 27.7644H19.5446V27.4644H18.0739V27.7644ZM17.8373 26.7774C17.8738 26.9193 17.9189 27.1433 17.9239 27.616L18.2239 27.6128C18.2187 27.1192 18.1711 26.8709 18.1278 26.7027L17.8373 26.7774ZM16.3836 24.4372C16.9289 25.0705 17.5768 25.8263 17.8379 26.7797L18.1272 26.7004C17.8456 25.672 17.15 24.8675 16.6109 24.2415L16.3836 24.4372ZM16.3826 24.4361L16.3835 24.4372L16.611 24.2415L16.6101 24.2405L16.3826 24.4361ZM16.354 24.4031L16.3829 24.4365L16.6097 24.2401L16.5808 24.2067L16.354 24.4031ZM15.9361 23.9044C16.0663 24.0709 16.2076 24.234 16.354 24.4031L16.5808 24.2067C16.4334 24.0365 16.2972 23.8792 16.1725 23.7196L15.9361 23.9044ZM15.0255 21.2809C15.0255 22.2399 15.3406 23.1476 15.9365 23.9048L16.1722 23.7192C15.6177 23.0147 15.3255 22.1723 15.3255 21.2809H15.0255ZM19.2828 17.0235C16.9353 17.0235 15.0255 18.9334 15.0255 21.2809H15.3255C15.3255 19.099 17.101 17.3235 19.2828 17.3235V17.0235ZM23.3644 20.0726C22.8428 18.312 21.2112 17.0235 19.2828 17.0235V17.3235C21.0744 17.3235 22.5917 18.5208 23.0768 20.1578L23.3644 20.0726ZM23.307 20.2378C23.6289 20.0108 23.9671 19.8055 24.3196 19.6241L24.1823 19.3574C23.8174 19.5452 23.4673 19.7577 23.1341 19.9927L23.307 20.2378Z"
        fill="#525252"
      />
      <path
        d="M23 23.4837V26.3941H25.9104"
        stroke="#525252"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.6716 31.2447V28.3344H30.7612"
        stroke="#525252"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.4539 25.9092C32.2079 25.214 31.7898 24.5925 31.2386 24.1026C30.6874 23.6127 30.0211 23.2704 29.3018 23.1076C28.5825 22.9449 27.8338 22.967 27.1254 23.1719C26.417 23.3768 25.772 23.7578 25.2507 24.2794L23 26.3943M33.6714 28.3346L31.4207 30.4494C30.8994 30.971 30.2544 31.352 29.546 31.5569C28.8376 31.7618 28.0889 31.784 27.3696 31.6212C26.6503 31.4585 25.984 31.1162 25.4328 30.6263C24.8816 30.1364 24.4635 29.5148 24.2175 28.8196"
        stroke="#525252"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 1H36V-1H4V1ZM39 4V36H41V4H39ZM36 39H4V41H36V39ZM1 36V4H-1V36H1ZM4 39C2.34315 39 1 37.6569 1 36H-1C-1 38.7614 1.23858 41 4 41V39ZM39 36C39 37.6569 37.6569 39 36 39V41C38.7614 41 41 38.7614 41 36H39ZM36 1C37.6569 1 39 2.34315 39 4H41C41 1.23858 38.7614 -1 36 -1V1ZM4 -1C1.23858 -1 -1 1.23858 -1 4H1C1 2.34315 2.34315 1 4 1V-1Z"
        fill="#C7C7C7"
        fill-opacity="0.5"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1573_4261"
          x1="19.2308"
          y1="0"
          x2="19.2308"
          y2="40"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#F1F1F1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1573_4261"
          x1="20"
          y1="0"
          x2="20"
          y2="40"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#ECECEC" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const PackagingIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      className={"svgButtonEffect"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <rect width="24" height="24" rx="4" fill="url(#paint0_linear)" />
        <rect width="24" height="24" rx="4" fill="url(#paint1_linear)" />
        <g filter="url(#filter0_d)">
          <path
            d="M16.9532 11.9502L15.6366 10.4335C15.605 10.3914 15.5629 10.3703 15.5207 10.3598C15.4997 10.3492 14.3621 10.0543 13.4036 9.80151L13.035 10.1702L14.5728 10.5809L12.0027 11.255L9.43273 10.5809L10.9705 10.1807L10.6019 9.81205C9.64339 10.0648 8.50584 10.3598 8.47424 10.3703C8.43211 10.3808 8.37944 10.4124 8.35838 10.444C8.33731 10.4546 7.0523 11.9502 7.0523 11.9502C6.99964 12.0029 6.98911 12.0871 7.01017 12.1609C7.03124 12.2346 7.09443 12.2978 7.16816 12.3083L8.30571 12.6138V15.1311C8.30571 15.2365 8.37944 15.3313 8.47424 15.3523L11.9395 16.2582C11.9606 16.2582 11.9817 16.2687 11.9922 16.2687C12.0133 16.2687 12.0343 16.2687 12.0554 16.2582L15.5207 15.3523C15.626 15.3313 15.6892 15.2365 15.6892 15.1311V12.6138L16.8268 12.3083C16.9005 12.2873 16.9637 12.2346 16.9848 12.1609C17.0164 12.0871 16.9953 12.0029 16.9532 11.9502ZM7.64214 11.9607L8.6217 10.8232L11.592 11.6026L10.6124 12.7402L7.64214 11.9607ZM11.771 15.742L8.75863 14.9521V12.7296L10.6335 13.2247C10.6545 13.2352 10.6756 13.2352 10.6967 13.2352C10.7599 13.2352 10.8231 13.2036 10.8652 13.151L11.771 12.0977V15.742V15.742ZM15.2469 14.9521L12.2345 15.742V12.0977L13.1403 13.151C13.1824 13.2036 13.2456 13.2352 13.3088 13.2352C13.3299 13.2352 13.351 13.2352 13.372 13.2247L15.2469 12.7402V14.9521V14.9521ZM13.3931 12.7507L12.4135 11.6132L12.4873 11.5921L15.3838 10.8337L16.3633 11.9713L13.3931 12.7507Z"
            fill="#525252"
          />
          <path
            d="M11.8447 10.2441C11.8868 10.2863 11.95 10.3073 12.0026 10.3073C12.0553 10.3073 12.1185 10.2863 12.1606 10.2441L13.0349 9.36989C13.1191 9.28563 13.1191 9.13817 13.0349 9.05391C12.9506 8.96964 12.8031 8.96964 12.7189 9.05391L12.2238 9.54895V7.23172C12.2238 7.10533 12.129 7 12.0026 7C11.8762 7 11.7815 7.10533 11.7815 7.22119V9.52789L11.2864 9.03284C11.2021 8.94858 11.0547 8.94858 10.9704 9.03284C10.8862 9.1171 10.8862 9.26456 10.9704 9.34883L11.8447 10.2441Z"
            fill="#525252"
          />
        </g>
      </g>
      <rect
        x="0.5"
        y="0.5"
        width="23"
        height="23"
        rx="3.5"
        stroke="#C7C7C7"
        strokeOpacity="0.5"
      />
      <defs>
        <filter
          id="filter0_d"
          x="-2"
          y="-2"
          width="30"
          height="30"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear"
          x1="11.5385"
          y1="0"
          x2="11.5385"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#F1F1F1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="12"
          y1="0"
          x2="12"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#ECECEC" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0">
          <rect width="24" height="24" rx="4" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ShippingIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      className={"svgButtonEffect"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <rect width="24" height="24" rx="4" fill="url(#paint0_linear)" />
        <rect width="24" height="24" rx="4" fill="url(#paint1_linear)" />
        <g filter="url(#filter0_d)">
          <path
            d="M15.4139 9.46534V9.45111C15.4139 9.43689 15.4139 9.43689 15.3997 9.42266C15.3997 9.40844 15.3854 9.40843 15.3854 9.39421C15.3854 9.39421 15.3854 9.37998 15.3712 9.37998C15.357 9.36575 15.357 9.35153 15.3428 9.35153L14.0624 8.07113C14.0197 8.02845 13.9485 8 13.8916 8H12.0991H10.3919C10.3208 8 10.2639 8.02845 10.2212 8.07113L8.94077 9.35153C8.92655 9.36576 8.92655 9.37998 8.91232 9.37998L8.89809 9.39421C8.89809 9.40843 8.88387 9.40844 8.88387 9.42266C8.88387 9.43689 8.88387 9.43689 8.86964 9.45111V9.46534C8.86964 9.47957 8.86964 9.49379 8.86964 9.50802V14.8715C8.86964 14.9995 8.98345 15.1133 9.11149 15.1133H10.022C10.0505 15.1133 10.0647 15.1133 10.0931 15.0991C10.1643 15.5543 10.5626 15.91 11.0463 15.91C11.5158 15.91 11.9141 15.5686 11.9853 15.1133C11.9995 15.1133 12.0137 15.1133 12.028 15.1133H15.2005H15.7411C15.8265 15.5686 16.2106 15.91 16.6801 15.91C17.1495 15.91 17.5479 15.5686 17.619 15.1133H18.3446C18.4726 15.1133 18.5864 14.9995 18.5864 14.8715V12.3533C18.5864 11.7131 18.4015 11.1725 18.06 10.8026C17.7328 10.447 17.2776 10.262 16.7654 10.262H15.4281V9.50802C15.4139 9.49379 15.4139 9.47957 15.4139 9.46534ZM12.3409 8.4837H13.7921L14.5887 9.2804H12.3409V8.4837V8.4837ZM10.4773 8.4837H11.843V9.2804H9.68056L10.4773 8.4837ZM11.0179 15.4405C10.7618 15.4405 10.5484 15.2271 10.5484 14.971C10.5484 14.715 10.7618 14.5016 11.0179 14.5016C11.2739 14.5016 11.4873 14.715 11.4873 14.971C11.4873 15.2271 11.2739 15.4405 11.0179 15.4405ZM14.916 10.5039V14.6438H11.9995C11.971 14.6438 11.9426 14.6438 11.9284 14.6581C11.8003 14.2739 11.4447 14.0036 11.0179 14.0036C10.5911 14.0036 10.2354 14.2882 10.1074 14.6581C10.0789 14.6438 10.0362 14.6296 10.0078 14.6296H9.35335V9.74987H14.9302V10.5039H14.916ZM16.6516 15.4405C16.3955 15.4405 16.1821 15.2271 16.1821 14.971C16.1821 14.715 16.3955 14.5016 16.6516 14.5016C16.9077 14.5016 17.1211 14.715 17.1211 14.971C17.1211 15.2271 16.9077 15.4405 16.6516 15.4405ZM16.7512 10.7457C17.5763 10.7457 18.0885 11.3575 18.0885 12.3533V14.6296H17.5621C17.4341 14.2597 17.0784 13.9894 16.6516 13.9894C16.239 13.9894 15.8834 14.2597 15.7553 14.6296H15.4281V10.7457H16.7512ZM6.2804 10.6319H8.14408C8.27212 10.6319 8.38594 10.7457 8.38594 10.8738C8.38594 11.0018 8.27212 11.1156 8.14408 11.1156H6.2804C6.15236 11.1156 6.03854 11.0018 6.03854 10.8738C6.03854 10.7457 6.15236 10.6319 6.2804 10.6319ZM5 12.1969C5 12.0688 5.11381 11.955 5.24185 11.955H8.12986C8.2579 11.955 8.37171 12.0688 8.37171 12.1969C8.37171 12.3249 8.2579 12.4387 8.12986 12.4387H5.24185C5.11381 12.4387 5 12.3391 5 12.1969ZM8.38594 13.5199C8.38594 13.648 8.27212 13.7618 8.14408 13.7618H6.2804C6.15236 13.7618 6.03854 13.648 6.03854 13.5199C6.03854 13.3919 6.15236 13.2781 6.2804 13.2781H8.14408C8.28635 13.2781 8.38594 13.3777 8.38594 13.5199ZM10.5484 12.2253C10.5484 12.0973 10.6622 11.9835 10.7902 11.9835H12.6681L12.3409 11.6562C12.2414 11.5567 12.2414 11.4002 12.3409 11.3148C12.4405 11.2152 12.597 11.2152 12.6824 11.3148L13.4222 12.0546C13.4364 12.0688 13.4364 12.083 13.4506 12.083C13.4506 12.083 13.4506 12.0973 13.4648 12.0973C13.4648 12.1115 13.4791 12.1115 13.4791 12.1257C13.4791 12.1399 13.4791 12.1399 13.4933 12.1542V12.1684C13.4933 12.1826 13.4933 12.1969 13.4933 12.2111C13.4933 12.2253 13.4933 12.2395 13.4933 12.2538V12.268C13.4933 12.2822 13.4933 12.2822 13.4791 12.2964C13.4791 12.3107 13.4648 12.3107 13.4648 12.3249C13.4648 12.3249 13.4648 12.3391 13.4506 12.3391C13.4364 12.3533 13.4364 12.3676 13.4222 12.3676L12.6397 13.15C12.597 13.1927 12.5259 13.2212 12.469 13.2212C12.4121 13.2212 12.3409 13.1927 12.2983 13.15C12.1987 13.0504 12.1987 12.894 12.2983 12.8086L12.6681 12.4387H10.7902C10.6622 12.4672 10.5484 12.3533 10.5484 12.2253Z"
            fill="#525252"
          />
        </g>
      </g>
      <rect
        x="0.5"
        y="0.5"
        width="23"
        height="23"
        rx="3.5"
        stroke="#C7C7C7"
        strokeOpacity="0.5"
      />
      <defs>
        <filter
          id="filter0_d"
          x="-2"
          y="-2"
          width="30"
          height="30"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear"
          x1="11.5385"
          y1="0"
          x2="11.5385"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#F1F1F1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="12"
          y1="0"
          x2="12"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#ECECEC" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0">
          <rect width="24" height="24" rx="4" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AddIcon = (props) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10.5" cy="10.5" r="10.5" fill="white" />
      <path
        d="M17 10.8571H11.8571V16H10.1429V10.8571H5V9.14286H10.1429V4H11.8571V9.14286H17V10.8571Z"
        fill="#C7C7C7"
      />
    </svg>
  );
};

export const InfoIcon = (props) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8.30078" cy="8" r="8" fill="#033DD2" />
      <path
        d="M8.90377 13.7467C8.66911 13.7467 8.47177 13.6827 8.31177 13.5547C8.16244 13.4267 8.08777 13.2347 8.08777 12.9787V6.48275C8.08777 6.22675 8.16244 6.03475 8.31177 5.90675C8.47177 5.76808 8.66911 5.69875 8.90377 5.69875C9.13844 5.69875 9.33044 5.76808 9.47977 5.90675C9.62911 6.03475 9.70377 6.22675 9.70377 6.48275V12.9787C9.70377 13.2347 9.62911 13.4267 9.47977 13.5547C9.33044 13.6827 9.13844 13.7467 8.90377 13.7467ZM8.90377 4.13075C8.59444 4.13075 8.34911 4.04541 8.16777 3.87475C7.98644 3.70408 7.89577 3.48008 7.89577 3.20275C7.89577 2.92541 7.98644 2.70675 8.16777 2.54675C8.34911 2.37608 8.59444 2.29075 8.90377 2.29075C9.20244 2.29075 9.44244 2.37608 9.62377 2.54675C9.81577 2.70675 9.91177 2.92541 9.91177 3.20275C9.91177 3.48008 9.82111 3.70408 9.63977 3.87475C9.45844 4.04541 9.21311 4.13075 8.90377 4.13075Z"
        fill="white"
      />
    </svg>
  );
};

export const RangeIcon = (props) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="224.000000pt"
      height="224.000000pt"
      viewBox="0 0 224.000000 224.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,224.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M120 1540 c-17 -17 -20 -33 -20 -100 0 -67 3 -83 20 -100 11 -11 29
-20 40 -20 11 0 29 9 40 20 17 17 20 33 20 100 0 67 -3 83 -20 100 -11 11 -29
20 -40 20 -11 0 -29 -9 -40 -20z"
        />
        <path
          d="M600 1540 c-17 -17 -20 -33 -20 -100 0 -67 3 -83 20 -100 11 -11 29
-20 40 -20 11 0 29 9 40 20 17 17 20 33 20 100 0 67 -3 83 -20 100 -11 11 -29
20 -40 20 -11 0 -29 -9 -40 -20z"
        />
        <path
          d="M1080 1540 c-17 -17 -20 -33 -20 -100 0 -67 3 -83 20 -100 11 -11 29
-20 40 -20 11 0 29 9 40 20 17 17 20 33 20 100 0 67 -3 83 -20 100 -11 11 -29
20 -40 20 -11 0 -29 -9 -40 -20z"
        />
        <path
          d="M1560 1540 c-17 -17 -20 -33 -20 -100 0 -67 3 -83 20 -100 11 -11 29
-20 40 -20 11 0 29 9 40 20 17 17 20 33 20 100 0 67 -3 83 -20 100 -11 11 -29
20 -40 20 -11 0 -29 -9 -40 -20z"
        />
        <path
          d="M2040 1540 c-17 -17 -20 -33 -20 -100 0 -67 3 -83 20 -100 11 -11 29
-20 40 -20 11 0 29 9 40 20 17 17 20 33 20 100 0 67 -3 83 -20 100 -11 11 -29
20 -40 20 -11 0 -29 -9 -40 -20z"
        />
        <path
          d="M495 1194 c-72 -36 -136 -73 -142 -82 -7 -9 -13 -33 -13 -54 l0 -38
-130 0 c-117 0 -132 -2 -150 -20 -11 -11 -20 -29 -20 -40 0 -11 9 -29 20 -40
18 -18 33 -20 150 -20 l130 0 0 -70 c0 -107 6 -110 180 -110 127 0 142 2 160
20 13 13 20 33 20 60 l0 40 420 0 420 0 0 -40 c0 -27 7 -47 20 -60 18 -18 33
-20 160 -20 174 0 180 3 180 110 l0 70 130 0 c117 0 132 2 150 20 25 25 25 55
0 80 -18 18 -33 20 -150 20 l-130 0 0 38 c0 21 -6 46 -12 55 -15 20 -266 147
-290 147 -39 0 -58 -36 -58 -110 l0 -70 -420 0 -420 0 0 70 c0 74 -19 110 -58
110 -9 0 -76 -30 -147 -66z m85 -224 l0 -130 -60 0 -61 0 3 103 3 102 55 27
c30 15 56 28 58 28 1 0 2 -58 2 -130z m1187 78 c9 -7 13 -41 13 -109 l0 -99
-60 0 -60 0 0 130 0 129 47 -20 c26 -11 53 -25 60 -31z"
        />
      </g>
    </svg>
  );
};

export const ExactIcon = (props) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="220.000000pt"
      height="220.000000pt"
      viewBox="0 0 220.000000 220.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,220.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M90 1420 c-17 -17 -20 -33 -20 -100 0 -89 17 -120 64 -120 40 0 56
34 56 122 0 84 -17 118 -60 118 -11 0 -29 -9 -40 -20z"
        />
        <path
          d="M570 1420 c-17 -17 -20 -33 -20 -100 0 -89 17 -120 64 -120 40 0 56
34 56 122 0 84 -17 118 -60 118 -11 0 -29 -9 -40 -20z"
        />
        <path
          d="M1050 1420 c-17 -17 -20 -33 -20 -100 0 -89 17 -120 64 -120 40 0 56
34 56 122 0 84 -17 118 -60 118 -11 0 -29 -9 -40 -20z"
        />
        <path
          d="M1530 1420 c-17 -17 -20 -33 -20 -100 0 -89 17 -120 64 -120 40 0 56
34 56 122 0 84 -17 118 -60 118 -11 0 -29 -9 -40 -20z"
        />
        <path
          d="M2010 1420 c-17 -17 -20 -33 -20 -100 0 -89 17 -120 64 -120 40 0 56
34 56 122 0 84 -17 118 -60 118 -11 0 -29 -9 -40 -20z"
        />
        <path
          d="M988 1002 c-72 -73 -78 -81 -78 -120 l0 -42 -400 0 c-387 0 -401 -1
-420 -20 -24 -24 -25 -48 -4 -78 l15 -22 405 0 404 0 0 -40 c0 -27 7 -47 20
-60 18 -18 33 -20 164 -20 138 0 146 1 160 22 9 12 16 39 16 60 l0 38 404 0
405 0 15 22 c21 30 20 54 -4 78 -19 19 -33 20 -420 20 l-400 0 0 42 c0 39 -6
47 -78 120 -54 53 -86 78 -102 78 -16 0 -48 -25 -102 -78z m134 -99 c26 -25
28 -32 28 -105 l0 -78 -60 0 -60 0 0 77 c0 70 2 79 27 105 15 15 29 28 32 28
3 0 18 -12 33 -27z"
        />
      </g>
    </svg>
  );
};

export const MoveUpIcon = (props) => {
  return (
    <svg
      version="1.0"
      width="26"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,15.000000) scale(0.100000,-0.100000)"
        fill="#4A4A4A"
        stroke="none"
      >
        <path
          d="M62 87 c-29 -29 -52 -56 -52 -60 0 -4 49 -7 110 -7 61 0 110 4 110 8
0 8 -102 112 -111 112 -2 0 -28 -24 -57 -53z"
        />
      </g>
    </svg>
  );
};

export const MoveDownIcon = (props) => {
  return (
    <svg
      version="1.0"
      width="26"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,15.000000) scale(0.100000,-0.100000)"
        fill="#4A4A4A"
        stroke="none"
      >
        <path
          d="M10 122 c0 -4 25 -32 55 -62 l55 -54 55 54 c30 30 55 58 55 62 0 4
-49 8 -110 8 -61 0 -110 -4 -110 -8z"
        />
      </g>
    </svg>
  );
};

export const ReturnIcon = (props) => {
  return (
    // <svg width="32" height="32" className={'svgButtonEffect'} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //     <g clipPath="url(#clip0)">
    //         <rect width="24" height="24" rx="4" fill="url(#paint0_linear)" />
    //         <rect width="24" height="24" rx="4" fill="url(#paint1_linear)" />
    //         <g filter="url(#filter0_d)">
    //             <path d="M11.4822 14.9264L11.606 14.3754C13.0909 14.7091 14.5704 13.7726 14.9042 12.2878C14.9738 11.9782 14.9881 11.669 14.9538 11.3703C14.8236 10.236 13.9918 9.25388 12.8166 8.98973C11.3318 8.65603 9.85229 9.59254 9.5185 11.0773C9.38176 11.686 9.45622 12.3149 9.71973 12.8682L9.8575 12.3425L10.4039 12.4858L10.0115 13.982L8.53435 13.4746L8.71788 12.9404L9.20903 13.1091C8.8923 12.4431 8.80268 11.6862 8.96743 10.9535C9.36973 9.16474 11.1519 8.03666 12.9405 8.43875C14.3563 8.75691 15.3582 9.93992 15.515 11.3064C15.5563 11.6662 15.5389 12.0388 15.4552 12.4117C15.0531 14.2003 13.2709 15.3285 11.4822 14.9264Z" fill="#525252" />
    //         </g>
    //     </g>
    //     <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" stroke="#C7C7C7" strokeOpacity="0.5" />
    //     <defs>
    //         <filter id="filter0_d" x="-2" y="-2" width="30" height="30" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    //             <feFlood floodOpacity="0" result="BackgroundImageFix" />
    //             <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
    //             <feOffset dx="1" dy="1" />
    //             <feGaussianBlur stdDeviation="1.5" />
    //             <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
    //             <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
    //             <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
    //         </filter>
    //         <linearGradient id="paint0_linear" x1="11.5385" y1="0" x2="11.5385" y2="24" gradientUnits="userSpaceOnUse">
    //             <stop stopColor="white" stopOpacity="0" />
    //             <stop offset="1" stopColor="#F1F1F1" />
    //         </linearGradient>
    //         <linearGradient id="paint1_linear" x1="12" y1="0" x2="12" y2="24" gradientUnits="userSpaceOnUse">
    //             <stop stopColor="white" />
    //             <stop offset="1" stopColor="#ECECEC" stopOpacity="0" />
    //         </linearGradient>
    //         <clipPath id="clip0">
    //             <rect width="24" height="24" rx="4" fill="white" />
    //         </clipPath>
    //     </defs>
    // </svg>
    <svg
      width="32"
      height="32"
      className={"svgButtonEffect"}
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.486816"
        y="0.344238"
        width="40"
        height="40"
        rx="4"
        fill="url(#paint0_linear_974_3389)"
      />
      <rect
        x="0.486816"
        y="0.344238"
        width="40"
        height="40"
        rx="4"
        fill="url(#paint1_linear_974_3389)"
      />
      <rect
        x="0.986816"
        y="0.844238"
        width="39"
        height="39"
        rx="3.5"
        stroke="#C7C7C7"
        strokeOpacity="0.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.4801 14.4495C23.4801 14.8637 23.1444 15.1995 22.7301 15.1995L18.2505 15.1993C17.8363 15.1993 17.5005 14.8635 17.5005 14.4493C17.5005 14.0351 17.8363 13.6993 18.2505 13.6993L22.7301 13.6995C23.1444 13.6995 23.4801 14.0353 23.4801 14.4495Z"
        fill="#525252"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1552 10C14.4589 10 13.0237 10.6056 12.0162 11.6865C11.0142 12.7615 10.4902 14.2468 10.4902 15.916V24.084C10.4902 25.7523 11.0114 27.2377 12.0125 28.3131C13.0193 29.3947 14.4549 30 16.1552 30H21.7397C21.1727 29.5947 20.6732 29.0866 20.2636 28.5H16.1552C14.8255 28.5 13.8037 28.0358 13.1105 27.2911C12.4116 26.5403 11.9902 25.4427 11.9902 24.084V15.916C11.9902 14.5582 12.4133 13.4605 13.1135 12.7093C13.8083 11.9639 14.8305 11.5 16.1552 11.5H24.8242C26.1539 11.5 27.1761 11.9642 27.8696 12.709C28.5687 13.4598 28.9902 14.5574 28.9902 15.916V19.7946C29.6358 20.433 30.1518 21.224 30.4902 22.1152V15.916C30.4902 14.2476 29.9688 12.7622 28.9674 11.6868C27.9604 10.6053 26.5245 10 24.8242 10H16.1552Z"
        fill="#525252"
      />
      <path
        d="M21.2954 23.0322L22.614 21.7134C23.3392 20.988 23.9395 20.3945 23.948 20.3945C23.9565 20.3945 24.1477 20.5791 24.3728 20.8046L24.7821 21.2148L24.201 21.7953C23.8814 22.1145 23.6199 22.386 23.6199 22.3984C23.6199 22.4109 24.1077 22.421 24.7038 22.421C25.5233 22.421 25.8486 22.4317 26.0374 22.4648C27.2645 22.6797 28.2855 23.6201 28.5945 24.8201C28.8121 25.665 28.684 26.5005 28.2247 27.2321C28.1359 27.3735 28.0375 27.5219 28.0061 27.5619L27.9489 27.6346L27.5502 27.3192L27.083 26.9496L27.0145 26.8954L27.1168 26.7518C27.3786 26.3842 27.5041 26.0186 27.5036 25.6247C27.5032 25.2949 27.4427 25.0478 27.2812 24.7158C27.1218 24.3882 26.7559 24.0128 26.4302 23.8427C26.02 23.6285 25.901 23.6131 24.6511 23.6131H23.546L24.1642 24.2318L24.7824 24.8505L24.3649 25.2672L23.9475 25.6838L22.6214 24.358L21.2954 23.0322Z"
        fill="#525252"
      />
      <defs>
        <linearGradient
          id="paint0_linear_974_3389"
          x1="19.7176"
          y1="0.344238"
          x2="19.7176"
          y2="40.3442"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#F1F1F1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_974_3389"
          x1="20.4868"
          y1="0.344238"
          x2="20.4868"
          y2="40.3442"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#ECECEC" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const ReturnIconBig = (props) => {
  return (
    <svg
      width="40"
      height="40"
      className={"svgButtonEffect"}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="4" fill="url(#paint0_linear_974_3389)" />
      <rect width="40" height="40" rx="4" fill="url(#paint1_linear_974_3389)" />
      <rect
        width="39"
        height="39"
        rx="3.5"
        stroke="#C7C7C7"
        strokeOpacity="0.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.4801 14.4495C23.4801 14.8637 23.1444 15.1995 22.7301 15.1995L18.2505 15.1993C17.8363 15.1993 17.5005 14.8635 17.5005 14.4493C17.5005 14.0351 17.8363 13.6993 18.2505 13.6993L22.7301 13.6995C23.1444 13.6995 23.4801 14.0353 23.4801 14.4495Z"
        fill="#525252"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1552 10C14.4589 10 13.0237 10.6056 12.0162 11.6865C11.0142 12.7615 10.4902 14.2468 10.4902 15.916V24.084C10.4902 25.7523 11.0114 27.2377 12.0125 28.3131C13.0193 29.3947 14.4549 30 16.1552 30H21.7397C21.1727 29.5947 20.6732 29.0866 20.2636 28.5H16.1552C14.8255 28.5 13.8037 28.0358 13.1105 27.2911C12.4116 26.5403 11.9902 25.4427 11.9902 24.084V15.916C11.9902 14.5582 12.4133 13.4605 13.1135 12.7093C13.8083 11.9639 14.8305 11.5 16.1552 11.5H24.8242C26.1539 11.5 27.1761 11.9642 27.8696 12.709C28.5687 13.4598 28.9902 14.5574 28.9902 15.916V19.7946C29.6358 20.433 30.1518 21.224 30.4902 22.1152V15.916C30.4902 14.2476 29.9688 12.7622 28.9674 11.6868C27.9604 10.6053 26.5245 10 24.8242 10H16.1552Z"
        fill="#525252"
      />
      <path
        d="M21.2954 23.0322L22.614 21.7134C23.3392 20.988 23.9395 20.3945 23.948 20.3945C23.9565 20.3945 24.1477 20.5791 24.3728 20.8046L24.7821 21.2148L24.201 21.7953C23.8814 22.1145 23.6199 22.386 23.6199 22.3984C23.6199 22.4109 24.1077 22.421 24.7038 22.421C25.5233 22.421 25.8486 22.4317 26.0374 22.4648C27.2645 22.6797 28.2855 23.6201 28.5945 24.8201C28.8121 25.665 28.684 26.5005 28.2247 27.2321C28.1359 27.3735 28.0375 27.5219 28.0061 27.5619L27.9489 27.6346L27.5502 27.3192L27.083 26.9496L27.0145 26.8954L27.1168 26.7518C27.3786 26.3842 27.5041 26.0186 27.5036 25.6247C27.5032 25.2949 27.4427 25.0478 27.2812 24.7158C27.1218 24.3882 26.7559 24.0128 26.4302 23.8427C26.02 23.6285 25.901 23.6131 24.6511 23.6131H23.546L24.1642 24.2318L24.7824 24.8505L24.3649 25.2672L23.9475 25.6838L22.6214 24.358L21.2954 23.0322Z"
        fill="#525252"
      />
      <defs>
        <linearGradient
          id="paint0_linear_974_3389"
          x1="19.7176"
          y1="0.344238"
          x2="19.7176"
          y2="40.3442"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#F1F1F1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_974_3389"
          x1="20.4868"
          y1="0.344238"
          x2="20.4868"
          y2="40.3442"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#ECECEC" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const ExpandMore = (props) => {
  return (
    <svg
      className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc"
      onClick={props.click ? props.click : null}
      style={{ width: 24, height: 24, background: "#fff", borderRadius: "50%" }}
      focusable="false"
      aria-hidden="true"
      viewBox="0 0 24 24"
      data-testid="ExpandCircleDownOutlinedIcon"
    >
      <path d="M15.08 9.59 12 12.67 8.92 9.59 7.5 11l4.5 4.5 4.5-4.5-1.42-1.41zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"></path>
    </svg>
  );
};

export const CollapseMore = (props) => {
  return (
    <svg
      className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc"
      onClick={props.click ? props.click : null}
      style={{
        width: 24,
        height: 24,
        transform: "rotate(180deg)",
        background: "#fff",
        borderRadius: "50%",
      }}
      focusable="false"
      aria-hidden="true"
      viewBox="0 0 24 24"
      data-testid="ExpandCircleDownOutlinedIcon"
    >
      <path d="M15.08 9.59 12 12.67 8.92 9.59 7.5 11l4.5 4.5 4.5-4.5-1.42-1.41zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"></path>
    </svg>
  );
};

export const ExpandAll = (props) => {
  return (
    // <svg width="32" height="32" className={'svgButtonEffect'} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //     <g clipPath="url(#clip0)">
    //         <rect width="24" height="24" rx="4" fill="url(#paint0_linear)" />
    //         <rect width="24" height="24" rx="4" fill="url(#paint1_linear)" />
    //         {/* <g filter="url(#filter0_d)">
    //             <path d="M17 10.8571H11.8571V16H10.1429V10.8571H5V9.14286H10.1429V4H11.8571V9.14286H17V10.8571Z" fill="#525252" strokeOpacity="0.5" x="0.5" y="0.5" />
    //         </g> */}
    //         <image id="image0" width="10" height="10" x="7.2" y="7.2"
    //             href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAABGdBTUEAALGPC/xhBQAAACBjSFJN
    //             AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElN
    //             RQfmAx8UIzDATCNHAAABRElEQVRIx+WUzS4EQRSFT82gyMwTWHgBK3W7N2gSIXoisfMI7JF4CYme
    //             WImfeQAJw4aNpdrpXnsDD8BgNddC13SaXvQtS2fVddPfqVN/V0EkY9V8qWAbMgPFPwoLSmbgFHS4
    //             Dw0AwgQ5vsk30OrQ0yDo8CUmcPR0AABjfuE5yfa/x8IEJuZraE6yPVcRGZhY9TGpugUuWgJt4Aqa
    //             k7TALbg2bmL6IA4S6Z45fP1PeLhMn8TURcW1q7WJwwgax+muYMVlbTXDWU/0X6hZXaaZ6fGX9zoG
    //             lccYrOEZD/USVBiEq3yLqboGvzS3RG/EdAq/ZpfjZ4Jnbiw9jr5XaEBsTkSzE1N+w01Er8R0Lmsy
    //             o59NpO7QxkW6g6GHgS8OKGIAEe7R5l62LcWdwQAtn9kB11Rb3Mu8cJegkE0XZQYN2NJY3LS+ADpJ
    //             ZDhuUJfPAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIyLTAzLTMxVDE3OjM1OjQ4KzAzOjAwRs9G1gAA
    //             ACV0RVh0ZGF0ZTptb2RpZnkAMjAyMi0wMy0zMVQxNzozNTo0OCswMzowMDeS/moAAAAASUVORK5C
    //             YII=" />
    //     </g>
    //     <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" stroke="#C7C7C7" strokeOpacity="0.5" />
    //     <defs>
    //         <filter id="filter0_d" x="-2" y="-2" width="30" height="30" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    //             <feFlood floodOpacity="0" result="BackgroundImageFix" />
    //             <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
    //             <feOffset dx="1" dy="1" />
    //             <feGaussianBlur stdDeviation="1.5" />
    //             <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
    //             <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
    //             <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
    //         </filter>
    //         <linearGradient id="paint0_linear" x1="11.5385" y1="0" x2="11.5385" y2="24" gradientUnits="userSpaceOnUse">
    //             <stop stopColor="white" stopOpacity="0" />
    //             <stop offset="1" stopColor="#F1F1F1" />
    //         </linearGradient>
    //         <linearGradient id="paint1_linear" x1="12" y1="0" x2="12" y2="24" gradientUnits="userSpaceOnUse">
    //             <stop stopColor="white" />
    //             <stop offset="1" stopColor="#ECECEC" stopOpacity="0" />
    //         </linearGradient>
    //         <clipPath id="clip0">
    //             <rect width="24" height="24" rx="4" fill="white" />
    //         </clipPath>
    //     </defs>
    // </svg>
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.96 4.16H11.84V7.04M7.04 11.84H4.16V8.96"
        stroke="currentColor"
        strokeWidth="0.7"
      />
      <path
        d="M11.84 4.16L8.96 7.04M4.16 11.84L7.04 8.96"
        stroke="currentColor"
        strokeWidth="0.7"
      />
    </svg>
  );
};

export const DownloadIcon = (props) => {
  return (
    <svg
      style={{ transform: "rotate(180deg)" }}
      className={"svgButtonEffect"}
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.350586"
        y="0.344238"
        width="40"
        height="40"
        rx="4"
        fill="url(#paint0_linear_974_3351)"
      />
      <rect
        x="0.350586"
        y="0.344238"
        width="40"
        height="40"
        rx="4"
        fill="url(#paint1_linear_974_3351)"
      />
      <rect
        x="0.850586"
        y="0.844238"
        width="39"
        height="39"
        rx="3.5"
        stroke="#C7C7C7"
        strokeOpacity="0.5"
      />
      <path
        d="M11.3506 17.3442L11.3506 13.3442C11.3506 12.8138 11.5613 12.3051 11.9364 11.93C12.3114 11.555 12.8202 11.3442 13.3506 11.3442L27.3506 11.3442C27.881 11.3442 28.3897 11.555 28.7648 11.93C29.1399 12.3051 29.3506 12.8138 29.3506 13.3442L29.3506 17.3442"
        stroke="#525252"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.3506 22.3442L20.3506 17.3442L15.3506 22.3442"
        stroke="#525252"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.3506 17.3442L20.3506 29.3442"
        stroke="#525252"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_974_3351"
          x1="19.5814"
          y1="0.344238"
          x2="19.5814"
          y2="40.3442"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#F1F1F1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_974_3351"
          x1="20.3506"
          y1="0.344238"
          x2="20.3506"
          y2="40.3442"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#ECECEC" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const DiagramIcon11 = (props) => {
  return (
    <svg
      width="32"
      height="32"
      className={"svgButtonEffect"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <rect width="24" height="24" rx="4" fill="url(#paint0_linear)" />
        <rect width="24" height="24" rx="4" fill="url(#paint1_linear)" />
        {/* <g filter="url(#filter0_d)">
                    <circle cx="12" cy="12" r="5" fill="#525252" />
                    <path d="M14 11L10.5625 14L9 12.6364" stroke="white" strokeLinecap="square" />
                </g> */}
        {/* <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="AccountTreeIcon">
                    <path d="M22 11V3h-7v3H9V3H2v8h7V8h2v10h4v3h7v-8h-7v3h-2V8h2v3z" fill="#525252" stroke="#525252"></path>
                </svg> */}
        {/* <svg focusable="false" aria-hidden="true" data-testid="AccountTreeIcon" width="15" height="15" viewBox="0 0 24 24">
                    <path
                        d="M22 11V3h-7v3H9V3H2v8h7V8h2v10h4v3h7v-8h-7v3h-2V8h2v3z"
                        // fill="none"
                        fill="#525252"
                        stroke="#525252"
                        width="24"
                        height="24"
                    ></path>
                </svg> */}
        <img
          width="10"
          height="10"
          x="7.2"
          y="7.2"
          href="data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iTXVpU3ZnSWNvbi1yb290IE11aVN2Z0l
                jb24tZm9udFNpemVNZWRpdW0gTXVpQm94LXJvb3QgY3NzLTFvbTBoa2MiIGZvY3VzYWJsZT0iZmFsc
                2UiIGFyaWEtaGlkZGVuPSJ0cnVlIiB2aWV3Qm94PSIwIDAgMjQgMjQiIGRhdGEtdGVzdGlkPSJBY2N
                vdW50VHJlZUljb24iPgoJPHBhdGggZD0iTTIyIDExVjNoLTd2M0g5VjNIMnY4aDdWOGgydjEwaDR2M2
                g3di04aC03djNoLTJWOGgydjN6Ij48L3BhdGg+Cjwvc3ZnPg=="
        />
      </g>

      <rect
        x="0.5"
        y="0.5"
        width="23"
        height="23"
        rx="3.5"
        stroke="#C7C7C7"
        strokeOpacity="0.5"
      />
      <defs>
        <filter
          id="filter0_d"
          x="-2"
          y="-2"
          width="30"
          height="30"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear"
          x1="11.5385"
          y1="0"
          x2="11.5385"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#F1F1F1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="12"
          y1="0"
          x2="12"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#ECECEC" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0">
          <rect width="24" height="24" rx="4" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DiagramIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      className={"svgButtonEffect"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <rect width="24" height="24" rx="4" fill="url(#paint0_linear)" />
        <rect width="24" height="24" rx="4" fill="url(#paint1_linear)" />
        <image
          id="image0"
          width="15"
          height="15"
          x="4"
          y="5"
          href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAD1BMVEUAAABUVFRSUlJSUlL///+VKb/TAAAABHRSTlMAQIDAY+6xoQAAAAFiS0dEBI9o2VEAAABjSURBVBjTdY/BCcAwEMPUTFAyQaPb4PYfro9LmlKofwIjY/jNoQ7o6klLTQiNi3aBILSC0Hyg69gw+obI2DV1ClJTS32oQ2sUgA9UbUIJCqa6YI4CEL6g+6qtC6zio163f3MDgYwPrahF5lEAAAAASUVORK5CYII=
                    "
        />
        {/* <image id="image0" width="15" height="15" x="4" y="5"
                    href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAElBMVEUAAABUVFRSUlJSUlJSUlL////D68YoAAAABHRSTlMAQIDAY+6xoQAAAAFiS0dEBfhv6ccAAABZSURBVBjTdc/RDYAwCATQ0wlMJ1DCCJ0Auv9MNoVqI3g/5CWXXgr8ZiOiCyj9HNhbawJwP2eEEtUHngRa9a0JC0eMURYbHfnAagn8aYOPRhRaavMLGZbRLDfAryMRSZ0G6QAAAABJRU5ErkJggg==" /> */}
      </g>
      <rect
        x="0.5"
        y="0.5"
        width="23"
        height="23"
        rx="3.5"
        stroke="#C7C7C7"
        strokeOpacity="0.5"
      />
      <defs>
        <filter
          id="filter0_d"
          x="-2"
          y="-2"
          width="30"
          height="30"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear"
          x1="11.5385"
          y1="0"
          x2="11.5385"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#F1F1F1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="12"
          y1="0"
          x2="12"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#ECECEC" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0">
          <rect width="24" height="24" rx="4" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CartBlackIcon = (props) => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1076_1137)">
        <path
          d="M10 30C11.1046 30 12 29.1046 12 28C12 26.8954 11.1046 26 10 26C8.89543 26 8 26.8954 8 28C8 29.1046 8.89543 30 10 30Z"
          fill="black"
        />
        <path
          d="M24 30C25.1046 30 26 29.1046 26 28C26 26.8954 25.1046 26 24 26C22.8954 26 22 26.8954 22 28C22 29.1046 22.8954 30 24 30Z"
          fill="black"
        />
        <path
          d="M4.9806 2.8039C4.93527 2.57721 4.81279 2.37322 4.63401 2.22666C4.45522 2.08009 4.23118 2 4 2H0V4H3.18L7.0194 23.1961C7.06473 23.4228 7.18721 23.6268 7.36599 23.7733C7.54478 23.9199 7.76882 24 8 24H26V22H8.82L8.02 18H26C26.2275 18 26.4482 17.9224 26.6257 17.7801C26.8032 17.6377 26.9268 17.4391 26.9762 17.217L29.2445 7H27.1971L25.1982 16H7.62L4.9806 2.8039Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1076_1137">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const QuoteBlackIcon = (props) => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1076_1131)">
        <path
          d="M10 30C11.1046 30 12 29.1046 12 28C12 26.8954 11.1046 26 10 26C8.89543 26 8 26.8954 8 28C8 29.1046 8.89543 30 10 30Z"
          fill="black"
        />
        <path
          d="M24 30C25.1046 30 26 29.1046 26 28C26 26.8954 25.1046 26 24 26C22.8954 26 22 26.8954 22 28C22 29.1046 22.8954 30 24 30Z"
          fill="black"
        />
        <path
          d="M4.9806 2.8039C4.93527 2.57721 4.81279 2.37322 4.63401 2.22666C4.45522 2.08009 4.23118 2 4 2H0V4H3.18L7.0194 23.1961C7.06473 23.4228 7.18721 23.6268 7.36599 23.7733C7.54478 23.9199 7.76882 24 8 24H26V22H8.82L8.02 18H26C26.2275 18 26.4482 17.9224 26.6257 17.7801C26.8032 17.6377 26.9268 17.4391 26.9762 17.217L29.2445 7H27.1971L25.1982 16H7.62L4.9806 2.8039Z"
          fill="black"
        />
        <path
          d="M21.586 6.586L18 10.172V2H16V10.172L12.414 6.586L11 8L17 14L23 8L21.586 6.586Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1076_1131">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ProcessOrderIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      className={"svgButtonEffect"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1241_1626)">
        <mask
          id="mask0_1241_1626"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="32"
          height="32"
        >
          <path
            d="M26.6667 0H5.33333C2.38781 0 0 2.38781 0 5.33333V26.6667C0 29.6122 2.38781 32 5.33333 32H26.6667C29.6122 32 32 29.6122 32 26.6667V5.33333C32 2.38781 29.6122 0 26.6667 0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_1241_1626)">
          <path
            d="M26.6667 0H5.33333C2.38781 0 0 2.38781 0 5.33333V26.6667C0 29.6122 2.38781 32 5.33333 32H26.6667C29.6122 32 32 29.6122 32 26.6667V5.33333C32 2.38781 29.6122 0 26.6667 0Z"
            fill="url(#paint0_linear_1241_1626)"
          />
          <path
            d="M26.6667 0H5.33333C2.38781 0 0 2.38781 0 5.33333V26.6667C0 29.6122 2.38781 32 5.33333 32H26.6667C29.6122 32 32 29.6122 32 26.6667V5.33333C32 2.38781 29.6122 0 26.6667 0Z"
            fill="url(#paint1_linear_1241_1626)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 8C14.3682 8 14.6667 8.29848 14.6667 8.66667V10H17.3333V8.66667C17.3333 8.29848 17.6318 8 18 8C18.3682 8 18.6667 8.29848 18.6667 8.66667V10H20C21.1046 10 22 10.8954 22 12V13.3333H23.3333C23.7015 13.3333 24 13.6318 24 14C24 14.3682 23.7015 14.6667 23.3333 14.6667H22V16.6667H23.3333C23.7015 16.6667 24 16.9651 24 17.3333C24 17.7015 23.7015 18 23.3333 18H22V20C22 21.1046 21.1046 22 20 22H18.6667V23.3333C18.6667 23.7015 18.3682 24 18 24C17.6318 24 17.3333 23.7015 17.3333 23.3333V22H14.6667V23.3333C14.6667 23.7015 14.3682 24 14 24C13.6318 24 13.3333 23.7015 13.3333 23.3333V22H12C10.8954 22 10 21.1046 10 20V18H8.66667C8.29848 18 8 17.7015 8 17.3333C8 16.9651 8.29848 16.6667 8.66667 16.6667H10V14.6667H8.66667C8.29848 14.6667 8 14.3682 8 14C8 13.6318 8.29848 13.3333 8.66667 13.3333H10V12C10 10.8954 10.8954 10 12 10H13.3333V8.66667C13.3333 8.29848 13.6318 8 14 8ZM12 11.3333C11.6318 11.3333 11.3333 11.6318 11.3333 12V20C11.3333 20.3682 11.6318 20.6667 12 20.6667H20C20.3682 20.6667 20.6667 20.3682 20.6667 20V12C20.6667 11.6318 20.3682 11.3333 20 11.3333H12ZM13.3333 14C13.3333 13.6318 13.6318 13.3333 14 13.3333H18C18.3682 13.3333 18.6667 13.6318 18.6667 14V18C18.6667 18.3682 18.3682 18.6667 18 18.6667H14C13.6318 18.6667 13.3333 18.3682 13.3333 18V14ZM14.6667 14.6667V17.3333H17.3333V14.6667H14.6667Z"
            fill="#525252"
          />
        </g>
        <path
          d="M26.6667 0.666656H5.33342C2.75609 0.666656 0.666748 2.75599 0.666748 5.33332V26.6667C0.666748 29.244 2.75609 31.3333 5.33342 31.3333H26.6667C29.2441 31.3333 31.3334 29.244 31.3334 26.6667V5.33332C31.3334 2.75599 29.2441 0.666656 26.6667 0.666656Z"
          stroke="#C7C7C7"
          stroke-opacity="0.5"
          strokeWidth="1.33333"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1241_1626"
          x1="15.3847"
          y1="0"
          x2="15.3847"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#F1F1F1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1241_1626"
          x1="16"
          y1="0"
          x2="16"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#ECECEC" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_1241_1626">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const EditIconNew = (props) => {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.45509 1.93945C9.30639 1.93945 9.16379 1.99852 9.05864 2.10367L2.90657 8.25574L2.64227 9.31293L3.69946 9.04863L9.85154 2.89656C9.9036 2.8445 9.94489 2.78269 9.97307 2.71467C10.0012 2.64665 10.0157 2.57374 10.0157 2.50011C10.0157 2.42649 10.0012 2.35358 9.97307 2.28556C9.94489 2.21754 9.9036 2.15573 9.85154 2.10367C9.79947 2.0516 9.73767 2.01031 9.66964 1.98213C9.60162 1.95395 9.52872 1.93945 9.45509 1.93945ZM8.35154 1.39656C8.64422 1.10388 9.04118 0.939453 9.45509 0.939453C9.66004 0.939453 9.86298 0.979821 10.0523 1.05825C10.2417 1.13668 10.4137 1.25164 10.5586 1.39656C10.7036 1.54148 10.8185 1.71353 10.897 1.90287C10.9754 2.09222 11.0157 2.29516 11.0157 2.50011C11.0157 2.70506 10.9754 2.908 10.897 3.09735C10.8185 3.2867 10.7036 3.45875 10.5586 3.60367L4.30864 9.85367C4.24456 9.91775 4.16427 9.96321 4.07636 9.98518L2.07636 10.4852C1.90597 10.5278 1.72573 10.4779 1.60154 10.3537C1.47735 10.2295 1.42742 10.0492 1.47002 9.87885L1.97002 7.87885C1.992 7.79093 2.03746 7.71064 2.10154 7.64656L8.35154 1.39656ZM5.95509 10.0001C5.95509 9.72397 6.17895 9.50011 6.45509 9.50011H10.9551C11.2312 9.50011 11.4551 9.72397 11.4551 10.0001C11.4551 10.2763 11.2312 10.5001 10.9551 10.5001H6.45509C6.17895 10.5001 5.95509 10.2763 5.95509 10.0001Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DeleteIconNew = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 1.5C4 1.22386 4.22386 1 4.5 1H7.5C7.77614 1 8 1.22386 8 1.5C8 1.77614 7.77614 2 7.5 2H4.5C4.22386 2 4 1.77614 4 1.5ZM2.49612 2.5H1.5C1.22386 2.5 1 2.72386 1 3C1 3.27614 1.22386 3.5 1.5 3.5H2.03222L2.35307 8.31272C2.37825 8.69044 2.39908 9.00302 2.43644 9.25744C2.47533 9.52234 2.53702 9.76441 2.66555 9.99C2.86562 10.3412 3.16739 10.6235 3.53111 10.7998C3.76476 10.913 4.0104 10.9585 4.2773 10.9797C4.53364 11 4.84691 11 5.22547 11H6.77453C7.15309 11 7.46636 11 7.7227 10.9797C7.9896 10.9585 8.23524 10.913 8.46889 10.7998C8.83261 10.6235 9.13439 10.3412 9.33446 9.99C9.46298 9.76441 9.52467 9.52234 9.56356 9.25744C9.60092 9.003 9.62176 8.6904 9.64693 8.31265L9.96778 3.5H10.5C10.7761 3.5 11 3.27614 11 3C11 2.72386 10.7761 2.5 10.5 2.5H9.50388C9.50096 2.49997 9.49804 2.49997 9.49513 2.5H2.50487C2.50196 2.49997 2.49904 2.49997 2.49612 2.5ZM8.96556 3.5H3.03444L3.34954 8.22639C3.37637 8.62889 3.39492 8.90168 3.42583 9.11217C3.45585 9.31663 3.49252 9.42143 3.53444 9.495C3.63447 9.6706 3.78536 9.81176 3.96722 9.89989C4.04342 9.93682 4.15043 9.96645 4.35643 9.9828C4.56851 9.99963 4.84193 10 5.24533 10H6.75467C7.15807 10 7.43149 9.99963 7.64357 9.9828C7.84957 9.96645 7.95658 9.93682 8.03278 9.89989C8.21464 9.81176 8.36553 9.6706 8.46556 9.495C8.50748 9.42143 8.54415 9.31663 8.57417 9.11217C8.60508 8.90168 8.62363 8.62889 8.65046 8.22639L8.96556 3.5ZM5 4.75C5.27614 4.75 5.5 4.97386 5.5 5.25V7.75C5.5 8.02614 5.27614 8.25 5 8.25C4.72386 8.25 4.5 8.02614 4.5 7.75V5.25C4.5 4.97386 4.72386 4.75 5 4.75ZM7 4.75C7.27614 4.75 7.5 4.97386 7.5 5.25V7.75C7.5 8.02614 7.27614 8.25 7 8.25C6.72386 8.25 6.5 8.02614 6.5 7.75V5.25C6.5 4.97386 6.72386 4.75 7 4.75Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const PlusIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 2C6.27614 2 6.5 2.22386 6.5 2.5V5.5H9.5C9.77614 5.5 10 5.72386 10 6C10 6.27614 9.77614 6.5 9.5 6.5H6.5V9.5C6.5 9.77614 6.27614 10 6 10C5.72386 10 5.5 9.77614 5.5 9.5V6.5H2.5C2.22386 6.5 2 6.27614 2 6C2 5.72386 2.22386 5.5 2.5 5.5H5.5V2.5C5.5 2.22386 5.72386 2 6 2Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CartIcon = (props) => {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_36_5803)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.48535 1.50001H1.95508C1.67894 1.50001 1.45508 1.27615 1.45508 1.00001C1.45508 0.723863 1.67894 0.500006 1.95508 0.500006H2.5793C2.58292 0.500006 2.5866 0.500004 2.59033 0.500003C2.64651 0.499981 2.71428 0.499955 2.77426 0.504725C2.84429 0.510295 2.94332 0.524533 3.04814 0.575493C3.18483 0.641948 3.29811 0.748366 3.37296 0.880649C3.43036 0.982087 3.45075 1.08003 3.46067 1.14958C3.46918 1.20914 3.47338 1.27678 3.47686 1.33285C3.47709 1.33658 3.47732 1.34025 3.47755 1.34386L3.51855 2.00001L11.5207 2C11.5868 1.99998 11.6641 1.99995 11.7316 2.0057C11.8087 2.01226 11.9219 2.0292 12.0382 2.09342C12.1869 2.17546 12.3032 2.30549 12.3684 2.46224C12.4193 2.58495 12.4237 2.69938 12.4217 2.77666C12.4199 2.84443 12.4114 2.9213 12.4041 2.98694L12.1082 5.6498C12.0819 5.88619 12.0591 6.0914 12.027 6.26023C11.9928 6.43941 11.9419 6.61542 11.8398 6.78237C11.6864 7.03331 11.4626 7.23362 11.1963 7.35838C11.0191 7.44138 10.8385 7.47256 10.6567 7.4867C10.4853 7.50002 10.2788 7.50001 10.041 7.50001H3.8623L3.9248 8.50001H10.4551C10.7312 8.50001 10.9551 8.72386 10.9551 9.00001C10.9551 9.27615 10.7312 9.50001 10.4551 9.50001L3.81984 9.50001C3.76366 9.50003 3.69588 9.50006 3.6359 9.49529C3.56587 9.48972 3.46684 9.47548 3.36202 9.42452C3.22533 9.35806 3.11205 9.25165 3.0372 9.11936C2.9798 9.01793 2.95941 8.91998 2.94948 8.85043C2.94098 8.79087 2.93678 8.72323 2.9333 8.66716C2.93307 8.66343 2.93284 8.65976 2.93261 8.65615L2.48535 1.50001ZM2.47949 1.40624L2.52291 1.40353C2.53884 1.42401 2.55787 1.44188 2.5793 1.45651C2.58933 1.46335 2.59989 1.46949 2.61091 1.47484C2.63679 1.48743 2.65979 1.49441 2.67624 1.49815C2.6885 1.50094 2.6961 1.50168 2.6961 1.50168L2.69498 1.50158M3.7998 6.50001H10.023C10.284 6.50001 10.4512 6.49966 10.5792 6.48971C10.7009 6.48024 10.7477 6.46422 10.7721 6.4528C10.8609 6.41121 10.9355 6.34444 10.9866 6.2608C11.0007 6.23783 11.0218 6.19306 11.0446 6.07309C11.0686 5.94703 11.0875 5.78085 11.1163 5.52148L11.3964 3.00001H3.58105L3.7998 6.50001ZM3.95508 10.75C3.95508 10.3358 4.29086 10 4.70508 10C5.11929 10 5.45508 10.3358 5.45508 10.75C5.45508 11.1642 5.11929 11.5 4.70508 11.5C4.29086 11.5 3.95508 11.1642 3.95508 10.75ZM8.45508 10.75C8.45508 10.3358 8.79086 10 9.20508 10C9.61929 10 9.95508 10.3358 9.95508 10.75C9.95508 11.1642 9.61929 11.5 9.20508 11.5C8.79086 11.5 8.45508 11.1642 8.45508 10.75Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_36_5803">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(0.955078)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const QuoteIcon = (props) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ verticalAlign: "sub", marginRight: "6px" }}
    >
      <g clipPath="url(#clip0_395_13150)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.38883 2.70957C8.25322 2.67702 8.10142 2.67273 7.58051 2.67273L4.90599 2.67273C4.5378 2.67273 4.23933 2.37425 4.23933 2.00606C4.23933 1.63787 4.5378 1.3394 4.90599 1.3394L7.58051 1.3394C7.60345 1.3394 7.62608 1.33939 7.64843 1.33938C8.07176 1.33917 8.39162 1.33902 8.70009 1.41308C8.97218 1.4784 9.2323 1.58615 9.47089 1.73236C9.74137 1.89811 9.96744 2.12439 10.2666 2.42387C10.2824 2.43968 10.2984 2.4557 10.3147 2.47192L15.3774 7.53466C15.6377 7.79501 15.6377 8.21712 15.3774 8.47747C15.117 8.73782 14.6949 8.73782 14.4346 8.47747L9.37185 3.41473C9.0035 3.04639 8.89314 2.94208 8.77423 2.86921C8.65493 2.79611 8.52487 2.74223 8.38883 2.70957ZM7.50934 5.02448C7.45046 5.01035 7.38019 5.00606 7.02234 5.00606H5.03933C4.65496 5.00606 4.40677 5.00658 4.21788 5.02202C4.03677 5.03681 3.96963 5.06193 3.93667 5.07873C3.81122 5.14264 3.70924 5.24463 3.64532 5.37007C3.62853 5.40303 3.60341 5.47018 3.58861 5.65129C3.57318 5.84018 3.57266 6.08836 3.57266 6.47273L3.57266 7.78907C3.57266 8.14693 3.57694 8.2172 3.59108 8.27608C3.60741 8.3441 3.63435 8.40913 3.6709 8.46878C3.70254 8.52041 3.7492 8.57312 4.00224 8.82617L9.20224 14.0262C9.47403 14.298 9.64988 14.4731 9.79436 14.5957C9.93289 14.7133 9.99813 14.7431 10.0333 14.7545C10.1672 14.798 10.3114 14.798 10.4453 14.7545C10.4805 14.7431 10.5458 14.7133 10.6843 14.5957C10.8288 14.4731 11.0046 14.298 11.2764 14.0262L12.9261 12.3765C13.1979 12.1047 13.373 11.9288 13.4957 11.7844C13.6133 11.6458 13.643 11.5806 13.6544 11.5454C13.6979 11.4115 13.6979 11.2673 13.6544 11.1334C13.643 11.0982 13.6133 11.033 13.4957 10.8944C13.373 10.75 13.1979 10.5741 12.9261 10.3023L8.05943 5.43564C7.80639 5.1826 7.75367 5.13594 7.70204 5.1043C7.64239 5.06775 7.57736 5.04082 7.50934 5.02448ZM7.07787 3.6727C7.34914 3.67244 7.5883 3.67222 7.8206 3.72799C8.02467 3.77698 8.21976 3.85779 8.39871 3.96745C8.6024 4.09227 8.77135 4.26154 8.96299 4.45353C8.97596 4.46653 8.98904 4.47963 9.00224 4.49283L13.887 9.37764C14.1356 9.62614 14.35 9.84052 14.5121 10.0315C14.6833 10.2331 14.835 10.4521 14.9225 10.7214C15.053 11.1231 15.053 11.5557 14.9225 11.9574C14.835 12.2267 14.6833 12.4457 14.5121 12.6473C14.35 12.8383 14.1356 13.0526 13.8871 13.3011L12.201 14.9872C11.9526 15.2357 11.7382 15.45 11.5472 15.6122C11.3456 15.7833 11.1266 15.9351 10.8574 16.0226C10.4557 16.1531 10.023 16.1531 9.62129 16.0226C9.35204 15.9351 9.13305 15.7833 8.93146 15.6122C8.74046 15.45 8.5261 15.2357 8.27762 14.9872L3.05943 9.76897C3.04623 9.75578 3.03313 9.7427 3.02013 9.72973C2.82814 9.53809 2.65887 9.36914 2.53405 9.16544C2.42439 8.9865 2.34358 8.79141 2.29459 8.58734C2.23882 8.35504 2.23904 8.11587 2.23929 7.84461C2.23931 7.82625 2.23933 7.80774 2.23933 7.78907L2.23933 6.44704C2.23931 6.0956 2.2393 5.79243 2.25971 5.54271C2.28124 5.27915 2.32878 5.017 2.45731 4.76475C2.64906 4.38843 2.95502 4.08246 3.33134 3.89072C3.5836 3.76219 3.84574 3.71464 4.10931 3.69311C4.35902 3.67271 4.6622 3.67272 5.01363 3.67273L7.02234 3.67273C7.041 3.67273 7.05951 3.67271 7.07787 3.6727Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_395_13150">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.90625 0.672852)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const EditSpecialPrice = (props) => {
  return (
    // <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    // <g clipPath="url(#clip0_72_6124)">
    // <path d="M8.71236 12.684H7.1024V11.6306C6.48557 11.5758 5.84344 11.3992 5.40781 11.1585L5.22122 11.0554L5.68645 9.24112L5.99757 9.41148C6.2987 9.57638 6.91499 9.85306 7.65887 9.85306C8.04344 9.85306 8.43144 9.73113 8.43144 9.45868C8.43144 9.27601 8.31404 9.06737 7.46264 8.77969C6.47008 8.44574 5.3304 7.88944 5.3304 6.54134C5.3304 5.49218 6.0238 4.6867 7.15644 4.39682V3.31604H8.7664V4.28171C9.44955 4.33695 9.8979 4.51431 10.1856 4.64968L10.3936 4.74755L9.92511 6.51232L9.6146 6.36337C9.34498 6.23395 8.89371 6.01731 8.18828 6.01731C7.94417 6.01731 7.53461 6.06152 7.53461 6.35765C7.53461 6.58171 8.13071 6.82784 8.65008 7.01726C10.0408 7.50398 10.6356 8.18928 10.6356 9.3074C10.6356 9.86423 10.4403 10.3694 10.0706 10.7683C9.73645 11.1289 9.2701 11.3863 8.71236 11.52V12.684ZM7.65346 12.1329H8.1613V11.0634L8.39 11.024C9.43524 10.8438 10.0845 10.186 10.0845 9.30739C10.0845 8.58458 9.8091 8.00672 8.46466 7.53618C7.65277 7.24008 6.98355 6.94799 6.98355 6.35765C6.98355 5.92671 7.30006 5.46624 8.18829 5.46624C8.79494 5.46624 9.24782 5.60504 9.56148 5.73443L9.74122 5.05756C9.45893 4.94678 9.05532 4.83492 8.48265 4.81785L8.21536 4.80986V3.86711H7.70752V4.84684L7.48259 4.88888C6.48002 5.07628 5.88145 5.69403 5.88145 6.54134C5.88145 7.32987 6.40699 7.84312 7.63869 8.25746C8.3368 8.49332 8.98249 8.80207 8.98249 9.45868C8.98249 10.033 8.46296 10.4041 7.65887 10.4041C7.00303 10.4041 6.43562 10.2213 6.04793 10.05L5.86366 10.7687C6.21799 10.9234 6.76748 11.0773 7.38615 11.0957L7.65345 11.1037V12.1329H7.65346Z" fill="currentColor"/>
    // <path d="M7.95056 15.3033C3.92354 15.3033 0.64731 12.027 0.64731 8.00003C0.64731 3.97297 3.92354 0.696742 7.95056 0.696742C11.9776 0.696742 15.2539 3.97297 15.2539 8.00003C15.2539 9.28356 14.9207 10.4906 14.3368 11.5398L14.8843 11.6865C15.4715 10.5865 15.805 9.33154 15.805 8.00003C15.805 3.66915 12.2815 0.145676 7.95056 0.145676C3.61968 0.145676 0.0962524 3.66915 0.0962524 8.00003C0.0962524 12.3309 3.61968 15.8543 7.95056 15.8543C9.32647 15.8543 10.6206 15.4983 11.7464 14.8741L11.5992 14.3247C10.525 14.9468 9.27865 15.3033 7.95056 15.3033Z" fill="currentColor"/>
    // <path d="M14.7698 15.8543C14.6993 15.8543 14.6288 15.8274 14.5749 15.7737L13.2387 14.4374L12.8088 15.3306C12.7589 15.4345 12.6491 15.4964 12.5348 15.4855C12.4201 15.4748 12.3242 15.3937 12.2944 15.2825L11.3061 11.5941C11.2807 11.499 11.3079 11.3975 11.3774 11.3279C11.4471 11.2582 11.5485 11.2311 11.6436 11.2566L15.332 12.2449C15.4432 12.2747 15.5242 12.3707 15.535 12.4854C15.5457 12.6001 15.4839 12.7094 15.3801 12.7594L14.4868 13.1893L15.8231 14.5255C15.8748 14.5772 15.9038 14.6473 15.9038 14.7203C15.9038 14.7934 15.8748 14.8634 15.8231 14.9152L14.9646 15.7737C14.9108 15.8274 14.8402 15.8543 14.7698 15.8543ZM13.1588 13.6924C13.2313 13.6924 13.3015 13.721 13.3537 13.7731L14.7698 15.1892L15.2386 14.7203L13.8225 13.3043C13.7594 13.2411 13.7307 13.1513 13.7457 13.0632C13.7607 12.9752 13.8174 12.8999 13.8979 12.8612L14.4718 12.5849L11.9619 11.9124L12.6344 14.4222L12.9105 13.8484C12.9493 13.7679 13.0246 13.7113 13.1126 13.6963C13.128 13.6937 13.1435 13.6924 13.1588 13.6924Z" fill="currentColor"/>
    // <path d="M10.136 2.6004C11.1247 2.6004 13.0492 3.68161 13.0492 5.6636C13.0492 5.81578 13.1725 5.93913 13.3247 5.93913C13.4769 5.93913 13.6003 5.81578 13.6003 5.6636C13.6003 4.63193 13.1443 3.67546 12.3164 2.97033C11.6595 2.41085 10.8037 2.04933 10.136 2.04933C9.98384 2.04933 9.86044 2.17268 9.86044 2.32487C9.86044 2.47706 9.98385 2.6004 10.136 2.6004Z" fill="currentColor"/>
    // </g>
    // <defs>
    // <clipPath id="clip0_72_6124">
    // <rect width="16" height="16" fill="transparent"/>
    // </clipPath>
    // </defs>
    // </svg>
    // <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    // <g clipPath="url(#clip0_72_6096)">
    // <path d="M15.7888 0.0781416C15.6845 -0.0261286 15.516 -0.0261286 15.4117 0.0781416L14.4231 1.06671H8.21413L0.408532 8.93657C0.230927 9.11418 0.133057 9.35072 0.133057 9.60193C0.133057 9.85313 0.230927 10.0897 0.408532 10.2673L5.86631 15.7251C6.04952 15.9083 6.28979 16 6.5306 16C6.77248 16 7.01435 15.9075 7.19969 15.7224L14.8002 7.91654V1.44379L15.7888 0.455221C15.893 0.350951 15.893 0.182412 15.7888 0.0781416ZM14.2669 7.7L6.81995 15.348C6.66101 15.5069 6.40233 15.5069 6.24339 15.348L0.785612 9.8902C0.626673 9.73126 0.626673 9.47259 0.786412 9.31285L8.43653 1.60006H13.8898L12.6009 2.8889C12.39 2.74916 12.138 2.66676 11.8668 2.66676C11.1316 2.66676 10.5334 3.26491 10.5334 4.00014C10.5334 4.73536 11.1316 5.33352 11.8668 5.33352C12.602 5.33352 13.2002 4.73536 13.2002 4.00014C13.2002 3.72893 13.1178 3.47692 12.978 3.26598L14.2669 1.97714V7.7ZM12.6668 4.00014C12.6668 4.44122 12.3079 4.80017 11.8668 4.80017C11.4257 4.80017 11.0668 4.44122 11.0668 4.00014C11.0668 3.55906 11.4257 3.20011 11.8668 3.20011C11.99 3.20011 12.1052 3.23051 12.2095 3.28038L11.6782 3.8116C11.574 3.91587 11.574 4.08441 11.6782 4.18868C11.7302 4.24068 11.7985 4.26681 11.8668 4.26681C11.935 4.26681 12.0033 4.24068 12.0553 4.18868L12.5865 3.65746C12.6367 3.76173 12.6668 3.87693 12.6668 4.00014Z" fill="currentColor"/>
    // <path d="M11.2659 8.3419L8.43758 11.1705C8.33331 11.2748 8.33331 11.4433 8.43758 11.5476C8.48958 11.5996 8.55785 11.6257 8.62612 11.6257C8.69439 11.6257 8.76266 11.5996 8.81466 11.5476L11.643 8.71898C11.7473 8.61471 11.7473 8.44617 11.643 8.3419C11.5387 8.23763 11.3702 8.23789 11.2659 8.3419Z" fill="currentColor"/>
    // <path d="M12.2081 7.39758C12.1599 7.44798 12.1308 7.51732 12.1308 7.58692C12.1308 7.65892 12.1599 7.72799 12.2081 7.77626C12.2585 7.82666 12.3279 7.8536 12.3975 7.8536C12.4668 7.8536 12.5361 7.82666 12.5839 7.77626C12.6345 7.72799 12.6641 7.65892 12.6641 7.58692C12.6641 7.51732 12.6348 7.44798 12.5839 7.39758C12.4852 7.29891 12.3095 7.29891 12.2081 7.39758Z" fill="currentColor"/>
    // <path d="M9.9459 5.13619C10.0502 5.03192 10.0502 4.86338 9.9459 4.75911C9.84163 4.65484 9.67309 4.65484 9.56882 4.75911L6.74019 7.58774C6.63592 7.69201 6.63592 7.86055 6.74019 7.96482C6.79219 8.01682 6.86046 8.04295 6.92873 8.04295C6.997 8.04295 7.06527 8.01682 7.11727 7.96482L9.9459 5.13619Z" fill="currentColor"/>
    // <path d="M9.00322 8.34189C9.05522 8.39389 9.12349 8.42003 9.19176 8.42003C9.26003 8.42003 9.3283 8.39389 9.3803 8.34189L11.266 6.45623C11.3702 6.35196 11.3702 6.18342 11.266 6.07915C11.1617 5.97488 10.9932 5.97488 10.8889 6.07915L9.00322 7.96481C8.89895 8.06908 8.89895 8.23789 9.00322 8.34189Z" fill="currentColor"/>
    // <path d="M7.49465 9.47312L7.11757 9.8502C7.0133 9.95447 7.0133 10.123 7.11757 10.2273C7.16957 10.2793 7.23784 10.3054 7.30611 10.3054C7.37438 10.3054 7.44265 10.2793 7.49465 10.2273L7.87173 9.8502C7.976 9.74593 7.976 9.57739 7.87173 9.47312C7.76746 9.36885 7.59865 9.36912 7.49465 9.47312Z" fill="currentColor"/>
    // <path d="M4.666 7.6656C4.73427 7.6656 4.80254 7.63946 4.85454 7.58746L7.6829 4.7591C7.78717 4.65483 7.78717 4.48629 7.6829 4.38202C7.57863 4.27775 7.41009 4.27775 7.30582 4.38202L4.47746 7.21038C4.37319 7.31465 4.37319 7.48319 4.47746 7.58746C4.52947 7.63946 4.59773 7.6656 4.666 7.6656Z" fill="currentColor"/>
    // <path d="M8.43733 3.89347C8.50667 3.89347 8.57627 3.86681 8.62667 3.81614C8.67494 3.76573 8.70401 3.69907 8.70401 3.6268C8.70401 3.55746 8.67494 3.48813 8.624 3.43746C8.52533 3.33879 8.34933 3.33879 8.24799 3.44012C8.19999 3.48839 8.17065 3.55746 8.17065 3.6268C8.17065 3.69613 8.19999 3.76573 8.24799 3.81614C8.29866 3.86681 8.36799 3.89347 8.43733 3.89347Z" fill="currentColor"/>
    // <path d="M5.98658 8.34163C5.93591 8.39203 5.90924 8.4587 5.90924 8.53097C5.90924 8.60297 5.93591 8.66964 5.98658 8.71737C6.03458 8.76804 6.10365 8.79764 6.17592 8.79764C6.24525 8.79764 6.31459 8.76831 6.36232 8.72031C6.41299 8.66964 6.44259 8.6003 6.44259 8.53097C6.44259 8.46136 6.41326 8.39203 6.36232 8.34163C6.26392 8.24296 6.08498 8.24296 5.98658 8.34163Z" fill="currentColor"/>
    // <path d="M8.62667 9.09605C8.67494 9.04805 8.70401 8.97898 8.70401 8.90671C8.70401 8.83738 8.67494 8.76804 8.62667 8.71737C8.52533 8.6187 8.34933 8.6187 8.24799 8.71737C8.19999 8.76804 8.17065 8.83738 8.17065 8.90671C8.17065 8.97898 8.19999 9.04565 8.24799 9.09605C8.29866 9.14672 8.36799 9.17339 8.43733 9.17339C8.50667 9.17339 8.576 9.14699 8.62667 9.09605Z" fill="currentColor"/>
    // <path d="M6.57381 12.701C6.73781 12.4532 6.81622 12.1567 6.79088 11.8551C6.77008 11.6033 6.64874 11.3759 6.44954 11.2142C6.24553 11.0492 5.97779 10.9734 5.71938 11.006L4.97216 11.0993L3.94652 10.0737C4.2436 9.93261 4.60921 9.98194 4.85482 10.2275C4.95909 10.3318 5.12763 10.3318 5.2319 10.2275C5.33617 10.1233 5.33617 9.95474 5.2319 9.85047C4.77668 9.39525 4.07133 9.33899 3.55371 9.68113L3.34597 9.47339C3.2417 9.36912 3.07316 9.36912 2.96889 9.47339C2.86462 9.57766 2.86462 9.7462 2.96889 9.85047L3.17716 10.0587C3.01342 10.3062 2.93502 10.603 2.96035 10.9046C2.98116 11.1561 3.10249 11.3839 3.30143 11.5452C3.50544 11.7103 3.77158 11.7863 4.03186 11.754L4.77908 11.6607L5.80205 12.6836C5.50577 12.8172 5.13269 12.7684 4.89642 12.5322C4.79215 12.4279 4.62361 12.4279 4.51934 12.5322C4.41507 12.6362 4.41507 12.805 4.51934 12.9092C4.77082 13.161 5.10576 13.2999 5.46204 13.2999C5.72765 13.2999 5.98099 13.2223 6.19726 13.0788L6.36313 13.2447C6.41514 13.2967 6.48341 13.3229 6.55167 13.3229C6.61994 13.3229 6.68821 13.2967 6.74021 13.2447C6.84448 13.1404 6.84448 12.9719 6.74021 12.8676L6.57381 12.701ZM3.96572 11.2249C3.84892 11.2393 3.72865 11.2057 3.63744 11.131C3.55237 11.0617 3.50037 10.9657 3.49157 10.8601C3.47984 10.7172 3.51024 10.5777 3.57024 10.4516L4.30147 11.1828L3.96572 11.2249ZM5.78552 11.5351C5.90099 11.5193 6.02179 11.5543 6.11326 11.6287C6.1986 11.698 6.2506 11.794 6.2594 11.8996C6.27113 12.0425 6.24073 12.182 6.18046 12.3082L5.4495 11.5772L5.78552 11.5351Z" fill="currentColor"/>
    // </g>
    // <defs>
    // <clipPath id="clip0_72_6096">
    // <rect width="16" height="16" fill="transparent"/>
    // </clipPath>
    // </defs>
    // </svg>
    // <svg width="16" height="16" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    // 	<g clipPath="url(#clip0_64_6050)">
    // 		<path
    // 			d="M11.8418 0.0586072C11.7636 -0.0195968 11.6372 -0.0195968 11.559 0.0586072L10.8173 0.800044H6.16071L0.30642 6.70254C0.173013 6.83575 0.0996094 7.01316 0.0996094 7.20157C0.0996094 7.38997 0.173013 7.56738 0.30642 7.70059L4.39982 11.794C4.53723 11.9314 4.71744 12 4.89805 12C5.07926 12 5.26087 11.9308 5.39967 11.792L11.1002 5.9375V1.08286L11.8416 0.341421C11.9198 0.263217 11.9198 0.136811 11.8418 0.0586072ZM4.68264 11.5112L0.589234 7.41778C0.531431 7.35997 0.499629 7.28317 0.499629 7.20157C0.499629 7.11996 0.531431 7.04316 0.589834 6.98475L2.35992 5.20006L6.86915 9.70949L5.11486 11.5112C4.99585 11.6302 4.80185 11.6302 4.68264 11.5112ZM10.7003 5.77509L7.14836 9.42288L2.64174 4.91605L6.32732 1.20006H10.4175L9.45088 2.16671C9.29267 2.06191 9.10366 2.0001 8.90025 2.0001C8.34882 2.0001 7.9002 2.44873 7.9002 3.00015C7.9002 3.55158 8.34882 4.0002 8.90025 4.0002C9.45168 4.0002 9.9003 3.55158 9.9003 3.00015C9.9003 2.79674 9.8385 2.60773 9.73369 2.44953L10.7003 1.48288V5.77509ZM9.50028 3.00015C9.50028 3.33097 9.23107 3.60018 8.90025 3.60018C8.56943 3.60018 8.30022 3.33097 8.30022 3.00015C8.30022 2.66934 8.56943 2.40012 8.90025 2.40012C8.99265 2.40012 9.07906 2.42293 9.15726 2.46033L8.75884 2.85875C8.68064 2.93695 8.68064 3.06336 8.75884 3.14156C8.79784 3.18056 8.84905 3.20016 8.90025 3.20016C8.95145 3.20016 9.00266 3.18056 9.04166 3.14156L9.44008 2.74314C9.47748 2.82135 9.50028 2.90775 9.50028 3.00015Z"
    // 			fill="currentColor"
    // 			stroke="currentColor"
    // 			strokeWidth="0.25"
    // 		/>
    // 	</g>
    // 	<defs>
    // 		<clipPath id="clip0_64_6050">
    // 			<rect width="12" height="12" fill="white" />
    // 		</clipPath>
    // 	</defs>
    // </svg>
    <svg
      width="18"
      height="18"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 2.5C2.83268 2.99816 3.45449 3.33333 4.16667 3.33333C4.87884 3.33333 5.50065 2.99816 5.83333 2.5C6.08284 2.00183 6.5492 1.66666 7.08333 1.66666C7.61747 1.66666 8.08382 2.00183 8.33333 2.5C8.666 2.99816 9.28783 3.33333 10 3.33333C10.7122 3.33333 11.334 2.99816 11.6667 2.5C11.9162 2.00183 12.3825 1.66666 12.9167 1.66666C13.4508 1.66666 13.9172 2.00183 14.1667 2.5C14.4993 2.99816 15.1212 3.33333 15.8333 3.33333C16.5455 3.33333 17.1673 2.99816 17.5 2.5V17.5C17.1673 17.0018 16.5455 16.6667 15.8333 16.6667C15.1212 16.6667 14.4993 17.0018 14.1667 17.5C13.9172 17.9982 13.4508 18.3333 12.9167 18.3333C12.3825 18.3333 11.9162 17.9982 11.6667 17.5C11.334 17.0018 10.7122 16.6667 10 16.6667C9.28783 16.6667 8.666 17.0018 8.33333 17.5C8.08382 17.9982 7.61747 18.3333 7.08333 18.3333C6.5492 18.3333 6.08284 17.9982 5.83333 17.5C5.50065 17.0018 4.87884 16.6667 4.16667 16.6667C3.45449 16.6667 2.83268 17.0018 2.5 17.5V2.5Z"
        stroke="currentColor"
        stroke-width="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 5.41666V14.3333"
        stroke="currentColor"
        stroke-width="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 6.49999H9.12C8.2253 6.49999 7.5 7.28349 7.5 8.24999C7.5 9.2165 8.2253 10 9.12 10H10.7693C11.7251 10 12.5 10.7835 12.5 11.75C12.5 12.7165 11.7251 13.5 10.7693 13.5H7.5"
        stroke="currentColor"
        stroke-width="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ViewIconNew = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 13.5C3 13.5 0 8 0 8C0 8 3 2.5 8 2.5C13 2.5 16 8 16 8C16 8 13 13.5 8 13.5ZM8 12.5C11.52 12.5 14.002 9.249 14.825 8C14.003 6.752 11.521 3.5 8 3.5C4.48 3.5 1.998 6.751 1.175 8C1.997 9.248 4.479 12.5 8 12.5ZM8 11.5C7.07174 11.5 6.1815 11.1313 5.52513 10.4749C4.86875 9.8185 4.5 8.92826 4.5 8C4.5 7.07174 4.86875 6.1815 5.52513 5.52513C6.1815 4.86875 7.07174 4.5 8 4.5C8.92826 4.5 9.8185 4.86875 10.4749 5.52513C11.1313 6.1815 11.5 7.07174 11.5 8C11.5 8.92826 11.1313 9.8185 10.4749 10.4749C9.8185 11.1313 8.92826 11.5 8 11.5ZM8 10.5C8.6628 10.4992 9.29822 10.2356 9.76689 9.76689C10.2356 9.29822 10.4992 8.6628 10.5 8C10.5 6.622 9.379 5.5 8 5.5C6.621 5.5 5.5 6.622 5.5 8C5.5 9.378 6.621 10.5 8 10.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DownIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.66666 6.66667L7.99999 10L11.3333 6.66667"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UpIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3333 9.33333L8.00001 6L4.66668 9.33333"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DownloadIconNew = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 1C6.27614 1 6.5 1.22386 6.5 1.5V7.29289L8.64645 5.14645C8.84171 4.95118 9.15829 4.95118 9.35355 5.14645C9.54882 5.34171 9.54882 5.65829 9.35355 5.85355L6.35355 8.85355C6.15829 9.04882 5.84171 9.04882 5.64645 8.85355L2.64645 5.85355C2.45118 5.65829 2.45118 5.34171 2.64645 5.14645C2.84171 4.95118 3.15829 4.95118 3.35355 5.14645L5.5 7.29289V1.5C5.5 1.22386 5.72386 1 6 1ZM1 10.5C1 10.2239 1.22386 10 1.5 10H10.5C10.7761 10 11 10.2239 11 10.5C11 10.7761 10.7761 11 10.5 11H1.5C1.22386 11 1 10.7761 1 10.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ShiftIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 8H2M14 8L12 10M14 8L12 6M2 8L4 6M2 8L4 10"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SuspendIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00001 1.60001C4.4717 1.60001 1.60001 4.4717 1.60001 8.00001C1.60001 11.5283 4.4717 14.4 8.00001 14.4C11.5283 14.4 14.4 11.5283 14.4 8.00001C14.4 4.4717 11.5283 1.60001 8.00001 1.60001ZM8.00001 2.66667C9.2834 2.66667 10.4582 3.11725 11.3771 3.86876L3.86876 11.3771C3.11725 10.4582 2.66667 9.2834 2.66667 8.00001C2.66667 5.04817 5.04817 2.66667 8.00001 2.66667ZM12.1313 4.62292C12.8828 5.54184 13.3333 6.71661 13.3333 8.00001C13.3333 10.9518 10.9518 13.3333 8.00001 13.3333C6.71661 13.3333 5.54184 12.8828 4.62292 12.1313L12.1313 4.62292Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ResumeIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.86193 0.861932C7.12227 0.601585 7.5444 0.601585 7.80473 0.861932L9.80473 2.86193C9.92973 2.98696 10 3.15653 10 3.33334C10 3.51015 9.92973 3.67972 9.80473 3.80475L7.80473 5.80475C7.5444 6.06509 7.12227 6.06509 6.86193 5.80475C6.60158 5.54439 6.60158 5.12229 6.86193 4.86193L7.71533 4.00855C5.27056 4.15567 3.33333 6.18494 3.33333 8.66667C3.33333 11.244 5.42267 13.3333 8 13.3333C10.5773 13.3333 12.6667 11.244 12.6667 8.66667C12.6667 8.29847 12.9651 8.00001 13.3333 8.00001C13.7015 8.00001 14 8.29847 14 8.66667C14 11.9804 11.3137 14.6667 8 14.6667C4.68629 14.6667 2 11.9804 2 8.66667C2 5.4435 4.54151 2.81393 7.7298 2.67265L6.86193 1.80475C6.60158 1.54439 6.60158 1.12229 6.86193 0.861932Z"
        fill="currentColor"
      />
    </svg>
  );
};

///////

export const Products = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.31137 3.26693C2.28683 3.26693 2.26693 3.28683 2.26693 3.31137V12.0003C2.26693 12.4053 2.59525 12.7336 3.00026 12.7336C3.40527 12.7336 3.73359 12.4053 3.73359 12.0003V7.71137C3.73359 6.95045 4.35045 6.33359 5.11137 6.33359H12.3114V5.31921C12.3114 5.29467 12.2915 5.27477 12.2669 5.27477H7.58196C7.35561 5.27477 7.14473 5.15993 7.02193 4.96979L5.9353 3.28726C5.92711 3.27458 5.91306 3.26693 5.89797 3.26693H2.31137ZM5.11137 7.66693C5.08683 7.66693 5.06693 7.68683 5.06693 7.71137V12.0003C5.06693 12.2585 5.01956 12.5057 4.93304 12.7336H13.0669C13.4351 12.7336 13.7336 12.4351 13.7336 12.0669V7.71137C13.7336 7.68683 13.7137 7.66693 13.6891 7.66693H5.11137ZM3.12793 14.063C3.15169 14.0656 3.17582 14.0669 3.20026 14.0669H13.0669C14.1715 14.0669 15.0669 13.1715 15.0669 12.0669V7.71137C15.0669 6.95045 14.4501 6.33359 13.6891 6.33359H13.6447V5.31921C13.6447 4.55829 13.0279 3.94144 12.2669 3.94144H7.94502L7.05535 2.56389C6.80157 2.17094 6.36575 1.93359 5.89797 1.93359H2.31137C1.55045 1.93359 0.933594 2.55045 0.933594 3.31137V12.0003C0.933594 13.1417 1.85887 14.0669 3.00026 14.0669C3.04313 14.0669 3.0857 14.0656 3.12793 14.063Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const Subscriptions = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3333 6.66667V4.66667C13.3333 3.93029 12.7364 3.33333 12 3.33333H3.99999C3.26361 3.33333 2.66666 3.93029 2.66666 4.66667V6.66667M13.3333 6.66667H2.66666M13.3333 6.66667V7.83333M2.66666 6.66667V12.6667C2.66666 13.4031 3.26361 14 3.99999 14H7.33332M5.33332 2V4.66667M10.6667 2V4.66667"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M9.33334 12.6667L10.6667 14L14 10.6667"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Settlement = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.83398 4.57597L1.83398 5.99857C1.83582 6.00793 1.85073 6.05614 1.94809 6.13985C2.07131 6.24578 2.27886 6.36384 2.5788 6.47291C3.17457 6.68956 4.03075 6.83333 5.00065 6.83333C5.83776 6.83333 6.59298 6.72618 7.16945 6.55587C7.21006 6.51286 7.25264 6.47262 7.29617 6.4352C7.32231 6.41272 7.34936 6.39073 7.37726 6.36923C7.38283 6.36493 7.38841 6.36067 7.394 6.35645C7.42701 6.33153 7.46124 6.30721 7.49662 6.28349C7.53714 6.25631 7.57905 6.22999 7.62224 6.20449C7.7313 6.1401 7.84845 6.08098 7.97151 6.02684C8.02703 6.00241 8.08375 5.97899 8.14148 5.95656C8.15007 5.95322 8.15868 5.9499 8.16732 5.9466V4.57597C8.03987 4.63844 7.9046 4.695 7.76425 4.74604C7.03295 5.01197 6.0558 5.16667 5.00065 5.16667C3.9455 5.16667 2.96835 5.01197 2.23705 4.74604C2.0967 4.695 1.96143 4.63844 1.83398 4.57597ZM9.16732 3.33333V5.66818C9.72172 5.55952 10.3462 5.5 11.0007 5.5C12.0558 5.5 13.0329 5.6547 13.7642 5.92063C14.1278 6.05284 14.4573 6.2221 14.7051 6.4352C14.9514 6.6469 15.1673 6.94869 15.1673 7.33333V12.6667C15.1673 13.0513 14.9514 13.3531 14.7051 13.5648C14.4573 13.7779 14.1278 13.9472 13.7642 14.0794C13.0329 14.3453 12.0558 14.5 11.0007 14.5C9.9455 14.5 8.96836 14.3453 8.23705 14.0794C7.87346 13.9472 7.54404 13.7779 7.29617 13.5648C7.12324 13.4161 6.96525 13.223 6.88651 12.988C6.32042 13.1031 5.67739 13.1667 5.00065 13.1667C3.9455 13.1667 2.96835 13.012 2.23705 12.746C1.87346 12.6138 1.54404 12.4446 1.29617 12.2315C1.04992 12.0198 0.833984 11.718 0.833984 11.3333V3.33333C0.833984 2.94869 1.04992 2.6469 1.29617 2.4352C1.54404 2.2221 1.87346 2.05284 2.23705 1.92063C2.96835 1.6547 3.9455 1.5 5.00065 1.5C6.0558 1.5 7.03295 1.6547 7.76425 1.92063C8.12784 2.05284 8.45726 2.2221 8.70513 2.4352C8.95138 2.6469 9.16732 2.94869 9.16732 3.33333ZM1.83398 7.24264L1.83398 8.66523C1.83582 8.67459 1.85073 8.72281 1.94809 8.80652C2.07131 8.91245 2.27886 9.03051 2.5788 9.13958C3.17457 9.35622 4.03075 9.5 5.00065 9.5C5.68386 9.5 6.31253 9.42862 6.83398 9.30979V7.66515C6.28078 7.77358 5.65655 7.83333 5.00065 7.83333C3.9455 7.83333 2.96835 7.67863 2.23705 7.41271C2.0967 7.36167 1.96143 7.30511 1.83398 7.24264ZM7.83398 8.57597V9.684C7.83416 9.69164 7.83416 9.69926 7.83398 9.70685L7.83398 9.99857C7.83583 10.0079 7.85073 10.0561 7.94809 10.1399C8.07131 10.2458 8.27886 10.3638 8.5788 10.4729C9.17457 10.6896 10.0308 10.8333 11.0007 10.8333C11.9705 10.8333 12.8267 10.6896 13.4225 10.4729C13.7224 10.3638 13.93 10.2458 14.0532 10.1399C14.1506 10.0561 14.1655 10.0079 14.1673 9.99857V8.57597C14.0399 8.63844 13.9046 8.695 13.7642 8.74604C13.0329 9.01197 12.0558 9.16667 11.0007 9.16667C9.9455 9.16667 8.96836 9.01197 8.23705 8.74604C8.0967 8.695 7.96143 8.63844 7.83398 8.57597ZM14.1674 7.33168C14.1674 7.3307 14.1675 7.33022 14.1675 7.33022L14.1674 7.33168ZM14.167 7.33333C14.164 7.3455 14.1464 7.3931 14.0532 7.47318C13.93 7.57912 13.7224 7.69718 13.4225 7.80625C12.8267 8.02289 11.9705 8.16667 11.0007 8.16667C10.0308 8.16667 9.17457 8.02289 8.5788 7.80625C8.27886 7.69718 8.07131 7.57912 7.94809 7.47318C7.85576 7.3938 7.83759 7.34634 7.83438 7.33366C7.83601 7.32718 7.84201 7.30949 7.86266 7.28159C7.87954 7.25898 7.90617 7.22952 7.94809 7.19348C7.96026 7.18302 7.97326 7.17244 7.98708 7.16175C7.99018 7.15937 7.99333 7.15696 7.99655 7.15453C8.02168 7.13556 8.04918 7.11645 8.07907 7.0973C8.20154 7.01881 8.36717 6.93738 8.5788 6.86042C8.64861 6.83503 8.72201 6.81065 8.79874 6.78737C8.80286 6.78612 8.80699 6.78488 8.81113 6.78364M14.167 7.33333C14.164 7.32116 14.1464 7.27357 14.0532 7.19348C13.93 7.08755 13.7224 6.96949 13.4225 6.86042C12.8267 6.64378 11.9705 6.5 11.0007 6.5C10.1514 6.5 9.38939 6.61022 8.81299 6.78308M14.1673 11.2426C14.0399 11.3051 13.9046 11.3617 13.7642 11.4127C13.0329 11.6786 12.0558 11.8333 11.0007 11.8333C9.9455 11.8333 8.96836 11.6786 8.23705 11.4127C8.0967 11.3617 7.96143 11.3051 7.83398 11.2426V12.6652C7.83583 12.6746 7.85072 12.7228 7.94809 12.8065C8.07131 12.9125 8.27886 13.0305 8.5788 13.1396C9.17457 13.3562 10.0308 13.5 11.0007 13.5C11.9705 13.5 12.8267 13.3562 13.4225 13.1396C13.7224 13.0305 13.93 12.9125 14.0532 12.8065C14.1506 12.7228 14.1655 12.6746 14.1673 12.6652V11.2426ZM14.1675 12.6635C14.1676 12.6635 14.1675 12.6643 14.1673 12.6652L14.1675 12.6635ZM7.83377 12.6635C7.8338 12.6635 7.83393 12.6642 7.83398 12.6652L7.83377 12.6635ZM6.83398 10.3318V11.9765C6.31253 12.0953 5.68386 12.1667 5.00065 12.1667C4.03075 12.1667 3.17457 12.0229 2.5788 11.8062C2.27886 11.6972 2.07131 11.5791 1.94809 11.4732C1.85073 11.3895 1.83583 11.3413 1.83398 11.3319V9.90931C1.96143 9.97178 2.0967 10.0283 2.23705 10.0794C2.96835 10.3453 3.9455 10.5 5.00065 10.5C5.65655 10.5 6.28078 10.4402 6.83398 10.3318ZM1.83376 11.3302C1.8338 11.3302 1.83393 11.3309 1.83398 11.3319L1.83376 11.3302ZM8.16754 3.33022C8.16757 3.33022 8.16754 3.33071 8.16736 3.33169L8.16754 3.33022ZM8.167 3.33333C8.16403 3.3455 8.14637 3.3931 8.05321 3.47318C7.92999 3.57912 7.72245 3.69718 7.4225 3.80625C6.82673 4.02289 5.97055 4.16667 5.00065 4.16667C4.03075 4.16667 3.17457 4.02289 2.5788 3.80625C2.27886 3.69718 2.07131 3.57912 1.94809 3.47318C1.85494 3.3931 1.83727 3.3455 1.8343 3.33333C1.83727 3.32117 1.85494 3.27357 1.94809 3.19348C2.07131 3.08755 2.27886 2.96949 2.5788 2.86042C3.17457 2.64378 4.03075 2.5 5.00065 2.5C5.97055 2.5 6.82673 2.64378 7.4225 2.86042C7.72245 2.96949 7.92999 3.08755 8.05321 3.19348C8.14636 3.27357 8.16403 3.32117 8.167 3.33333ZM1.83377 3.33022C1.8338 3.33021 1.83389 3.3307 1.83394 3.33169L1.83377 3.33022Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const Orders = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.83913 1.33398H10.1609C10.6975 1.33398 11.1404 1.33397 11.5012 1.36345C11.8759 1.39406 12.2204 1.45977 12.544 1.62463C13.0457 1.8803 13.4537 2.28824 13.7094 2.79001C13.8742 3.11357 13.9399 3.45804 13.9705 3.83277C14 4.19356 14 4.63646 14 5.1731V14.0007C14 14.2514 13.8593 14.4809 13.6359 14.5947C13.4124 14.7085 13.144 14.6873 12.9412 14.5398L11.5193 13.5057L10.2498 14.5212C10.0152 14.7089 9.68415 14.7165 9.44122 14.5398L8 13.4916L6.55878 14.5398C6.31585 14.7165 5.98477 14.7089 5.7502 14.5212L4.48074 13.5057L3.05878 14.5398C2.85599 14.6873 2.5876 14.7085 2.36415 14.5947C2.1407 14.4809 2 14.2514 2 14.0007L2 5.17312C1.99999 4.63647 1.99998 4.19356 2.02946 3.83277C2.06008 3.45804 2.12579 3.11357 2.29065 2.79001C2.54631 2.28824 2.95426 1.8803 3.45603 1.62463C3.77958 1.45977 4.12405 1.39406 4.49878 1.36345C4.85958 1.33397 5.30249 1.33398 5.83913 1.33398ZM4.60736 2.69235C4.31508 2.71623 4.16561 2.75952 4.06135 2.81264C3.81046 2.94047 3.60649 3.14445 3.47866 3.39533C3.42553 3.4996 3.38225 3.64907 3.35837 3.94134C3.33385 4.2414 3.33333 4.6296 3.33333 5.20065V12.6915L4.10789 12.1282C4.35082 11.9515 4.6819 11.9591 4.91646 12.1467L6.18593 13.1623L7.60789 12.1282C7.84165 11.9581 8.15835 11.9581 8.39212 12.1282L9.81407 13.1623L11.0835 12.1467C11.3181 11.9591 11.6492 11.9515 11.8921 12.1282L12.6667 12.6915V5.20065C12.6667 4.6296 12.6661 4.2414 12.6416 3.94134C12.6178 3.64907 12.5745 3.4996 12.5213 3.39533C12.3935 3.14445 12.1895 2.94047 11.9387 2.81264C11.8344 2.75952 11.6849 2.71623 11.3926 2.69235C11.0926 2.66784 10.7044 2.66732 10.1333 2.66732H5.86667C5.29561 2.66732 4.90742 2.66784 4.60736 2.69235ZM10.8047 4.86258C11.0651 5.12293 11.0651 5.54504 10.8047 5.80539L7.80474 8.80539C7.54439 9.06574 7.12228 9.06574 6.86193 8.80539L5.5286 7.47206C5.26825 7.21171 5.26825 6.7896 5.5286 6.52925C5.78895 6.2689 6.21106 6.2689 6.47141 6.52925L7.33333 7.39118L9.86193 4.86258C10.1223 4.60223 10.5444 4.60223 10.8047 4.86258Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const Reports = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.2357 2.76495C8.10553 2.63477 7.89447 2.63477 7.7643 2.76495C7.63412 2.89512 7.63412 3.10618 7.7643 3.23635C7.89447 3.36653 8.10553 3.36653 8.2357 3.23635C8.36588 3.10618 8.36588 2.89512 8.2357 2.76495ZM6.82149 1.82214C7.47236 1.17127 8.52764 1.17127 9.17851 1.82214C9.48159 2.12522 9.64355 2.51599 9.66436 2.91279L12.1371 3.84008C12.143 3.83407 12.1489 3.82809 12.1548 3.82214C12.8057 3.17127 13.861 3.17127 14.5118 3.82214C15.1627 4.47301 15.1627 5.52829 14.5118 6.17916C13.861 6.83004 12.8057 6.83004 12.1548 6.17916C11.8517 5.87608 11.6898 5.48531 11.669 5.08852L9.19619 4.16122C9.19035 4.16724 9.18446 4.17322 9.17851 4.17916C8.63632 4.72135 7.81352 4.81189 7.17761 4.45077L4.28889 6.61732C4.41672 7.16058 4.26881 7.75553 3.84518 8.17916C3.1943 8.83004 2.13903 8.83004 1.48816 8.17916C0.837282 7.52829 0.837282 6.47301 1.48816 5.82214C2.03034 5.27995 2.85315 5.18941 3.48905 5.55053L6.37778 3.38398C6.24995 2.84073 6.39785 2.24577 6.82149 1.82214ZM13.569 4.76495C13.4389 4.63477 13.2278 4.63477 13.0976 4.76495C12.9675 4.89512 12.9675 5.10618 13.0976 5.23635C13.2278 5.36653 13.4389 5.36653 13.569 5.23635C13.6992 5.10618 13.6992 4.89512 13.569 4.76495ZM2.90237 6.76495C2.77219 6.63477 2.56114 6.63477 2.43096 6.76495C2.30079 6.89512 2.30079 7.10618 2.43096 7.23635C2.56114 7.36653 2.77219 7.36653 2.90237 7.23635C3.03254 7.10618 3.03254 6.89512 2.90237 6.76495ZM8 6.00065C8.36819 6.00065 8.66667 6.29913 8.66667 6.66732V13.334C8.66667 13.7022 8.36819 14.0007 8 14.0007C7.63181 14.0007 7.33333 13.7022 7.33333 13.334V6.66732C7.33333 6.29913 7.63181 6.00065 8 6.00065ZM13.3333 8.00065C13.7015 8.00065 14 8.29913 14 8.66732V13.334C14 13.7022 13.7015 14.0007 13.3333 14.0007C12.9651 14.0007 12.6667 13.7022 12.6667 13.334V8.66732C12.6667 8.29913 12.9651 8.00065 13.3333 8.00065ZM2.66667 10.0007C3.03486 10.0007 3.33333 10.2991 3.33333 10.6673V13.334C3.33333 13.7022 3.03486 14.0007 2.66667 14.0007C2.29848 14.0007 2 13.7022 2 13.334L2 10.6673C2 10.2991 2.29848 10.0007 2.66667 10.0007Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const Customers = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00006 2.66732C6.71139 2.66732 5.66672 3.71199 5.66672 5.00065C5.66672 6.28932 6.71139 7.33398 8.00006 7.33398C9.28872 7.33398 10.3334 6.28932 10.3334 5.00065C10.3334 3.71199 9.28872 2.66732 8.00006 2.66732ZM4.33339 5.00065C4.33339 2.97561 5.97501 1.33398 8.00006 1.33398C10.0251 1.33398 11.6667 2.97561 11.6667 5.00065C11.6667 7.02569 10.0251 8.66732 8.00006 8.66732C5.97501 8.66732 4.33339 7.02569 4.33339 5.00065ZM6.21757 9.66729C6.25561 9.6673 6.29421 9.66731 6.33339 9.66731H9.66672C9.7059 9.66731 9.7445 9.6673 9.78255 9.66729C10.6007 9.66698 11.1594 9.66678 11.6343 9.81085C12.6997 10.134 13.5334 10.9677 13.8565 12.033C14.0006 12.508 14.0004 13.0666 14.0001 13.8848C14.0001 13.9229 14.0001 13.9615 14.0001 14.0007C14.0001 14.3688 13.7016 14.6673 13.3334 14.6673C12.9652 14.6673 12.6667 14.3688 12.6667 14.0007C12.6667 13.0218 12.6595 12.6801 12.5806 12.4201C12.3867 11.7809 11.8865 11.2807 11.2473 11.0868C10.9872 11.0079 10.6456 11.0006 9.66672 11.0006H6.33339C5.35451 11.0006 5.01286 11.0079 4.75282 11.0868C4.11362 11.2807 3.61341 11.7809 3.41951 12.4201C3.34063 12.6801 3.33339 13.0218 3.33339 14.0007C3.33339 14.3688 3.03491 14.6673 2.66672 14.6673C2.29853 14.6673 2.00006 14.3688 2.00006 14.0007C2.00006 13.9615 2.00004 13.9229 2.00003 13.8848C1.99972 13.0666 1.99952 12.508 2.14359 12.033C2.46676 10.9677 3.30043 10.134 4.36577 9.81085C4.84071 9.66678 5.39938 9.66698 6.21757 9.66729Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const Billing = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.44032 2.66602L12.5584 2.66602C12.9098 2.66601 13.213 2.66599 13.4627 2.6864C13.7263 2.70793 13.9884 2.75548 14.2407 2.884C14.617 3.07575 14.923 3.38171 15.1147 3.75804C15.2432 4.01029 15.2908 4.27244 15.3123 4.536C15.3327 4.78571 15.3327 5.08888 15.3327 5.44031V10.5584C15.3327 10.9098 15.3327 11.213 15.3123 11.4627C15.2908 11.7263 15.2432 11.9884 15.1147 12.2407C14.923 12.617 14.617 12.923 14.2407 13.1147C13.9884 13.2432 13.7263 13.2908 13.4627 13.3123C13.213 13.3327 12.9098 13.3327 12.5584 13.3327L3.44033 13.3327C3.0889 13.3327 2.78572 13.3327 2.536 13.3123C2.27243 13.2908 2.01029 13.2432 1.75804 13.1147C1.38171 12.9229 1.07575 12.617 0.884004 12.2407C0.755474 11.9884 0.70793 11.7263 0.686396 11.4627C0.665994 11.213 0.666004 10.9098 0.666016 10.5584L0.666017 6.66644L0.666016 5.44032C0.666004 5.08889 0.665994 4.78571 0.686397 4.536C0.707931 4.27243 0.755475 4.01029 0.884004 3.75804C1.07575 3.38171 1.38171 3.07575 1.75804 2.884C2.01029 2.75547 2.27244 2.70793 2.536 2.6864C2.78571 2.66599 3.08889 2.666 3.44032 2.66602ZM1.99935 7.33268V10.5327C1.99935 10.9171 1.99987 11.1652 2.0153 11.3541C2.0301 11.5352 2.05522 11.6024 2.07201 11.6353C2.13593 11.7608 2.23792 11.8628 2.36336 11.9267C2.39632 11.9435 2.46346 11.9686 2.64457 11.9834C2.83347 11.9988 3.08165 11.9993 3.46602 11.9993L12.5327 11.9994C12.9171 11.9994 13.1652 11.9988 13.3541 11.9834C13.5352 11.9686 13.6024 11.9435 13.6353 11.9267C13.7608 11.8628 13.8628 11.7608 13.9267 11.6353C13.9435 11.6024 13.9686 11.5352 13.9834 11.3541C13.9988 11.1652 13.9994 10.9171 13.9994 10.5327V7.33268H1.99935ZM13.9994 5.99935H1.99935V5.46602C1.99935 5.08165 1.99987 4.83347 2.0153 4.64457C2.0301 4.46347 2.05522 4.39632 2.07201 4.36336C2.13593 4.23792 2.23792 4.13593 2.36336 4.07201C2.39632 4.05522 2.46347 4.0301 2.64457 4.0153C2.83347 3.99987 3.08165 3.99935 3.46602 3.99935L12.5327 3.99935C12.9171 3.99935 13.1652 3.99987 13.3541 4.0153C13.5352 4.0301 13.6024 4.05522 13.6353 4.07201C13.7608 4.13593 13.8628 4.23792 13.9267 4.36336C13.9435 4.39632 13.9686 4.46346 13.9834 4.64457C13.9988 4.83347 13.9994 5.08165 13.9994 5.46602V5.99935ZM3.33268 9.33268C3.33268 8.96449 3.63116 8.66602 3.99935 8.66602H7.33268C7.70087 8.66602 7.99935 8.96449 7.99935 9.33268C7.99935 9.70087 7.70087 9.99935 7.33268 9.99935H3.99935C3.63116 9.99935 3.33268 9.70087 3.33268 9.33268Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const MyOfferings = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.65228 0.89009C7.88048 0.828303 8.12101 0.828303 8.34921 0.89009C8.61412 0.961817 8.83715 1.13692 9.01516 1.27668C9.03215 1.29002 9.04874 1.30304 9.06491 1.31562L13.5864 4.83237C13.6038 4.8459 13.6211 4.85931 13.6383 4.87261C13.8893 5.06746 14.1105 5.23913 14.2754 5.46199C14.42 5.65758 14.5278 5.87792 14.5934 6.11219C14.6681 6.37913 14.6678 6.65914 14.6675 6.97697C14.6674 6.99865 14.6674 7.02051 14.6674 7.04255V11.8916C14.6674 12.243 14.6674 12.5461 14.647 12.7959C14.6255 13.0594 14.578 13.3216 14.4494 13.5738C14.2577 13.9501 13.9517 14.2561 13.5754 14.4479C13.3231 14.5764 13.061 14.6239 12.7974 14.6455C12.5477 14.6659 12.2445 14.6659 11.8931 14.6658H4.10837C3.75694 14.6659 3.45377 14.6659 3.20406 14.6455C2.9405 14.6239 2.67835 14.5764 2.4261 14.4479C2.04977 14.2561 1.74381 13.9501 1.55206 13.5738C1.42353 13.3216 1.37599 13.0594 1.35446 12.7959C1.33405 12.5461 1.33406 12.243 1.33408 11.8915L1.33408 7.04255C1.33408 7.02051 1.33405 6.99865 1.33403 6.97696C1.33369 6.65914 1.33338 6.37913 1.4081 6.11219C1.47368 5.87792 1.58144 5.65758 1.7261 5.46199C1.89094 5.23912 2.11215 5.06745 2.36324 4.8726C2.38037 4.8593 2.39764 4.8459 2.41504 4.83237L6.93658 1.31562C6.95275 1.30304 6.96934 1.29002 6.98633 1.27668C7.16434 1.13692 7.38737 0.961817 7.65228 0.89009ZM7.99588 2.18687C7.94578 2.22035 7.87977 2.27117 7.75517 2.36809L3.23363 5.88484C2.90158 6.1431 2.83975 6.19853 2.79809 6.25486C2.74987 6.32005 2.71394 6.3935 2.69209 6.47159C2.6732 6.53905 2.66741 6.62189 2.66741 7.04255V11.8658C2.66741 12.2502 2.66793 12.4984 2.68336 12.6873C2.69816 12.8684 2.72328 12.9355 2.74007 12.9685C2.80399 13.0939 2.90598 13.1959 3.03142 13.2598C3.06438 13.2766 3.13153 13.3018 3.31263 13.3166C3.50153 13.332 3.74971 13.3325 4.13408 13.3325H11.8674C12.2518 13.3325 12.5 13.332 12.6889 13.3166C12.87 13.3018 12.9371 13.2766 12.9701 13.2598C13.0955 13.1959 13.1975 13.0939 13.2614 12.9685C13.2782 12.9355 13.3033 12.8684 13.3181 12.6873C13.3336 12.4984 13.3341 12.2502 13.3341 11.8658V7.04255C13.3341 6.6219 13.3283 6.53905 13.3094 6.47159C13.2875 6.3935 13.2516 6.32005 13.2034 6.25486C13.1617 6.19853 13.0999 6.1431 12.7679 5.88484L8.24632 2.36809C8.12172 2.27117 8.05571 2.22035 8.00561 2.18687C8.00391 2.18574 8.00229 2.18466 8.00074 2.18365C7.9992 2.18466 7.99758 2.18574 7.99588 2.18687ZM8.00074 7.33251C7.26436 7.33251 6.66741 7.92946 6.66741 8.66584C6.66741 9.40222 7.26436 9.99918 8.00074 9.99918C8.73712 9.99918 9.33408 9.40222 9.33408 8.66584C9.33408 7.92946 8.73712 7.33251 8.00074 7.33251ZM5.33408 8.66584C5.33408 7.19308 6.52798 5.99918 8.00074 5.99918C9.4735 5.99918 10.6674 7.19308 10.6674 8.66584C10.6674 10.1386 9.4735 11.3325 8.00074 11.3325C6.52798 11.3325 5.33408 10.1386 5.33408 8.66584Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Contracts = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33334 5.00001V15.8333C3.33334 17.2141 4.45264 18.3333 5.83334 18.3333H14.1667C15.5474 18.3333 16.6667 17.2141 16.6667 15.8333V7.50001C16.6667 6.1193 15.5474 5.00001 14.1667 5.00001H3.33334ZM3.33334 5.00001V4.16667"
        stroke="currentColor"
        strokeWidth="1.25"
      />
      <path
        d="M15 5.00001V5.62501H15.625V5.00001H15ZM4.2259 5.62501H15V4.37501H4.2259V5.62501ZM15.625 5.00001V3.58836H14.375V5.00001H15.625ZM13.0093 1.31973L4.01129 2.60515L4.18806 3.84259L13.186 2.55716L13.0093 1.31973ZM4.01129 2.60515C3.26366 2.71195 2.70834 3.35224 2.70834 4.10745H3.95834C3.95834 3.9743 4.05625 3.86142 4.18806 3.84259L4.01129 2.60515ZM15.625 3.58836C15.625 2.19377 14.3898 1.1225 13.0093 1.31973L13.186 2.55716C13.8136 2.46752 14.375 2.95445 14.375 3.58836H15.625ZM4.2259 4.37501C4.07814 4.37501 3.95834 4.25522 3.95834 4.10745H2.70834C2.70834 4.94558 3.38778 5.62501 4.2259 5.62501V4.37501Z"
        fill="currentColor"
      />
      <path
        d="M6.66666 10H13.3333"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <path
        d="M6.66666 12.9167H11.25"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const Assets = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_84_36826)">
        <path
          d="M7.99999 14.6667L5.59999 12.2667C3.99999 16.4667 -0.466674 12 3.73333 10.4L1.33333 8L3.73333 5.6C5.33332 9.8 9.79999 5.33333 5.59999 3.73333L7.99999 1.33333L10.4 3.73333C12 -0.466667 16.4667 4 12.2667 5.6L14.6667 8L12.2667 10.4C10.6667 6.2 6.19999 10.6667 10.4 12.2667L7.99999 14.6667Z"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_84_36826">
          <rect
            width="16"
            height="16"
            fill="transparent"
            transform="matrix(-1 0 0 -1 16 16)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Quotes = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.48355 2.03623C7.34795 2.00368 7.19615 1.99939 6.67524 1.99939L4.00072 1.99939C3.63253 1.99939 3.33405 1.70091 3.33405 1.33272C3.33405 0.964535 3.63253 0.666058 4.00072 0.666058L6.67524 0.666058C6.69817 0.666058 6.72081 0.666047 6.74316 0.666036C7.16648 0.665835 7.48635 0.665683 7.79481 0.739738C8.06691 0.805062 8.32703 0.912807 8.56562 1.05902C8.8361 1.22477 9.06217 1.45105 9.36137 1.75053C9.37716 1.76634 9.39316 1.78236 9.40938 1.79858L14.4721 6.86132C14.7325 7.12167 14.7325 7.54378 14.4721 7.80413C14.2118 8.06448 13.7897 8.06448 13.5293 7.80413L8.46657 2.74139C8.09823 2.37305 7.98786 2.26874 7.86896 2.19587C7.74966 2.12277 7.6196 2.06889 7.48355 2.03623ZM6.60406 4.35114C6.54519 4.33701 6.47492 4.33272 6.11706 4.33272H4.13405C3.74968 4.33272 3.5015 4.33324 3.31261 4.34868C3.1315 4.36347 3.06435 4.38859 3.03139 4.40539C2.90595 4.4693 2.80396 4.57129 2.74005 4.69673C2.72325 4.72969 2.69813 4.79684 2.68334 4.97795C2.6679 5.16684 2.66739 5.41502 2.66739 5.79939L2.66739 7.11574C2.66739 7.47359 2.67167 7.54386 2.68581 7.60274C2.70214 7.67076 2.72907 7.73579 2.76563 7.79544C2.79726 7.84707 2.84392 7.89979 3.09696 8.15283L8.29696 13.3528C8.56875 13.6246 8.74461 13.7997 8.88909 13.9224C9.02762 14.04 9.09286 14.0697 9.12804 14.0811C9.26194 14.1246 9.40617 14.1246 9.54006 14.0811C9.57525 14.0697 9.64049 14.04 9.77902 13.9224C9.92349 13.7997 10.0994 13.6246 10.3711 13.3528L12.0208 11.7031C12.2926 11.4314 12.4677 11.2555 12.5904 11.111C12.708 10.9725 12.7377 10.9073 12.7491 10.8721C12.7926 10.7382 12.7926 10.5939 12.7491 10.46C12.7377 10.4249 12.708 10.3596 12.5904 10.2211C12.4677 10.0766 12.2926 9.90076 12.0208 9.62897L7.15415 4.7623C6.90111 4.50926 6.8484 4.4626 6.79677 4.43096C6.73712 4.39441 6.67209 4.36748 6.60406 4.35114ZM6.1726 2.99936C6.44386 2.9991 6.68303 2.99888 6.91533 3.05465C7.1194 3.10364 7.31449 3.18445 7.49343 3.29411C7.69712 3.41893 7.86608 3.5882 8.05771 3.78019C8.07069 3.79319 8.08376 3.80629 8.09696 3.81949L12.9818 8.7043C13.2303 8.9528 13.4447 9.16718 13.6068 9.35819C13.778 9.55979 13.9297 9.77877 14.0172 10.048C14.1477 10.4497 14.1477 10.8824 14.0172 11.2841C13.9297 11.5533 13.778 11.7723 13.6068 11.9739C13.4447 12.1649 13.2303 12.3793 12.9818 12.6278L11.2958 14.3138C11.0473 14.5623 10.8329 14.7767 10.6419 14.9388C10.4403 15.11 10.2213 15.2617 9.95209 15.3492C9.5504 15.4797 9.11771 15.4797 8.71602 15.3492C8.44676 15.2617 8.22778 15.11 8.02619 14.9388C7.83519 14.7767 7.62083 14.5623 7.37235 14.3138L2.15415 9.09563C2.14096 9.08244 2.12785 9.06936 2.11486 9.05639C1.92287 8.86475 1.75359 8.6958 1.62877 8.4921C1.51911 8.31316 1.43831 8.11807 1.38931 7.914C1.33354 7.6817 1.33377 7.44253 1.33402 7.17127C1.33403 7.15291 1.33405 7.1344 1.33405 7.11574L1.33405 5.7737C1.33404 5.42226 1.33403 5.11909 1.35443 4.86937C1.37597 4.60581 1.42351 4.34366 1.55204 4.09141C1.74379 3.71509 2.04975 3.40912 2.42607 3.21738C2.67832 3.08885 2.94047 3.0413 3.20403 3.01977C3.45375 2.99937 3.75692 2.99938 4.10836 2.99939L6.11706 2.99939C6.13573 2.99939 6.15424 2.99937 6.1726 2.99936Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const CollapseMenu = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.00065 1.33398C2.36884 1.33398 2.66732 1.63246 2.66732 2.00065V14.0007C2.66732 14.3688 2.36884 14.6673 2.00065 14.6673C1.63246 14.6673 1.33398 14.3688 1.33398 14.0007V2.00065C1.33398 1.63246 1.63246 1.33398 2.00065 1.33398ZM9.80539 2.86258C10.0657 3.12293 10.0657 3.54504 9.80539 3.80539L6.27679 7.33398H14.0007C14.3688 7.33398 14.6673 7.63246 14.6673 8.00065C14.6673 8.36884 14.3688 8.66732 14.0007 8.66732H6.27679L9.80539 12.1959C10.0657 12.4563 10.0657 12.8784 9.80539 13.1387C9.54504 13.3991 9.12293 13.3991 8.86258 13.1387L4.19591 8.47205C3.93556 8.21171 3.93556 7.7896 4.19591 7.52925L8.86258 2.86258C9.12293 2.60223 9.54504 2.60223 9.80539 2.86258Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const EnterArrow = (props) => {
  return (
    <svg
      width="25"
      height="26"
      viewBox="0 0 25 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ cursor: "default" }}
    >
      <path
        d="M14.8758 16.6058V11.1214L17.6179 13.8636L14.8758 16.6058ZM7.38783 14.3622V8.54545H8.38499V14.3622H7.38783ZM7.41553 14.3622V13.3651H15.716V14.3622H7.41553Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const AssetIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_98_7467)">
        <path
          d="M15.439 15.6192C15.7488 15.6192 16 15.3681 16 15.0581V5.57015C16 5.26028 15.7488 5.00908 15.439 5.00908H8.98888V0.941899C8.98888 0.631919 8.73783 0.380821 8.42801 0.380821H0.56097C0.251205 0.380821 0 0.631973 0 0.941899V15.058C0 15.368 0.251205 15.6191 0.56097 15.6191H15.439V15.6192ZM9.84512 6.13112H11.3146V8.57309H9.84512V6.13112ZM3.75984 1.50281H5.22925V3.15782H3.75984V1.50281ZM1.12194 1.50281H2.63785V3.71884C2.63785 4.02866 2.88905 4.27981 3.19892 4.27981H5.79022C6.09993 4.27981 6.35108 4.02866 6.35108 3.71884V1.50281H7.8671V5.00908H5.72084C5.41107 5.00908 5.15987 5.26028 5.15987 5.57015V14.4971H1.12194V1.50281ZM6.2817 14.4971V6.13112H8.72313V9.1339C8.72313 9.44377 8.97438 9.69487 9.2841 9.69487H11.8756C12.1854 9.69487 12.4366 9.44377 12.4366 9.1339V6.13112H14.878V14.4972H6.2817V14.4971Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_98_7467">
          <rect width="16" height="16" fill="transparent" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Settings = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1879_9564)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.00065 1.83398C7.81178 1.83398 7.63065 1.90901 7.49711 2.04256C7.36356 2.17611 7.28853 2.35724 7.28853 2.54611V2.64914L7.28853 2.65113C7.28736 2.94366 7.20068 3.22947 7.03916 3.47337C6.87763 3.71727 6.64832 3.90862 6.37944 4.02386C6.33387 4.04338 6.28575 4.05599 6.23667 4.06134C5.98934 4.15006 5.72238 4.17246 5.4626 4.12536C5.1677 4.07189 4.89558 3.9313 4.68132 3.72172L4.67738 3.71786L4.64104 3.68148C4.5749 3.61527 4.49616 3.56254 4.40971 3.52671C4.32326 3.49087 4.2306 3.47242 4.13701 3.47242C4.04343 3.47242 3.95077 3.49087 3.86432 3.52671C3.77786 3.56254 3.69933 3.61507 3.63319 3.68128C3.56698 3.74742 3.51406 3.82635 3.47822 3.9128C3.44239 3.99925 3.42394 4.09192 3.42394 4.1855C3.42394 4.27908 3.44239 4.37175 3.47822 4.4582C3.51406 4.54465 3.56659 4.62319 3.6328 4.68933L3.67326 4.72978C3.88283 4.94404 4.0234 5.21619 4.07687 5.51109C4.12941 5.80081 4.09549 6.09946 3.97954 6.36986C3.87463 6.64609 3.69041 6.88531 3.44989 7.05734C3.20507 7.23244 2.91325 7.32984 2.61234 7.33688L2.60065 7.33701H2.54611C2.35724 7.33701 2.17611 7.41204 2.04256 7.54559C1.90901 7.67914 1.83398 7.86027 1.83398 8.04914C1.83398 8.238 1.90901 8.41913 2.04256 8.55268C2.17611 8.68623 2.35724 8.76126 2.54611 8.76126H2.65113C2.94366 8.76243 3.22947 8.84911 3.47337 9.01063C3.71652 9.17166 3.90743 9.40005 4.02279 9.66786C4.14294 9.94143 4.17867 10.2447 4.12536 10.5387C4.07189 10.8336 3.9313 11.1057 3.72172 11.32L3.71786 11.3239L3.68147 11.3603C3.61526 11.4264 3.56255 11.5051 3.52671 11.5916C3.49087 11.678 3.47242 11.7707 3.47242 11.8643C3.47242 11.9579 3.49087 12.0505 3.52671 12.137C3.56254 12.2234 3.61507 12.302 3.68128 12.3681C3.74742 12.4343 3.82635 12.4872 3.9128 12.5231C3.99925 12.5589 4.09191 12.5774 4.1855 12.5774C4.27908 12.5774 4.37175 12.5589 4.4582 12.5231C4.54465 12.4872 4.62319 12.4347 4.68933 12.3685L4.72978 12.328C4.94404 12.1185 5.21619 11.9779 5.51109 11.9244C5.80082 11.8719 6.09948 11.9058 6.36988 12.0218C6.64611 12.1267 6.88531 12.3109 7.05734 12.5514C7.23244 12.7962 7.32984 13.0881 7.33688 13.389L7.33701 13.4007V13.4552C7.33701 13.6441 7.41204 13.8252 7.54559 13.9587C7.67914 14.0923 7.86027 14.1673 8.04914 14.1673C8.238 14.1673 8.41913 14.0923 8.55268 13.9587C8.68623 13.8252 8.76126 13.6441 8.76126 13.4552V13.3522L8.76126 13.3502C8.76243 13.0576 8.84911 12.7718 9.01063 12.5279C9.17166 12.2848 9.40007 12.0939 9.6679 11.9785C9.94145 11.8584 10.2447 11.8226 10.5387 11.8759C10.8336 11.9294 11.1057 12.07 11.32 12.2796L11.3239 12.2834L11.3603 12.3198C11.4264 12.386 11.5051 12.4388 11.5916 12.4746C11.678 12.5104 11.7707 12.5289 11.8643 12.5289C11.9579 12.5289 12.0505 12.5104 12.137 12.4746C12.2234 12.4388 12.302 12.3862 12.3681 12.32C12.4343 12.2539 12.4872 12.175 12.5231 12.0885C12.5589 12.0021 12.5774 11.9094 12.5774 11.8158C12.5774 11.7222 12.5589 11.6296 12.5231 11.5431C12.4872 11.4567 12.4347 11.3781 12.3685 11.312L12.328 11.2715C12.1185 11.0573 11.9779 10.7851 11.9244 10.4902C11.8711 10.1961 11.9069 9.89286 12.027 9.61926C12.1424 9.3515 12.3333 9.12315 12.5764 8.96215C12.8203 8.80062 13.1061 8.71394 13.3987 8.71278L13.4007 8.71277L13.4552 8.71277C13.6441 8.71277 13.8252 8.63775 13.9587 8.5042C14.0923 8.37065 14.1673 8.18952 14.1673 8.00065C14.1673 7.81179 14.0923 7.63065 13.9587 7.49711C13.8252 7.36356 13.6441 7.28853 13.4552 7.28853H13.3522L13.3502 7.28853C13.0576 7.28736 12.7718 7.20068 12.5279 7.03916C12.284 6.87763 12.0927 6.64832 11.9774 6.37944C11.9579 6.33387 11.9453 6.28575 11.94 6.23667C11.8512 5.98934 11.8288 5.72238 11.8759 5.4626C11.9294 5.1677 12.07 4.89558 12.2796 4.68132L12.2834 4.67738L12.3198 4.64104C12.386 4.5749 12.4388 4.49616 12.4746 4.40971C12.5104 4.32327 12.5289 4.2306 12.5289 4.13701C12.5289 4.04343 12.5104 3.95076 12.4746 3.86432C12.4388 3.77787 12.3862 3.69933 12.32 3.63319C12.2539 3.56698 12.175 3.51406 12.0885 3.47822C12.0021 3.44239 11.9094 3.42394 11.8158 3.42394C11.7222 3.42394 11.6296 3.44239 11.5431 3.47822C11.4567 3.51406 11.3781 3.56659 11.312 3.6328L11.2715 3.67326C11.0573 3.88283 10.7851 4.0234 10.4902 4.07687C10.1962 4.13019 9.89295 4.09446 9.61939 3.97431C9.35158 3.85896 9.12317 3.66804 8.96215 3.42489C8.80062 3.18099 8.71394 2.89518 8.71278 2.60265L8.71277 2.60065V2.54611C8.71277 2.35724 8.63775 2.17611 8.5042 2.04256C8.37065 1.90901 8.18952 1.83398 8.00065 1.83398ZM6.79 1.33545C7.11108 1.01437 7.54657 0.833984 8.00065 0.833984C8.45473 0.833984 8.89022 1.01437 9.2113 1.33545C9.53239 1.65654 9.71277 2.09202 9.71277 2.54611V2.59945C9.71332 2.69669 9.7422 2.79166 9.79589 2.87274C9.84973 2.95404 9.92617 3.01782 10.0158 3.05623L10.0207 3.05835C10.1121 3.09868 10.2135 3.11074 10.3118 3.09292C10.4094 3.07523 10.4994 3.02894 10.5706 2.95997L10.6045 2.92608C10.7635 2.76689 10.9523 2.64061 11.1602 2.55445C11.368 2.46829 11.5908 2.42394 11.8158 2.42394C12.0408 2.42394 12.2636 2.46829 12.4714 2.55445C12.6791 2.64054 12.8678 2.76669 13.0267 2.92569C13.1859 3.0847 13.3122 3.27353 13.3984 3.48137C13.4845 3.68922 13.5289 3.91202 13.5289 4.13701C13.5289 4.36201 13.4845 4.58481 13.3984 4.79265C13.3122 5.0005 13.1859 5.18933 13.0267 5.34834L12.9928 5.38223C12.9239 5.45339 12.8776 5.54347 12.8599 5.64101C12.8421 5.73932 12.8541 5.8407 12.8944 5.9321C12.9111 5.96985 12.923 6.00941 12.9299 6.04988C12.9679 6.11181 13.019 6.16498 13.0801 6.20541C13.1611 6.25909 13.2561 6.28798 13.3533 6.28853H13.4552C13.9093 6.28853 14.3448 6.46891 14.6658 6.79C14.9869 7.11108 15.1673 7.54657 15.1673 8.00065C15.1673 8.45473 14.9869 8.89022 14.6658 9.2113C14.3448 9.53239 13.9093 9.71277 13.4552 9.71277H13.4018C13.3046 9.71332 13.2096 9.7422 13.1286 9.79589C13.0473 9.84973 12.9835 9.92617 12.9451 10.0158L12.943 10.0207C12.9026 10.1121 12.8906 10.2135 12.9084 10.3118C12.9261 10.4093 12.9723 10.4994 13.0413 10.5706L13.0752 10.6045C13.2344 10.7635 13.3607 10.9523 13.4469 11.1602C13.533 11.368 13.5774 11.5908 13.5774 11.8158C13.5774 12.0408 13.533 12.2636 13.4469 12.4714C13.3607 12.6792 13.2345 12.868 13.0754 13.0269C12.9164 13.186 12.7277 13.3122 12.5199 13.3984C12.3121 13.4845 12.0893 13.5289 11.8643 13.5289C11.6393 13.5289 11.4165 13.4845 11.2086 13.3984C11.0008 13.3122 10.812 13.1859 10.653 13.0267L10.6191 12.9928C10.5479 12.9239 10.4578 12.8776 10.3603 12.8599C10.262 12.8421 10.1606 12.8541 10.0692 12.8944L10.0643 12.8966C9.97467 12.935 9.89822 12.9988 9.84438 13.0801C9.79068 13.1612 9.7618 13.2561 9.76126 13.3534V13.4552C9.76126 13.9093 9.58087 14.3448 9.25979 14.6658C8.9387 14.9869 8.50322 15.1673 8.04914 15.1673C7.59505 15.1673 7.15957 14.9869 6.83848 14.6658C6.5174 14.3448 6.33701 13.9093 6.33701 13.4552V13.4075C6.33375 13.3089 6.3014 13.2135 6.24397 13.1332C6.18561 13.0516 6.10404 12.9894 6.00988 12.9548C5.99999 12.9511 5.99022 12.9472 5.98059 12.9429C5.88919 12.9026 5.7878 12.8906 5.6895 12.9084C5.59195 12.9261 5.50188 12.9724 5.43072 13.0413L5.39683 13.0752C5.23781 13.2344 5.04899 13.3607 4.84114 13.4469C4.63329 13.533 4.4105 13.5774 4.1855 13.5774C3.9605 13.5774 3.73771 13.533 3.52986 13.4469C3.32201 13.3607 3.13318 13.2344 2.97417 13.0752C2.81517 12.9163 2.68902 12.7276 2.60293 12.5199C2.51677 12.3121 2.47242 12.0893 2.47242 11.8643C2.47242 11.6393 2.51677 11.4165 2.60293 11.2086C2.6891 11.0008 2.81538 10.812 2.97457 10.653L3.00845 10.6191C3.07743 10.5479 3.12371 10.4578 3.1414 10.3603C3.15923 10.262 3.14719 10.1606 3.10686 10.0692L3.10469 10.0643C3.06628 9.97467 3.00252 9.89822 2.92122 9.84438C2.84014 9.79068 2.74517 9.7618 2.64794 9.76126H2.54611C2.09202 9.76126 1.65654 9.58087 1.33545 9.25979C1.01437 8.9387 0.833984 8.50322 0.833984 8.04914C0.833984 7.59505 1.01437 7.15957 1.33545 6.83848C1.65654 6.5174 2.09202 6.33701 2.54611 6.33701H2.5938C2.69239 6.33375 2.78785 6.3014 2.86814 6.24397C2.94974 6.18561 3.0119 6.10404 3.04653 6.00988C3.05017 5.99999 3.05412 5.99022 3.05837 5.98059C3.09871 5.88919 3.11074 5.7878 3.09292 5.6895C3.07523 5.59195 3.02894 5.50187 2.95997 5.43071L2.92608 5.39683C2.92602 5.39676 2.92615 5.39689 2.92608 5.39683C2.76699 5.23786 2.64058 5.0489 2.55445 4.84114C2.46829 4.63329 2.42394 4.4105 2.42394 4.1855C2.42394 3.9605 2.46829 3.73771 2.55445 3.52986C2.64058 3.3221 2.76679 3.13334 2.92589 2.97437C3.08485 2.81528 3.27361 2.68906 3.48137 2.60293C3.68922 2.51677 3.91202 2.47242 4.13701 2.47242C4.36201 2.47242 4.58481 2.51677 4.79265 2.60293C5.00042 2.68906 5.18918 2.81528 5.34814 2.97437C5.34808 2.9743 5.34821 2.97444 5.34814 2.97437L5.38223 3.00845C5.45339 3.07743 5.54346 3.12372 5.64101 3.1414C5.73932 3.15923 5.8407 3.14719 5.9321 3.10686C5.96985 3.0902 6.00942 3.07832 6.04988 3.07141C6.11181 3.03344 6.16498 2.98227 6.20541 2.92122C6.25909 2.84016 6.28798 2.74521 6.28853 2.648V2.54611C6.28853 2.09202 6.46891 1.65654 6.79 1.33545ZM8.00065 6.50065C7.17222 6.50065 6.50065 7.17222 6.50065 8.00065C6.50065 8.82908 7.17222 9.50065 8.00065 9.50065C8.82908 9.50065 9.50065 8.82908 9.50065 8.00065C9.50065 7.17222 8.82908 6.50065 8.00065 6.50065ZM5.50065 8.00065C5.50065 6.61994 6.61994 5.50065 8.00065 5.50065C9.38136 5.50065 10.5007 6.61994 10.5007 8.00065C10.5007 9.38136 9.38136 10.5007 8.00065 10.5007C6.61994 10.5007 5.50065 9.38136 5.50065 8.00065Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1879_9564">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const SupportIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_125_9749)">
        <g clipPath="url(#clip1_125_9749)">
          <path
            d="M8 1.33333C6.58551 1.33333 5.22896 1.89523 4.22876 2.89543C3.22857 3.89562 2.66667 5.25217 2.66667 6.66666V7.93333C2.46556 8.10856 2.3026 8.32325 2.18792 8.56408C2.07324 8.80492 2.00928 9.06675 2 9.33333C2.01518 9.71989 2.14679 10.0929 2.37758 10.4033C2.60836 10.7138 2.92755 10.9474 3.29333 11.0733C4.16 13.1467 5.9 14.6667 8 14.6667H10V13.3333H8C6.49333 13.3333 5.12667 12.2 4.44 10.4067L4.3 10.04L3.90667 9.99999C3.74648 9.97735 3.6 9.89724 3.49451 9.77458C3.38903 9.65192 3.33174 9.4951 3.33333 9.33333C3.33404 9.21699 3.36517 9.10285 3.42365 9.00227C3.48213 8.90169 3.56591 8.81816 3.66667 8.75999L4 8.56666V7.33333C4 7.15652 4.07024 6.98695 4.19526 6.86192C4.32029 6.7369 4.48986 6.66666 4.66667 6.66666H11.3333C11.5101 6.66666 11.6797 6.7369 11.8047 6.86192C11.9298 6.98695 12 7.15652 12 7.33333V10.6667H9.27333C9.21281 10.4969 9.10756 10.3467 8.96871 10.2319C8.82985 10.1171 8.66255 10.0419 8.48449 10.0143C8.30643 9.98675 8.12423 10.0078 7.95714 10.0752C7.79005 10.1427 7.6443 10.254 7.53527 10.3975C7.42624 10.5409 7.358 10.7112 7.33776 10.8902C7.31752 11.0693 7.34603 11.2504 7.42028 11.4146C7.49452 11.5788 7.61175 11.7199 7.75956 11.8229C7.90737 11.9259 8.08028 11.9871 8.26 12H13.3333C13.687 12 14.0261 11.8595 14.2761 11.6095C14.5262 11.3594 14.6667 11.0203 14.6667 10.6667V9.33333C14.6667 8.97971 14.5262 8.64057 14.2761 8.39052C14.0261 8.14047 13.687 7.99999 13.3333 7.99999V6.66666C13.3333 5.25217 12.7714 3.89562 11.7712 2.89543C10.771 1.89523 9.41449 1.33333 8 1.33333Z"
            fill="currentColor"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_125_9749">
          <rect width="16" height="16" fill="transparent" />
        </clipPath>
        <clipPath id="clip1_125_9749">
          <rect width="16" height="16" fill="transparent" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const UserIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99999 2.66675C6.71133 2.66675 5.66666 3.71142 5.66666 5.00009C5.66666 6.28875 6.71133 7.33342 7.99999 7.33342C9.28866 7.33342 10.3333 6.28875 10.3333 5.00009C10.3333 3.71142 9.28866 2.66675 7.99999 2.66675ZM4.33333 5.00009C4.33333 2.97504 5.97495 1.33342 7.99999 1.33342C10.025 1.33342 11.6667 2.97504 11.6667 5.00009C11.6667 7.02513 10.025 8.66675 7.99999 8.66675C5.97495 8.66675 4.33333 7.02513 4.33333 5.00009ZM6.21751 9.66672C6.25555 9.66674 6.29415 9.66675 6.33333 9.66675H9.66666C9.70584 9.66675 9.74444 9.66674 9.78248 9.66672C10.6007 9.66642 11.1593 9.66621 11.6343 9.81028C12.6996 10.1335 13.5333 10.9671 13.8565 12.0325C14.0005 12.5074 14.0003 13.0661 14 13.8843C14 13.9223 14 13.9609 14 14.0001C14 14.3683 13.7015 14.6668 13.3333 14.6668C12.9651 14.6668 12.6667 14.3683 12.6667 14.0001C12.6667 13.0212 12.6594 12.6796 12.5805 12.4195C12.3866 11.7803 11.8864 11.2801 11.2472 11.0862C10.9872 11.0073 10.6455 11.0001 9.66666 11.0001H6.33333C5.35445 11.0001 5.0128 11.0073 4.75276 11.0862C4.11356 11.2801 3.61335 11.7803 3.41945 12.4195C3.34056 12.6796 3.33333 13.0212 3.33333 14.0001C3.33333 14.3683 3.03485 14.6668 2.66666 14.6668C2.29847 14.6668 1.99999 14.3683 1.99999 14.0001C1.99999 13.9609 1.99998 13.9223 1.99997 13.8843C1.99966 13.0661 1.99946 12.5074 2.14353 12.0325C2.46669 10.9671 3.30037 10.1334 4.36571 9.81028C4.84065 9.66621 5.39932 9.66642 6.21751 9.66672Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const UsersIcon = (props) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.75 2C3.92157 2 3.25 2.67157 3.25 3.5C3.25 4.32843 3.92157 5 4.75 5C5.57843 5 6.25 4.32843 6.25 3.5C6.25 2.67157 5.57843 2 4.75 2ZM2.25 3.5C2.25 2.11929 3.36929 1 4.75 1C6.13071 1 7.25 2.11929 7.25 3.5C7.25 4.88071 6.13071 6 4.75 6C3.36929 6 2.25 4.88071 2.25 3.5ZM7.28653 1.45777C7.39014 1.20181 7.68164 1.0783 7.93761 1.18191C8.85288 1.5524 9.5 2.45003 9.5 3.5C9.5 4.54997 8.85288 5.4476 7.93761 5.81809C7.68164 5.9217 7.39014 5.79819 7.28653 5.54223C7.18292 5.28626 7.30643 4.99476 7.56239 4.89115C8.11303 4.66826 8.5 4.12872 8.5 3.5C8.5 2.87128 8.11303 2.33174 7.56239 2.10885C7.30643 2.00524 7.18292 1.71374 7.28653 1.45777ZM3.98224 7H5.51776C5.96864 7 6.33234 6.99999 6.62835 7.02019C6.93272 7.04096 7.20186 7.08474 7.45671 7.1903C8.06928 7.44404 8.55596 7.93072 8.8097 8.54329C8.91526 8.79814 8.95904 9.06728 8.97981 9.37165C9.00001 9.66766 9 10.0314 9 10.4822V10.5C9 10.7761 8.77614 11 8.5 11C8.22386 11 8 10.7761 8 10.5C8 10.0272 7.99973 9.69767 7.98213 9.43972C7.96484 9.18627 7.9325 9.03867 7.88582 8.92597C7.73358 8.55843 7.44157 8.26642 7.07403 8.11418C6.96133 8.0675 6.81373 8.03516 6.56028 8.01787C6.30233 8.00027 5.97278 8 5.5 8H4C3.52722 8 3.19767 8.00027 2.93972 8.01787C2.68627 8.03516 2.53867 8.0675 2.42598 8.11418C2.05843 8.26642 1.76642 8.55843 1.61418 8.92597C1.5675 9.03867 1.53516 9.18627 1.51787 9.43972C1.50027 9.69767 1.5 10.0272 1.5 10.5C1.5 10.7761 1.27614 11 1 11C0.723858 11 0.5 10.7761 0.5 10.5L0.5 10.4822C0.499997 10.0314 0.499994 9.66766 0.52019 9.37165C0.540957 9.06728 0.584739 8.79814 0.690301 8.54329C0.944036 7.93072 1.43072 7.44404 2.04329 7.1903C2.29814 7.08474 2.56728 7.04096 2.87165 7.02019C3.16766 6.99999 3.53136 7 3.98224 7ZM9.01578 7.43838C9.08461 7.17095 9.3572 7.00996 9.62463 7.07879C10.7028 7.35629 11.5 8.33441 11.5 9.5V10.5C11.5 10.7761 11.2761 11 11 11C10.7239 11 10.5 10.7761 10.5 10.5V9.5C10.5 8.80175 10.0224 8.21377 9.37537 8.04723C9.10794 7.9784 8.94695 7.70581 9.01578 7.43838Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const MenuIcon = (props) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 3C1 2.72386 1.22386 2.5 1.5 2.5H10.5C10.7761 2.5 11 2.72386 11 3C11 3.27614 10.7761 3.5 10.5 3.5H1.5C1.22386 3.5 1 3.27614 1 3ZM1 6C1 5.72386 1.22386 5.5 1.5 5.5H10.5C10.7761 5.5 11 5.72386 11 6C11 6.27614 10.7761 6.5 10.5 6.5H1.5C1.22386 6.5 1 6.27614 1 6ZM1 9C1 8.72386 1.22386 8.5 1.5 8.5H10.5C10.7761 8.5 11 8.72386 11 9C11 9.27614 10.7761 9.5 10.5 9.5H1.5C1.22386 9.5 1 9.27614 1 9Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const AdvanceSearchIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3 4H21V6H3V4Z" fill="currentColor" />
      <path d="M6 10H18V12H6V10Z" fill="currentColor" />
      <path d="M9 16H15V18H9V16Z" fill="currentColor" />
      <circle cx="17" cy="17" r="3" stroke="currentColor" strokeWidth="2" />
      <line
        x1="19.5"
        y1="19.5"
        x2="22"
        y2="22"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
};

export const PartnersOnboard = (props) => {
  return (
    <svg
      width="66"
      height="61"
      viewBox="0 0 66 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.21"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.517578 30.1208V37.1208C0.517578 49.8234 10.815 60.1208 23.5176 60.1208H33.1453H42.7731C55.4756 60.1208 65.7731 49.8234 65.7731 37.1208V30.1208V23.1208C65.7731 10.4183 55.4756 0.12085 42.7731 0.12085H33.1453H23.5176C10.815 0.12085 0.517578 10.4183 0.517578 23.1208V30.1208Z"
        fill="currentColor"
      />
      <path
        opacity="0.587821"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.9941 23.4542C22.9941 26.3997 25.5911 28.7875 28.7946 28.7875C31.9981 28.7875 34.5951 26.3997 34.5951 23.4542C34.5951 20.5087 31.9981 18.1208 28.7946 18.1208C25.5911 18.1208 22.9941 20.5087 22.9941 23.4542ZM37.4957 28.7878C37.4957 30.997 39.4434 32.7878 41.846 32.7878C44.2487 32.7878 46.1964 30.997 46.1964 28.7878C46.1964 26.5787 44.2487 24.7878 41.846 24.7878C39.4434 24.7878 37.4957 26.5787 37.4957 28.7878Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.7711 31.4539C21.9244 31.4539 16.3072 34.6892 15.7451 41.0528C15.7145 41.3994 16.4354 42.1205 16.7991 42.1205H40.754C41.8433 42.1205 41.8602 41.3145 41.8433 41.0539C41.4184 34.5114 35.7141 31.4539 28.7711 31.4539ZM49.7583 42.121H44.167C44.1669 39.1197 43.0883 36.3501 41.2682 34.1218C46.208 34.1715 50.2415 36.4679 50.545 41.321C50.5572 41.5165 50.545 42.121 49.7583 42.121Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const PartnersProducts = (props) => {
  return (
    <svg
      width="66"
      height="61"
      viewBox="0 0 66 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.21"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.466797 30.1208V37.1208C0.466797 49.8234 10.7642 60.1208 23.4668 60.1208H33.0945H42.7223C55.4248 60.1208 65.7223 49.8234 65.7223 37.1208V30.1208V23.1208C65.7223 10.4183 55.4248 0.12085 42.7223 0.12085H33.0945H23.4668C10.7642 0.12085 0.466797 10.4183 0.466797 23.1208V30.1208Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7812 24.437L30.8117 31.8851C30.9628 31.9653 31.1212 32.0233 31.2825 32.06V46.5053L17.7819 39.1591C17.1617 38.8216 16.7812 38.2081 16.7812 37.5455V24.437ZM49.409 24.239V37.5455C49.409 38.2081 49.0285 38.8216 48.4083 39.1591L34.9077 46.5053V31.9335C34.9406 31.9184 34.9732 31.9022 35.0055 31.8851L49.409 24.239Z"
        fill="currentColor"
      />
      <path
        opacity="0.499209"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.2227 20.8223C17.394 20.6233 17.6103 20.4551 17.8625 20.3316L32.1372 13.3409C32.7364 13.0475 33.4552 13.0475 34.0545 13.3409L48.3291 20.3316C48.5235 20.4268 48.6966 20.5486 48.8442 20.6905L33.1936 28.9987C33.0907 29.0533 32.9958 29.1158 32.9093 29.1849C32.8228 29.1158 32.728 29.0533 32.6251 28.9987L17.2227 20.8223Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const PartnersOrderTotal = (props) => {
  return (
    <svg
      width="66"
      height="61"
      viewBox="0 0 66 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.21"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.417969 30.1208V37.1208C0.417969 49.8234 10.7154 60.1208 23.418 60.1208H33.0457H42.6735C55.376 60.1208 65.6734 49.8234 65.6734 37.1208V30.1208V23.1208C65.6734 10.4183 55.376 0.12085 42.6735 0.12085H33.0457H23.418C10.7154 0.12085 0.417969 10.4183 0.417969 23.1208V30.1208Z"
        fill="currentColor"
      />
      <path
        d="M21.2039 41.0097H46.5811C47.5154 41.0097 48.2729 41.7062 48.2729 42.5653C48.2729 43.4244 47.5154 44.1208 46.5811 44.1208H19.5121C18.5778 44.1208 17.8203 43.4244 17.8203 42.5653V17.6764C17.8203 16.8173 18.5778 16.1208 19.5121 16.1208C20.4465 16.1208 21.2039 16.8173 21.2039 17.6764V41.0097Z"
        fill="currentColor"
      />
      <path
        opacity="0.5"
        d="M27.5139 34.2958C26.8749 34.9226 25.8043 34.9543 25.1226 34.3668C24.441 33.7792 24.4064 32.7948 25.0455 32.168L31.3898 25.9458C32.0078 25.3396 33.0348 25.2871 33.7222 25.8264L38.7295 29.7552L45.2535 22.1569C45.8325 21.4826 46.8964 21.3675 47.6297 21.8999C48.3631 22.4322 48.4883 23.4104 47.9093 24.0847L40.2961 32.9514C39.7015 33.6439 38.6001 33.7435 37.8701 33.1708L32.754 29.1566L27.5139 34.2958Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const OverallCommission = (props) => {
  return (
    <svg
      width="61"
      height="64"
      viewBox="0 0 61 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.21"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.488281 31.9529V38.9529C0.488281 51.6554 10.7857 61.9529 23.4883 61.9529H30.4883H37.4883C50.1908 61.9529 60.4883 51.6554 60.4883 38.9529V31.9529V24.9529C60.4883 12.2503 50.1908 1.95288 37.4883 1.95288H30.4883H23.4883C10.7857 1.95288 0.488281 12.2503 0.488281 24.9529V31.9529Z"
        fill="currentColor"
      />
      <path
        d="M38.6828 38.8703C38.6828 40.2143 38.3468 41.5023 37.6748 42.7343C37.0028 43.9383 36.0088 44.9463 34.6928 45.7583C33.4048 46.5703 31.8508 47.0323 30.0308 47.1443V50.5463H27.7628V47.1443C25.2148 46.9203 23.1428 46.1083 21.5468 44.7083C19.9508 43.2803 19.1388 41.4743 19.1108 39.2903H23.1848C23.2968 40.4663 23.7308 41.4883 24.4868 42.3563C25.2708 43.2243 26.3628 43.7703 27.7628 43.9943V33.4943C25.8868 33.0183 24.3748 32.5283 23.2268 32.0243C22.0788 31.5203 21.0988 30.7363 20.2868 29.6723C19.4748 28.6083 19.0688 27.1803 19.0688 25.3883C19.0688 23.1203 19.8528 21.2443 21.4208 19.7603C23.0168 18.2763 25.1308 17.4503 27.7628 17.2823V13.7963H30.0308V17.2823C32.4108 17.4783 34.3288 18.2483 35.7848 19.5923C37.2408 20.9083 38.0808 22.6303 38.3048 24.7583H34.2308C34.0908 23.7783 33.6568 22.8963 32.9288 22.1123C32.2008 21.3003 31.2348 20.7683 30.0308 20.5163V30.7643C31.8788 31.2403 33.3768 31.7303 34.5248 32.2343C35.7008 32.7103 36.6808 33.4803 37.4648 34.5443C38.2768 35.6083 38.6828 37.0503 38.6828 38.8703ZM22.9748 25.1783C22.9748 26.5503 23.3808 27.6003 24.1928 28.3283C25.0048 29.0563 26.1948 29.6583 27.7628 30.1343V20.4323C26.3068 20.5723 25.1448 21.0483 24.2768 21.8603C23.4088 22.6443 22.9748 23.7503 22.9748 25.1783ZM30.0308 44.0363C31.5428 43.8683 32.7188 43.3223 33.5588 42.3983C34.4268 41.4743 34.8608 40.3683 34.8608 39.0803C34.8608 37.7083 34.4408 36.6583 33.6008 35.9303C32.7608 35.1743 31.5708 34.5723 30.0308 34.1243V44.0363Z"
        fill="#4AD991"
      />
    </svg>
  );
};

export const ListView = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" role="presentation">
      <g fill="currentColor" fillRule="evenodd">
        <rect width="8" height="2" x="10" y="15" rx="1"></rect>
        <rect width="2" height="2" x="6" y="15" rx="1"></rect>
        <rect width="8" height="2" x="10" y="11" rx="1"></rect>
        <rect width="2" height="2" x="6" y="11" rx="1"></rect>
        <rect width="8" height="2" x="10" y="7" rx="1"></rect>
        <rect width="2" height="2" x="6" y="7" rx="1"></rect>
      </g>
    </svg>
  );
};

export const DetailView = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" role="presentation">
      <path
        fill="currentColor"
        d="M14 17h6V7.01C20 7 14 7 14 7zM12 5h8c1.11 0 2 .9 2 2.01V17a2 2 0 0 1-2 2h-8zM2 7h8V5H3a1 1 0 0 0-1 1zm0 4h8V9H2zm0 7c0 .55.45 1 1 1h7v-2H2zm0-3h8v-2H2z"
      ></path>
    </svg>
  );
};

export const MyTasks = (props) => {
  return (
    // <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    //     <g clipPath="url(#clip0_147_9763)">
    //         <path d="M12.6667 5.33334C13.7713 5.33334 14.6667 4.4379 14.6667 3.33334C14.6667 2.22877 13.7713 1.33334 12.6667 1.33334C11.5621 1.33334 10.6667 2.22877 10.6667 3.33334C10.6667 4.4379 11.5621 5.33334 12.6667 5.33334Z" stroke="currentColor" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
    //         <path d="M9.34666 1.46667C8.90666 1.38 8.45999 1.33334 7.99999 1.33334C4.31999 1.33334 1.33333 4.32 1.33333 8C1.33333 11.68 4.31999 14.6667 7.99999 14.6667C11.68 14.6667 14.6667 11.68 14.6667 8C14.6667 7.54667 14.62 7.1 14.5333 6.67334" stroke="currentColor" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
    //     </g>
    //     <defs>
    //         <clipPath id="clip0_147_9763">
    //             <rect width="16" height="16" fill="white" />
    //         </clipPath>
    //     </defs>
    // </svg>
    <svg
      width="20"
      height="20"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.48499 9.75H4.32749C4.89749 9.75 5.41499 10.0725 5.66999 10.5825L6.33749 11.925C6.74999 12.75 7.49998 12.75 7.68 12.75H10.3275C10.8975 12.75 11.415 12.4275 11.67 11.9175L12.3375 10.575C12.5925 10.065 13.11 9.7425 13.68 9.7425H16.485"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 6C15.4927 6 16.5 4.99264 16.5 3.75C16.5 2.50736 15.4927 1.5 14.25 1.5C13.0073 1.5 12 2.50736 12 3.75C12 4.99264 13.0073 6 14.25 6Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 1.5H6.75C3 1.5 1.5 3 1.5 6.75V11.25C1.5 15 3 16.5 6.75 16.5H11.25C15 16.5 16.5 15 16.5 11.25V7.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MyProfile = (props) => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.595 10.1175C9.53958 10.1096 9.46833 10.1096 9.405 10.1175C8.01166 10.07 6.90331 8.93 6.90331 7.52873C6.90331 6.09582 8.05916 4.93207 9.5 4.93207C10.9329 4.93207 12.0967 6.09582 12.0967 7.52873C12.0887 8.93 10.9883 10.07 9.595 10.1175Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.8358 15.3426C13.4267 16.633 11.5583 17.4167 9.49999 17.4167C7.44167 17.4167 5.57334 16.633 4.16417 15.3426C4.24334 14.5984 4.71834 13.8701 5.56542 13.3001C7.73459 11.8592 11.2812 11.8592 13.4346 13.3001C14.2817 13.8701 14.7567 14.5984 14.8358 15.3426Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.49999 17.4167C13.8722 17.4167 17.4167 13.8722 17.4167 9.5C17.4167 5.12775 13.8722 1.58334 9.49999 1.58334C5.12774 1.58334 1.58333 5.12775 1.58333 9.5C1.58333 13.8722 5.12774 17.4167 9.49999 17.4167Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ExportIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3333 11.3333H11.34M10.4 9.33333H12C12.6213 9.33333 12.9319 9.33333 13.1769 9.4348C13.5036 9.57013 13.7632 9.82973 13.8985 10.1564C14 10.4015 14 10.7121 14 11.3333C14 11.9546 14 12.2652 13.8985 12.5103C13.7632 12.8369 13.5036 13.0965 13.1769 13.2319C12.9319 13.3333 12.6213 13.3333 12 13.3333H4C3.37875 13.3333 3.06812 13.3333 2.82309 13.2319C2.49639 13.0965 2.23682 12.8369 2.10149 12.5103C2 12.2652 2 11.9546 2 11.3333C2 10.7121 2 10.4015 2.10149 10.1564C2.23682 9.82973 2.49639 9.57013 2.82309 9.4348C3.06812 9.33333 3.37875 9.33333 4 9.33333H5.6M8 10V2.66667M8 2.66667L10 4.66667M8 2.66667L6 4.66667"
        stroke="currentColor"
        stroke-width="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WhiteChatIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_153_9770)">
        <path
          d="M14.6667 6.66667V8.66667C14.6667 11.3333 13.3333 12.6667 10.6667 12.6667H10.3333C10.1267 12.6667 9.92666 12.7667 9.79999 12.9333L8.79999 14.2667C8.35999 14.8533 7.63999 14.8533 7.19999 14.2667L6.19999 12.9333C6.09333 12.7867 5.84666 12.6667 5.66666 12.6667H5.33333C2.66666 12.6667 1.33333 12 1.33333 8.66667V5.33334C1.33333 2.66667 2.66666 1.33334 5.33333 1.33334H9.33333"
          stroke="#ffffff"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13 4.66667C13.9205 4.66667 14.6667 3.92048 14.6667 3C14.6667 2.07953 13.9205 1.33334 13 1.33334C12.0795 1.33334 11.3333 2.07953 11.3333 3C11.3333 3.92048 12.0795 4.66667 13 4.66667Z"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.6643 7.33334H10.6703"
          stroke="#ffffff"
          stroke-width="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.99699 7.33334H8.00299"
          stroke="#ffffff"
          stroke-width="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.32967 7.33334H5.33565"
          stroke="#ffffff"
          stroke-width="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_153_9770">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const OpenItemIcon = (props) => {
  return (
    <svg
      width="10"
      height="18"
      viewBox="0 0 10 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 16.5858C0 17.4767 1.07714 17.9229 1.70711 17.2929L9.29289 9.70711C9.68342 9.31658 9.68342 8.68342 9.29289 8.29289L1.70711 0.707106C1.07714 0.0771408 0 0.523309 0 1.41421V16.5858Z"
        fill="#c4c4c4"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="5"
          y1="-1"
          x2="5"
          y2="19"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#979797" />
          <stop offset="1" stopColor="#979797" stopOpacity="0.78" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const EndItemIcon = (props) => {
  return (
    <svg
      width="10"
      height="10"
      style={{ position: "relative", top: "-2px" }}
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0Z"
        fill="#C4C4C4"
      />
    </svg>
  );
};

export const AddItemIcon = (props) => {
  return (
    <svg
      title={props.title}
      onClick={props.onClick}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="18" height="18" rx="5" fill="white" />
      <rect width="18" height="18" rx="5" fill="#c4c4c4" />
      <path
        d="M14.25 9.75H9.75V14.25H8.25V9.75H3.75V8.25H8.25V3.75H9.75V8.25H14.25V9.75Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint1_linear"
          x1="9"
          y1="0"
          x2="9"
          y2="18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C4C4C4" />
          <stop offset="1" stopColor="#C4C4C4" stopOpacity="0.58" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const ClipboardWithGear = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fillRule="evenodd"
      clipRule="evenodd"
      viewBox="0 0 419 511.67"
    >
      <path d="M93.01 39.4h46.12C141.84 17.18 159.77 0 181.52 0c21.61 0 39.45 16.95 42.33 38.94l46.77.46c2.61 0 4.7 2.1 4.7 4.71v51.84c0 2.61-2.09 4.7-4.7 4.7H93.05c-2.56 0-4.71-2.09-4.71-4.7V44.11a4.646 4.646 0 0 1 4.67-4.71zm221.96 264.22c57.47 0 104.03 46.58 104.03 104.02 0 57.47-46.59 104.03-104.03 104.03-57.47 0-104.02-46.59-104.02-104.03 0-57.47 46.58-104.02 104.02-104.02zm30.76 52c-1.35-.91-2.87-1.33-4.42-1.02-1.54.3-2.87 1.13-3.79 2.46l-5.23 7.38c-3.54-1.59-8.05-2.62-11.89-3.17l-1.64-9.65c-.31-1.62-1.13-2.86-2.36-3.79-1.33-.92-2.76-1.23-4.4-.92l-12.09 2.15c-1.54.31-2.78 1.03-3.79 2.36-.92 1.33-1.33 2.78-1.04 4.42l1.54 8.81c-3.72 1.56-7.4 3.82-10.55 6.35l-8.2-5.64c-1.33-.92-2.76-1.33-4.3-1.02-1.54.31-2.88 1.13-3.79 2.46l-6.98 9.95c-.91 1.33-1.33 2.86-1.02 4.39.3 1.65 1.12 2.88 2.46 3.79l7.37 5.24c-1.55 3.51-2.61 8.08-3.16 11.88l-9.64 1.64c-1.64.32-2.87 1.13-3.8 2.37-.92 1.33-1.22 2.75-.92 4.4l2.14 12.09c.32 1.55 1.04 2.77 2.37 3.8 1.33.93 2.77 1.34 4.41 1.02l8.82-1.54c1.63 3.86 3.84 7.33 6.34 10.67l-5.64 8.09c-.92 1.33-1.33 2.78-1.01 4.31.31 1.53 1.13 2.86 2.46 3.79l10.04 7.06c1.33.94 2.87 1.24 4.4.94 1.54-.31 2.87-1.03 3.91-2.36l5.21-7.49c3.6 1.58 8.01 2.59 11.9 3.18l1.65 9.64c.29 1.64 1.11 2.87 2.34 3.8 1.34.91 2.78 1.22 4.41.91l12.1-2.15c1.54-.31 2.76-1.03 3.79-2.36.92-1.33 1.33-2.76 1.02-4.4l-1.53-8.82c3.89-1.63 7.29-3.84 10.66-6.36l8.1 5.64c1.33.92 2.76 1.33 4.4 1.02 1.64-.3 2.87-1.11 3.8-2.46l7.06-10.04c.92-1.33 1.24-2.87.92-4.4-.29-1.55-1.01-2.87-2.34-3.9l-7.49-5.12c1.56-3.52 2.62-8.09 3.17-11.89l9.64-1.64c1.64-.31 2.87-1.13 3.8-2.36.92-1.33 1.23-2.76.92-4.4l-2.15-12.1c-.31-1.54-1.03-2.77-2.37-3.79-1.33-.93-2.77-1.34-4.41-1.03l-8.81 1.54c-1.7-3.83-3.72-7.28-6.35-10.55l5.64-8.21c.92-1.33 1.33-2.77 1.02-4.3-.31-1.54-1.13-2.87-2.46-3.8l-9.95-6.96-.29.09zm-30.74 26.18c14.27 0 25.84 11.57 25.84 25.84s-11.57 25.84-25.84 25.84-25.85-11.57-25.85-25.84 11.58-25.84 25.85-25.84zM41.73 59.28h23.93v24.37H41.73c-4.77 0-9.12 1.97-12.25 5.1-3.14 3.14-5.1 7.48-5.1 12.24v315.52c0 4.75 1.96 9.1 5.1 12.24 3.15 3.15 7.51 5.12 12.25 5.12h142.61c1.69 8.44 4.17 16.6 7.37 24.38H41.73c-11.45 0-21.9-4.71-29.47-12.28C4.72 438.43 0 427.98 0 416.51V100.99c0-11.48 4.7-21.91 12.25-29.46 7.55-7.55 17.99-12.25 29.48-12.25zm297.54 217.35V100.99c0-4.77-1.96-9.11-5.09-12.26a17.36 17.36 0 0 0-12.26-5.08H298V59.28h23.92c11.44 0 21.86 4.71 29.41 12.25 7.61 7.61 12.32 18.04 12.32 29.46V283.6c-7.79-3.07-15.95-5.42-24.38-6.97zm-206.74-8.06c-7.13 0-12.93-5.79-12.93-12.92s5.8-12.93 12.93-12.93h142.82c7.13 0 12.92 5.8 12.92 12.93s-5.79 12.92-12.92 12.92H132.53zM89.5 241.21c7.98 0 14.44 6.47 14.44 14.44 0 7.98-6.46 14.44-14.44 14.44-7.97 0-14.44-6.46-14.44-14.44 0-7.97 6.47-14.44 14.44-14.44zm0 78.62c7.98 0 14.44 6.47 14.44 14.44 0 7.98-6.46 14.44-14.44 14.44-7.97 0-14.44-6.46-14.44-14.44 0-7.97 6.47-14.44 14.44-14.44zm43.04 27.36c-7.13 0-12.93-5.79-12.93-12.92s5.8-12.93 12.93-12.93h80.96a133.913 133.913 0 0 0-17.26 25.85h-63.7zM89.5 162.61c7.98 0 14.44 6.46 14.44 14.43 0 7.98-6.46 14.44-14.44 14.44-7.97 0-14.44-6.46-14.44-14.44 0-7.97 6.47-14.43 14.44-14.43zm43.03 27.35c-7.13 0-12.93-5.79-12.93-12.92 0-7.14 5.8-12.93 12.93-12.93h142.82c7.13 0 12.92 5.79 12.92 12.93 0 7.13-5.79 12.92-12.92 12.92H132.53zm48.5-169.8c12.29 0 22.26 9.96 22.26 22.27 0 12.29-9.97 22.25-22.26 22.25-12.3 0-22.26-9.96-22.26-22.25 0-12.31 9.96-22.27 22.26-22.27z" />
    </svg>
  );
};

export const LeadIcon = (props) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_164_9764)">
        <path
          d="M10.7169 14V4.66667C10.7169 4.04669 10.7169 3.73669 10.6487 3.48236C10.4638 2.79218 9.92469 2.25308 9.23454 2.06815C8.98021 2 8.67021 2 8.05021 2C7.43021 2 7.12021 2 6.86587 2.06815C6.17574 2.25308 5.63661 2.79218 5.45167 3.48236C5.38354 3.73669 5.38354 4.04669 5.38354 4.66667V14M12.5835 14H3.51687C2.77014 14 2.39674 14 2.11154 13.8547C1.86067 13.7269 1.65667 13.5229 1.52887 13.272C1.38354 12.9868 1.38354 12.6134 1.38354 11.8667V6.8C1.38354 6.05326 1.38354 5.67989 1.52887 5.39468C1.65667 5.14379 1.86067 4.93982 2.11154 4.81199C2.39674 4.66667 2.77014 4.66667 3.51687 4.66667H12.5835C13.3303 4.66667 13.7036 4.66667 13.9889 4.81199C14.2397 4.93982 14.4437 5.14379 14.5715 5.39468C14.7169 5.67989 14.7169 6.05326 14.7169 6.8V11.8667C14.7169 12.6134 14.7169 12.9868 14.5715 13.272C14.4437 13.5229 14.2397 13.7269 13.9889 13.8547C13.7036 14 13.3303 14 12.5835 14Z"
          stroke="currentColor"
          stroke-width="1.17086"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_164_9764">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="matrix(-1 0 0 1 16.0502 0)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DashboardIcon = (props) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.88 6.84235C2.88 3.56153 3.58318 2.85835 6.864 2.85835H10.896C14.1768 2.85835 14.88 3.56153 14.88 6.84235V10.8744C14.88 14.1552 14.1768 14.8584 10.896 14.8584H6.864C3.58318 14.8584 2.88 14.1552 2.88 10.8744V6.84235Z"
        stroke="currentColor"
        stroke-width="1.09"
      />
      <path
        d="M14.88 6.85835H2.88"
        stroke="currentColor"
        stroke-width="1.09"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.88 14.8584V6.85835"
        stroke="currentColor"
        stroke-width="1.09"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
